// @ts-nocheck
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  CancelToken
} from 'axios';

export class AdminClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get global admin audit logs.
   * @param tenant Input your tenant Id to access this API
   * @param includeAllTenants (optional)
   * @param tenantId (optional)
   * @param userId (optional)
   * @param from (optional)
   * @param to (optional)
   * @param page (optional)
   * @param pageSize (optional)
   */
  getAuditLogs(
    tenant: string,
    includeAllTenants?: boolean | undefined,
    tenantId?: string | null | undefined,
    userId?: string | null | undefined,
    from?: string | null | undefined,
    to?: string | null | undefined,
    page?: number | undefined,
    pageSize?: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfAdminAuditLogDto> {
    let url_ = this.baseUrl + '/api/admin/audit-logs?';
    if (includeAllTenants === null)
      throw new Error("The parameter 'includeAllTenants' cannot be null.");
    else if (includeAllTenants !== undefined)
      url_ +=
        'IncludeAllTenants=' + encodeURIComponent('' + includeAllTenants) + '&';
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'TenantId=' + encodeURIComponent('' + tenantId) + '&';
    if (userId !== undefined && userId !== null)
      url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
    if (from !== undefined && from !== null)
      url_ += 'From=' + encodeURIComponent('' + from) + '&';
    if (to !== undefined && to !== null)
      url_ += 'To=' + encodeURIComponent('' + to) + '&';
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += 'Page=' + encodeURIComponent('' + page) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAuditLogs(_response);
      });
  }

  protected processGetAuditLogs(
    response: AxiosResponse
  ): Promise<PaginationResponseOfAdminAuditLogDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfAdminAuditLogDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfAdminAuditLogDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get landing page contact requests.
   * @param tenant Input your tenant Id to access this API
   * @param status (optional)
   * @param search (optional)
   * @param from (optional)
   * @param to (optional)
   * @param page (optional)
   * @param pageSize (optional)
   */
  getContactRequests(
    tenant: string,
    status?: string | null | undefined,
    search?: string | null | undefined,
    from?: string | null | undefined,
    to?: string | null | undefined,
    page?: number | undefined,
    pageSize?: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfAdminContactRequestDto> {
    let url_ = this.baseUrl + '/api/admin/contact-requests?';
    if (status !== undefined && status !== null)
      url_ += 'Status=' + encodeURIComponent('' + status) + '&';
    if (search !== undefined && search !== null)
      url_ += 'Search=' + encodeURIComponent('' + search) + '&';
    if (from !== undefined && from !== null)
      url_ += 'From=' + encodeURIComponent('' + from) + '&';
    if (to !== undefined && to !== null)
      url_ += 'To=' + encodeURIComponent('' + to) + '&';
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += 'Page=' + encodeURIComponent('' + page) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetContactRequests(_response);
      });
  }

  protected processGetContactRequests(
    response: AxiosResponse
  ): Promise<PaginationResponseOfAdminContactRequestDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 =
        PaginationResponseOfAdminContactRequestDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfAdminContactRequestDto>(
        result200
      );
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update landing page contact request status.
   * @param tenant Input your tenant Id to access this API
   */
  updateContactRequestStatus(
    tenant: string,
    id: string,
    request: UpdateContactRequestStatusRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminContactRequestDto> {
    let url_ = this.baseUrl + '/api/admin/contact-requests/{id}/status';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PATCH',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateContactRequestStatus(_response);
      });
  }

  protected processUpdateContactRequestStatus(
    response: AxiosResponse
  ): Promise<AdminContactRequestDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AdminContactRequestDto.fromJS(resultData200);
      return Promise.resolve<AdminContactRequestDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get users from the selected tenant as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   * @param search (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   */
  getUsers(
    tenant: string,
    tenantId?: string | null | undefined,
    search?: string | null | undefined,
    pageNumber?: number | undefined,
    pageSize?: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfAdminUserDto> {
    let url_ = this.baseUrl + '/api/admin/users?';
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'TenantId=' + encodeURIComponent('' + tenantId) + '&';
    if (search !== undefined && search !== null)
      url_ += 'Search=' + encodeURIComponent('' + search) + '&';
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUsers(_response);
      });
  }

  protected processGetUsers(
    response: AxiosResponse
  ): Promise<PaginationResponseOfAdminUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfAdminUserDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfAdminUserDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a user in the selected tenant as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  createUser(
    tenant: string,
    request: AdminCreateUserRequest,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminUserDto> {
    let url_ = this.baseUrl + '/api/admin/users?';
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateUser(_response);
      });
  }

  protected processCreateUser(response: AxiosResponse): Promise<AdminUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AdminUserDto.fromJS(resultData200);
      return Promise.resolve<AdminUserDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AdminUserDto>(null as any);
  }

  /**
   * Lookup users for admin role and audit filters.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   * @param search (optional)
   */
  lookupUsers(
    tenant: string,
    tenantId?: string | null | undefined,
    search?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminUserLookupDto[]> {
    let url_ = this.baseUrl + '/api/admin/users/lookup?';
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    if (search !== undefined && search !== null)
      url_ += 'search=' + encodeURIComponent('' + search) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processLookupUsers(_response);
      });
  }

  protected processLookupUsers(
    response: AxiosResponse
  ): Promise<AdminUserLookupDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(AdminUserLookupDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<AdminUserLookupDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AdminUserLookupDto[]>(null as any);
  }

  /**
   * Get a user profile from the selected tenant as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  getUser(
    tenant: string,
    userId: string | null,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminUserDto> {
    let url_ = this.baseUrl + '/api/admin/users/{userId}?';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUser(_response);
      });
  }

  protected processGetUser(response: AxiosResponse): Promise<AdminUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AdminUserDto.fromJS(resultData200);
      return Promise.resolve<AdminUserDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AdminUserDto>(null as any);
  }

  /**
   * Update a user in the selected tenant as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  updateUser(
    tenant: string,
    userId: string | null,
    request: AdminUpdateUserRequest,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminUserDto> {
    let url_ = this.baseUrl + '/api/admin/users/{userId}?';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateUser(_response);
      });
  }

  protected processUpdateUser(response: AxiosResponse): Promise<AdminUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AdminUserDto.fromJS(resultData200);
      return Promise.resolve<AdminUserDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AdminUserDto>(null as any);
  }

  /**
   * Update user flags in the selected tenant as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  updateUserFlags(
    tenant: string,
    userId: string | null,
    request: AdminUpdateUserFlagsRequest,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminUserDto> {
    let url_ = this.baseUrl + '/api/admin/users/{userId}/flags?';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PATCH',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateUserFlags(_response);
      });
  }

  protected processUpdateUserFlags(
    response: AxiosResponse
  ): Promise<AdminUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AdminUserDto.fromJS(resultData200);
      return Promise.resolve<AdminUserDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AdminUserDto>(null as any);
  }

  /**
   * Get user roles from the selected tenant as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  getUserRoles(
    tenant: string,
    userId: string | null,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminUserRoleDto[]> {
    let url_ = this.baseUrl + '/api/admin/users/{userId}/roles?';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUserRoles(_response);
      });
  }

  protected processGetUserRoles(
    response: AxiosResponse
  ): Promise<AdminUserRoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(AdminUserRoleDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<AdminUserRoleDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AdminUserRoleDto[]>(null as any);
  }

  /**
   * Overwrite user roles in the selected tenant as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  updateUserRolesPOST(
    tenant: string,
    userId: string | null,
    request: AdminUpdateUserRolesRequest,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminUserRoleDto[]> {
    let url_ = this.baseUrl + '/api/admin/users/{userId}/roles?';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateUserRolesPOST(_response);
      });
  }

  protected processUpdateUserRolesPOST(
    response: AxiosResponse
  ): Promise<AdminUserRoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(AdminUserRoleDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<AdminUserRoleDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AdminUserRoleDto[]>(null as any);
  }

  /**
   * Overwrite user roles in the selected tenant as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  updateUserRolesPUT(
    tenant: string,
    userId: string | null,
    request: AdminUpdateUserRolesRequest,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminUserRoleDto[]> {
    let url_ = this.baseUrl + '/api/admin/users/{userId}/roles?';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateUserRolesPUT(_response);
      });
  }

  protected processUpdateUserRolesPUT(
    response: AxiosResponse
  ): Promise<AdminUserRoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(AdminUserRoleDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<AdminUserRoleDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AdminUserRoleDto[]>(null as any);
  }

  /**
   * Get tenant roles with permissions as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  getRoles(
    tenant: string,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminRoleDto[]> {
    let url_ = this.baseUrl + '/api/admin/roles?';
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRoles(_response);
      });
  }

  protected processGetRoles(response: AxiosResponse): Promise<AdminRoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(AdminRoleDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<AdminRoleDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create or update a tenant role as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  upsertRole(
    tenant: string,
    request: AdminUpsertRoleRequest,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminRoleDto> {
    let url_ = this.baseUrl + '/api/admin/roles?';
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertRole(_response);
      });
  }

  protected processUpsertRole(response: AxiosResponse): Promise<AdminRoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AdminRoleDto.fromJS(resultData200);
      return Promise.resolve<AdminRoleDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AdminRoleDto>(null as any);
  }

  /**
   * Get tenant role with permissions as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  getRole(
    tenant: string,
    id: string | null,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminRoleDto> {
    let url_ = this.baseUrl + '/api/admin/roles/{id}?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRole(_response);
      });
  }

  protected processGetRole(response: AxiosResponse): Promise<AdminRoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AdminRoleDto.fromJS(resultData200);
      return Promise.resolve<AdminRoleDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AdminRoleDto>(null as any);
  }

  /**
   * Update a tenant role as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  updateRole(
    tenant: string,
    id: string | null,
    request: AdminUpsertRoleRequest,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminRoleDto> {
    let url_ = this.baseUrl + '/api/admin/roles/{id}?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateRole(_response);
      });
  }

  protected processUpdateRole(response: AxiosResponse): Promise<AdminRoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AdminRoleDto.fromJS(resultData200);
      return Promise.resolve<AdminRoleDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AdminRoleDto>(null as any);
  }

  /**
   * Delete tenant role as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  deleteRole(
    tenant: string,
    id: string | null,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/admin/roles/{id}?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteRole(_response);
      });
  }

  protected processDeleteRole(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Get tenant role permissions as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  getRolePermissions(
    tenant: string,
    id: string | null,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminRoleDto> {
    let url_ = this.baseUrl + '/api/admin/roles/{id}/permissions?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRolePermissions(_response);
      });
  }

  protected processGetRolePermissions(
    response: AxiosResponse
  ): Promise<AdminRoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AdminRoleDto.fromJS(resultData200);
      return Promise.resolve<AdminRoleDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AdminRoleDto>(null as any);
  }

  /**
   * Update tenant role permissions as root admin.
   * @param tenant Input your tenant Id to access this API
   * @param tenantId (optional)
   */
  updateRolePermissions(
    tenant: string,
    id: string | null,
    request: AdminUpdateRolePermissionsRequest,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<AdminRoleDto> {
    let url_ = this.baseUrl + '/api/admin/roles/{id}/permissions?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateRolePermissions(_response);
      });
  }

  protected processUpdateRolePermissions(
    response: AxiosResponse
  ): Promise<AdminRoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AdminRoleDto.fromJS(resultData200);
      return Promise.resolve<AdminRoleDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<AdminRoleDto>(null as any);
  }
}

export class ContactRequestsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Create a landing page contact request.
   */
  create(
    request: CreateContactRequestRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateContactRequestResponse> {
    let url_ = this.baseUrl + '/api/v1/contact-requests';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(
    response: AxiosResponse
  ): Promise<CreateContactRequestResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateContactRequestResponse.fromJS(resultData200);
      return Promise.resolve<CreateContactRequestResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreateContactRequestResponse>(null as any);
  }
}

export class RealtimeClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get realtime connection contract and quality thresholds.
   */
  getConnectionInfo(
    cancelToken?: CancelToken | undefined
  ): Promise<RealtimeConnectionInfoDto> {
    let url_ = this.baseUrl + '/api/v1/realtime/connection-info';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetConnectionInfo(_response);
      });
  }

  protected processGetConnectionInfo(
    response: AxiosResponse
  ): Promise<RealtimeConnectionInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RealtimeConnectionInfoDto.fromJS(resultData200);
      return Promise.resolve<RealtimeConnectionInfoDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class SearchClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Search across HSDesk data.
   * @param tenant Input your tenant Id to access this API
   * @param q (optional)
   * @param scope (optional)
   * @param tenantId (optional)
   */
  search(
    tenant: string,
    q?: string | null | undefined,
    scope?: string | null | undefined,
    tenantId?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<GlobalSearchResultDto[]> {
    let url_ = this.baseUrl + '/api/v1/search?';
    if (q !== undefined && q !== null)
      url_ += 'Q=' + encodeURIComponent('' + q) + '&';
    if (scope !== undefined && scope !== null)
      url_ += 'Scope=' + encodeURIComponent('' + scope) + '&';
    if (tenantId !== undefined && tenantId !== null)
      url_ += 'TenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(
    response: AxiosResponse
  ): Promise<GlobalSearchResultDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(GlobalSearchResultDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<GlobalSearchResultDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GlobalSearchResultDto[]>(null as any);
  }
}

export class AppRoutesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get current application routes.
   * @param host (optional)
   */
  getCurrent(
    host?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<CurrentAppRoutesDto> {
    let url_ = this.baseUrl + '/api/v1/app-routes/current?';
    if (host !== undefined && host !== null)
      url_ += 'host=' + encodeURIComponent('' + host) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCurrent(_response);
      });
  }

  protected processGetCurrent(
    response: AxiosResponse
  ): Promise<CurrentAppRoutesDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CurrentAppRoutesDto.fromJS(resultData200);
      return Promise.resolve<CurrentAppRoutesDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class TenantResolveClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Resolve tenant by host.
   * @param host (optional)
   */
  resolve(
    host?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<TenantResolveDto> {
    let url_ = this.baseUrl + '/api/v1/tenants/resolve?';
    if (host !== undefined && host !== null)
      url_ += 'host=' + encodeURIComponent('' + host) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processResolve(_response);
      });
  }

  protected processResolve(response: AxiosResponse): Promise<TenantResolveDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TenantResolveDto.fromJS(resultData200);
      return Promise.resolve<TenantResolveDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<TenantResolveDto>(null as any);
  }
}

export class TenantsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get a list of all tenants.
   */
  getList(cancelToken?: CancelToken | undefined): Promise<TenantDto[]> {
    let url_ = this.baseUrl + '/api/tenants';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetList(_response);
      });
  }

  protected processGetList(response: AxiosResponse): Promise<TenantDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(TenantDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<TenantDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a new tenant.
   */
  create(
    request: CreateTenantRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/tenants';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get tenant details.
   */
  get(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<TenantDto> {
    let url_ = this.baseUrl + '/api/tenants/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<TenantDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TenantDto.fromJS(resultData200);
      return Promise.resolve<TenantDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a tenant.
   */
  update(
    id: string | null,
    request: UpdateTenantRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/tenants/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Activate a tenant.
   */
  activate(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/tenants/{id}/activate';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processActivate(_response);
      });
  }

  protected processActivate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Deactivate a tenant.
   */
  deactivate(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/tenants/{id}/deactivate';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeactivate(_response);
      });
  }

  protected processDeactivate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Upgrade a tenant's subscription.
   */
  upgradeSubscription(
    id: string | null,
    request: UpgradeSubscriptionRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/tenants/{id}/upgrade';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpgradeSubscription(_response);
      });
  }

  protected processUpgradeSubscription(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class PermissionsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get the full system permission catalog.
   */
  getCatalog(
    cancelToken?: CancelToken | undefined
  ): Promise<PermissionCatalogItemDto[]> {
    let url_ = this.baseUrl + '/api/permissions/catalog';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCatalog(_response);
      });
  }

  protected processGetCatalog(
    response: AxiosResponse
  ): Promise<PermissionCatalogItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(PermissionCatalogItemDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<PermissionCatalogItemDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class RolesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get a list of all roles.
   */
  getList(cancelToken?: CancelToken | undefined): Promise<RoleDto[]> {
    let url_ = this.baseUrl + '/api/roles';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetList(_response);
      });
  }

  protected processGetList(response: AxiosResponse): Promise<RoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(RoleDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<RoleDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create or update a role.
   */
  registerRole(
    request: CreateOrUpdateRoleRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/roles';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRegisterRole(_response);
      });
  }

  protected processRegisterRole(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get role details.
   */
  getById(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<RoleDto> {
    let url_ = this.baseUrl + '/api/roles/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetById(_response);
      });
  }

  protected processGetById(response: AxiosResponse): Promise<RoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RoleDto.fromJS(resultData200);
      return Promise.resolve<RoleDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete a role.
   */
  delete(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/roles/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get role details with its permissions.
   */
  getByIdWithPermissions(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<RoleDto> {
    let url_ = this.baseUrl + '/api/roles/{id}/permissions';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetByIdWithPermissions(_response);
      });
  }

  protected processGetByIdWithPermissions(
    response: AxiosResponse
  ): Promise<RoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RoleDto.fromJS(resultData200);
      return Promise.resolve<RoleDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a role's permissions.
   */
  updatePermissions(
    id: string | null,
    request: UpdateRolePermissionsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/roles/{id}/permissions';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdatePermissions(_response);
      });
  }

  protected processUpdatePermissions(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class TokensClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Request an access token using credentials.
   * @param tenant Input your tenant Id to access this API
   */
  getToken(
    tenant: string,
    request: TokenRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<TokenResponse> {
    let url_ = this.baseUrl + '/api/tokens';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetToken(_response);
      });
  }

  protected processGetToken(response: AxiosResponse): Promise<TokenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TokenResponse.fromJS(resultData200);
      return Promise.resolve<TokenResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Request an access token using a refresh token.
   * @param tenant Input your tenant Id to access this API
   */
  refresh(
    tenant: string,
    request: RefreshTokenRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<TokenResponse> {
    let url_ = this.baseUrl + '/api/tokens/refresh';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRefresh(_response);
      });
  }

  protected processRefresh(response: AxiosResponse): Promise<TokenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TokenResponse.fromJS(resultData200);
      return Promise.resolve<TokenResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class UsersClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get list of all users.
   */
  getList(cancelToken?: CancelToken | undefined): Promise<UserDetailsDto[]> {
    let url_ = this.baseUrl + '/api/users';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetList(_response);
      });
  }

  protected processGetList(response: AxiosResponse): Promise<UserDetailsDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UserDetailsDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UserDetailsDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Creates a new user.
   */
  create(
    request: CreateUserRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get a user's details.
   */
  getById(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<UserDetailsDto> {
    let url_ = this.baseUrl + '/api/users/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetById(_response);
      });
  }

  protected processGetById(response: AxiosResponse): Promise<UserDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserDetailsDto.fromJS(resultData200);
      return Promise.resolve<UserDetailsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a user.
   */
  update(
    id: string | null,
    request: UpdateUserRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/users/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get a user's roles.
   */
  getRoles(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<UserRoleDto[]> {
    let url_ = this.baseUrl + '/api/users/{id}/roles';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRoles(_response);
      });
  }

  protected processGetRoles(response: AxiosResponse): Promise<UserRoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UserRoleDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UserRoleDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a user's assigned roles.
   */
  assignRoles(
    id: string | null,
    request: UserRolesRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users/{id}/roles';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAssignRoles(_response);
      });
  }

  protected processAssignRoles(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Anonymous user creates a user.
   * @param tenant Input your tenant Id to access this API
   */
  selfRegister(
    tenant: string,
    request: CreateUserRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users/self-register';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSelfRegister(_response);
      });
  }

  protected processSelfRegister(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Register a new company tenant and its first owner user.
   */
  registerCompany(
    request: RegisterCompanyRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PublicUserRegistrationResponse> {
    let url_ = this.baseUrl + '/api/users/register-company';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRegisterCompany(_response);
      });
  }

  protected processRegisterCompany(
    response: AxiosResponse
  ): Promise<PublicUserRegistrationResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PublicUserRegistrationResponse.fromJS(resultData200);
      return Promise.resolve<PublicUserRegistrationResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Accept a user invitation and create the invited user.
   */
  acceptInvitation(
    request: AcceptInvitationRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PublicUserRegistrationResponse> {
    let url_ = this.baseUrl + '/api/users/accept-invitation';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAcceptInvitation(_response);
      });
  }

  protected processAcceptInvitation(
    response: AxiosResponse
  ): Promise<PublicUserRegistrationResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PublicUserRegistrationResponse.fromJS(resultData200);
      return Promise.resolve<PublicUserRegistrationResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Toggle a user's active status.
   */
  toggleStatus(
    id: string | null,
    request: ToggleUserStatusRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/users/{id}/toggle-status';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processToggleStatus(_response);
      });
  }

  protected processToggleStatus(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Confirm email address for a user.
   * @param tenant (optional)
   * @param userId (optional)
   * @param code (optional)
   */
  confirmEmail(
    tenant?: string | null | undefined,
    userId?: string | null | undefined,
    code?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users/confirm-email?';
    if (tenant !== undefined && tenant !== null)
      url_ += 'tenant=' + encodeURIComponent('' + tenant) + '&';
    if (userId !== undefined && userId !== null)
      url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    if (code !== undefined && code !== null)
      url_ += 'code=' + encodeURIComponent('' + code) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processConfirmEmail(_response);
      });
  }

  protected processConfirmEmail(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Confirm phone number for a user.
   * @param userId (optional)
   * @param code (optional)
   */
  confirmPhoneNumber(
    userId?: string | null | undefined,
    code?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users/confirm-phone-number?';
    if (userId !== undefined && userId !== null)
      url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    if (code !== undefined && code !== null)
      url_ += 'code=' + encodeURIComponent('' + code) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processConfirmPhoneNumber(_response);
      });
  }

  protected processConfirmPhoneNumber(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Request a pasword reset email for a user.
   * @param tenant Input your tenant Id to access this API
   */
  forgotPassword(
    tenant: string,
    request: ForgotPasswordRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users/forgot-password';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processForgotPassword(_response);
      });
  }

  protected processForgotPassword(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Reset a user's password.
   */
  resetPassword(
    request: ResetPasswordRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users/reset-password';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processResetPassword(_response);
      });
  }

  protected processResetPassword(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class PersonalClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get profile details of currently logged in user.
   */
  getProfile(cancelToken?: CancelToken | undefined): Promise<UserDetailsDto> {
    let url_ = this.baseUrl + '/api/personal/profile';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProfile(_response);
      });
  }

  protected processGetProfile(
    response: AxiosResponse
  ): Promise<UserDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserDetailsDto.fromJS(resultData200);
      return Promise.resolve<UserDetailsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update profile details of currently logged in user.
   */
  updateProfile(
    request: UpdatePersonalProfileRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/personal/profile';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateProfile(_response);
      });
  }

  protected processUpdateProfile(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get profile settings of currently logged in user.
   */
  getProfileSettings(
    cancelToken?: CancelToken | undefined
  ): Promise<UserProfileSettingsDto> {
    let url_ = this.baseUrl + '/api/personal/profile-settings';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProfileSettings(_response);
      });
  }

  protected processGetProfileSettings(
    response: AxiosResponse
  ): Promise<UserProfileSettingsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserProfileSettingsDto.fromJS(resultData200);
      return Promise.resolve<UserProfileSettingsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update profile settings of currently logged in user.
   */
  updateProfileSettings(
    request: UpdateUserProfileSettingsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<UserProfileSettingsDto> {
    let url_ = this.baseUrl + '/api/personal/profile-settings';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateProfileSettings(_response);
      });
  }

  protected processUpdateProfileSettings(
    response: AxiosResponse
  ): Promise<UserProfileSettingsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserProfileSettingsDto.fromJS(resultData200);
      return Promise.resolve<UserProfileSettingsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get page layout config for currently logged in user with default fallback.
   * @param tenant Input your tenant Id to access this API
   */
  getPageLayoutConfig(
    tenant: string,
    scope: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<PageLayoutConfigDto> {
    let url_ = this.baseUrl + '/api/personal/page-layout-configs/{scope}';
    if (scope === undefined || scope === null)
      throw new Error("The parameter 'scope' must be defined.");
    url_ = url_.replace('{scope}', encodeURIComponent('' + scope));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPageLayoutConfig(_response);
      });
  }

  protected processGetPageLayoutConfig(
    response: AxiosResponse
  ): Promise<PageLayoutConfigDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PageLayoutConfigDto.fromJS(resultData200);
      return Promise.resolve<PageLayoutConfigDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create or update page layout config for currently logged in user.
   * @param tenant Input your tenant Id to access this API
   */
  upsertPageLayoutConfig(
    tenant: string,
    scope: string | null,
    request: UpsertPageLayoutConfigRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PageLayoutConfigDto> {
    let url_ = this.baseUrl + '/api/personal/page-layout-configs/{scope}';
    if (scope === undefined || scope === null)
      throw new Error("The parameter 'scope' must be defined.");
    url_ = url_.replace('{scope}', encodeURIComponent('' + scope));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertPageLayoutConfig(_response);
      });
  }

  protected processUpsertPageLayoutConfig(
    response: AxiosResponse
  ): Promise<PageLayoutConfigDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PageLayoutConfigDto.fromJS(resultData200);
      return Promise.resolve<PageLayoutConfigDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<PageLayoutConfigDto>(null as any);
  }

  /**
   * Delete page layout config for currently logged in user.
   * @param tenant Input your tenant Id to access this API
   */
  deletePageLayoutConfig(
    tenant: string,
    scope: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/personal/page-layout-configs/{scope}';
    if (scope === undefined || scope === null)
      throw new Error("The parameter 'scope' must be defined.");
    url_ = url_.replace('{scope}', encodeURIComponent('' + scope));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : ''
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeletePageLayoutConfig(_response);
      });
  }

  protected processDeletePageLayoutConfig(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Change password of currently logged in user.
   */
  changePassword(
    model: ChangePasswordRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/personal/change-password';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangePassword(_response);
      });
  }

  protected processChangePassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get permissions of currently logged in user.
   */
  getPermissions(cancelToken?: CancelToken | undefined): Promise<string[]> {
    let url_ = this.baseUrl + '/api/personal/permissions';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPermissions(_response);
      });
  }

  protected processGetPermissions(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(item);
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<string[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get audit logs of currently logged in user.
   */
  getLogs(cancelToken?: CancelToken | undefined): Promise<AuditDto[]> {
    let url_ = this.baseUrl + '/api/personal/logs';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLogs(_response);
      });
  }

  protected processGetLogs(response: AxiosResponse): Promise<AuditDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(AuditDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<AuditDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class DashboardClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get statistics for the dashboard.
   */
  get(cancelToken?: CancelToken | undefined): Promise<StatsDto> {
    let url_ = this.baseUrl + '/api/v1/dashboard';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<StatsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = StatsDto.fromJS(resultData200);
      return Promise.resolve<StatsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class AppNotificationsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Search application notifications.
   */
  search(
    request: SearchAppNotificationsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfAppNotificationDto> {
    let url_ = this.baseUrl + '/api/v1/app-notifications/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(
    response: AxiosResponse
  ): Promise<PaginationResponseOfAppNotificationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfAppNotificationDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfAppNotificationDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create an application notification.
   */
  create(
    request: CreateAppNotificationRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/app-notifications';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Mark an application notification as read.
   */
  markAsRead(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/app-notifications/{id}/read';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'PUT',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMarkAsRead(_response);
      });
  }

  protected processMarkAsRead(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Delete an application notification.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/app-notifications/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class BusinessStatisticsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get MVP business statistics.
   */
  get(cancelToken?: CancelToken | undefined): Promise<BusinessStatisticDto[]> {
    let url_ = this.baseUrl + '/api/v1/statistics';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(
    response: AxiosResponse
  ): Promise<BusinessStatisticDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(BusinessStatisticDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<BusinessStatisticDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class CalendarEventsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Search calendar events.
   */
  search(
    request: SearchCalendarEventsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<CalendarEventDto[]> {
    let url_ = this.baseUrl + '/api/v1/calendar/events/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(
    response: AxiosResponse
  ): Promise<CalendarEventDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(CalendarEventDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<CalendarEventDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a calendar event.
   */
  create(
    request: CreateCalendarEventRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<CalendarEventDto> {
    let url_ = this.baseUrl + '/api/v1/calendar/events';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<CalendarEventDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CalendarEventDto.fromJS(resultData200);
      return Promise.resolve<CalendarEventDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a calendar event.
   */
  update(
    request: UpdateCalendarEventRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<CalendarEventDto> {
    let url_ = this.baseUrl + '/api/v1/calendar/events/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<CalendarEventDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CalendarEventDto.fromJS(resultData200);
      return Promise.resolve<CalendarEventDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete a calendar event.
   * @param type (optional)
   */
  delete(
    id: string,
    type?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/calendar/events/{id}?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (type !== undefined && type !== null)
      url_ += 'type=' + encodeURIComponent('' + type) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class CompanyProfilesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get a public company profile.
   */
  get(
    publicSlug: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<CompanyProfileDto> {
    let url_ = this.baseUrl + '/api/v1/company-profile/{publicSlug}';
    if (publicSlug === undefined || publicSlug === null)
      throw new Error("The parameter 'publicSlug' must be defined.");
    url_ = url_.replace('{publicSlug}', encodeURIComponent('' + publicSlug));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<CompanyProfileDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CompanyProfileDto.fromJS(resultData200);
      return Promise.resolve<CompanyProfileDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create or update company profile used by the public business card.
   */
  upsert(
    request: UpsertCompanyProfileRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/company-profile';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsert(_response);
      });
  }

  protected processUpsert(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }
}

export class ContactMessagesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Search contact form messages.
   */
  search(
    request: SearchContactMessagesRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfContactMessageDto> {
    let url_ = this.baseUrl + '/api/v1/contact-messages/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(
    response: AxiosResponse
  ): Promise<PaginationResponseOfContactMessageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfContactMessageDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfContactMessageDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a contact form message.
   */
  create(
    request: CreateContactMessageRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/contact-messages';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Mark a contact message as read.
   */
  markAsRead(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/contact-messages/{id}/read';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'PUT',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMarkAsRead(_response);
      });
  }

  protected processMarkAsRead(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Delete a contact message.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/contact-messages/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class CustomersClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Search customers.
   * @param tenant Input your tenant Id to access this API
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param advancedSearch_Fields (optional)
   * @param advancedSearch_Keyword (optional)
   * @param keyword (optional) Keyword to Search in All the available columns of the Resource.
   */
  searchGet(
    tenant: string,
    pageNumber?: number | undefined,
    pageSize?: number | undefined,
    orderBy?: string[] | null | undefined,
    advancedSearch_Fields?: string[] | null | undefined,
    advancedSearch_Keyword?: string | null | undefined,
    keyword?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfCustomerDto> {
    let url_ = this.baseUrl + '/api/v1/customers/search?';
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy !== undefined && orderBy !== null)
      orderBy &&
        orderBy.forEach((item) => {
          url_ += 'OrderBy=' + encodeURIComponent('' + item) + '&';
        });
    if (advancedSearch_Fields !== undefined && advancedSearch_Fields !== null)
      advancedSearch_Fields &&
        advancedSearch_Fields.forEach((item) => {
          url_ +=
            'AdvancedSearch.Fields=' + encodeURIComponent('' + item) + '&';
        });
    if (advancedSearch_Keyword !== undefined && advancedSearch_Keyword !== null)
      url_ +=
        'AdvancedSearch.Keyword=' +
        encodeURIComponent('' + advancedSearch_Keyword) +
        '&';
    if (keyword !== undefined && keyword !== null)
      url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearchGet(_response);
      });
  }

  protected processSearchGet(
    response: AxiosResponse
  ): Promise<PaginationResponseOfCustomerDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfCustomerDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfCustomerDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Search customers.
   * @param tenant Input your tenant Id to access this API
   */
  search(
    tenant: string,
    request: SearchCustomersRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfCustomerDto> {
    let url_ = this.baseUrl + '/api/v1/customers/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(
    response: AxiosResponse
  ): Promise<PaginationResponseOfCustomerDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfCustomerDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfCustomerDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get customer details.
   */
  get(id: string, cancelToken?: CancelToken | undefined): Promise<CustomerDto> {
    let url_ = this.baseUrl + '/api/v1/customers/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<CustomerDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CustomerDto.fromJS(resultData200);
      return Promise.resolve<CustomerDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a customer.
   */
  update(
    request: UpdateCustomerRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/customers/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete a customer.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/customers/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a customer.
   * @param tenant Input your tenant Id to access this API
   */
  create(
    tenant: string,
    request: CreateCustomerRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/customers';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class DepartmentsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get departments.
   */
  get(cancelToken?: CancelToken | undefined): Promise<DepartmentDto[]> {
    let url_ = this.baseUrl + '/api/v1/departments';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<DepartmentDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(DepartmentDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<DepartmentDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a department.
   */
  create(
    request: CreateDepartmentRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/departments';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a department.
   */
  update(
    request: UpdateDepartmentRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/departments/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete a department.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/departments/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get department teams.
   */
  getTeams(
    departmentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<DepartmentTeamDto[]> {
    let url_ = this.baseUrl + '/api/v1/departments/{departmentId}/teams';
    if (departmentId === undefined || departmentId === null)
      throw new Error("The parameter 'departmentId' must be defined.");
    url_ = url_.replace(
      '{departmentId}',
      encodeURIComponent('' + departmentId)
    );
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTeams(_response);
      });
  }

  protected processGetTeams(
    response: AxiosResponse
  ): Promise<DepartmentTeamDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(DepartmentTeamDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<DepartmentTeamDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a department team.
   */
  createTeam(
    request: CreateDepartmentTeamRequest,
    departmentId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/departments/{departmentId}/teams';
    if (departmentId === undefined || departmentId === null)
      throw new Error("The parameter 'departmentId' must be defined.");
    url_ = url_.replace(
      '{departmentId}',
      encodeURIComponent('' + departmentId)
    );
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateTeam(_response);
      });
  }

  protected processCreateTeam(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }
}

export class DriveFilesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Search drive files.
   */
  search(
    request: SearchDriveFilesRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfDriveFileDto> {
    let url_ = this.baseUrl + '/api/v1/drive-files/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(
    response: AxiosResponse
  ): Promise<PaginationResponseOfDriveFileDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfDriveFileDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfDriveFileDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get drive file metadata.
   */
  get(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<DriveFileDto> {
    let url_ = this.baseUrl + '/api/v1/drive-files/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<DriveFileDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = DriveFileDto.fromJS(resultData200);
      return Promise.resolve<DriveFileDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete drive file metadata.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/drive-files/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create drive file metadata.
   */
  create(
    request: CreateDriveFileRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/drive-files';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class EmployeesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Search employees.
   */
  search(
    request: SearchEmployeesRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfEmployeeDto> {
    let url_ = this.baseUrl + '/api/v1/employees/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(
    response: AxiosResponse
  ): Promise<PaginationResponseOfEmployeeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfEmployeeDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfEmployeeDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get employee details.
   */
  get(id: string, cancelToken?: CancelToken | undefined): Promise<EmployeeDto> {
    let url_ = this.baseUrl + '/api/v1/employees/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<EmployeeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = EmployeeDto.fromJS(resultData200);
      return Promise.resolve<EmployeeDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update an employee.
   */
  update(
    request: UpdateEmployeeRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/employees/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete an employee.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/employees/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create an employee.
   */
  create(
    request: CreateEmployeeRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/employees';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class EntityFollowersClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get entity followers.
   * @param entityType (optional)
   * @param entityId (optional)
   */
  get(
    entityType?: string | null | undefined,
    entityId?: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<EntityFollowerDto[]> {
    let url_ = this.baseUrl + '/api/v1/entity-followers?';
    if (entityType !== undefined && entityType !== null)
      url_ += 'entityType=' + encodeURIComponent('' + entityType) + '&';
    if (entityId === null)
      throw new Error("The parameter 'entityId' cannot be null.");
    else if (entityId !== undefined)
      url_ += 'entityId=' + encodeURIComponent('' + entityId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<EntityFollowerDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(EntityFollowerDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<EntityFollowerDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Follow entity as current user.
   */
  follow(
    entityType: string | null,
    entityId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<EntityFollowerDto> {
    let url_ =
      this.baseUrl + '/api/v1/entity-followers/{entityType}/{entityId}/me';
    if (entityType === undefined || entityType === null)
      throw new Error("The parameter 'entityType' must be defined.");
    url_ = url_.replace('{entityType}', encodeURIComponent('' + entityType));
    if (entityId === undefined || entityId === null)
      throw new Error("The parameter 'entityId' must be defined.");
    url_ = url_.replace('{entityId}', encodeURIComponent('' + entityId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processFollow(_response);
      });
  }

  protected processFollow(response: AxiosResponse): Promise<EntityFollowerDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = EntityFollowerDto.fromJS(resultData200);
      return Promise.resolve<EntityFollowerDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<EntityFollowerDto>(null as any);
  }

  /**
   * Unfollow entity as current user.
   */
  unfollow(
    entityType: string | null,
    entityId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ =
      this.baseUrl + '/api/v1/entity-followers/{entityType}/{entityId}/me';
    if (entityType === undefined || entityType === null)
      throw new Error("The parameter 'entityType' must be defined.");
    url_ = url_.replace('{entityType}', encodeURIComponent('' + entityType));
    if (entityId === undefined || entityId === null)
      throw new Error("The parameter 'entityId' must be defined.");
    url_ = url_.replace('{entityId}', encodeURIComponent('' + entityId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      responseType: 'blob',
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/octet-stream'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUnfollow(_response);
      });
  }

  protected processUnfollow(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers['content-type']
        }),
        headers: _headers
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export class MeFollowedEntitiesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get entities followed by current user.
   */
  get(cancelToken?: CancelToken | undefined): Promise<FollowedEntityDto[]> {
    let url_ = this.baseUrl + '/api/v1/me/followed-entities';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<FollowedEntityDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(FollowedEntityDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<FollowedEntityDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class MessengerClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Search tenant users available for chat.
   * @param activeOnly (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param advancedSearch_Fields (optional)
   * @param advancedSearch_Keyword (optional)
   * @param keyword (optional) Keyword to Search in All the available columns of the Resource.
   */
  searchUsers(
    activeOnly?: boolean | undefined,
    pageNumber?: number | undefined,
    pageSize?: number | undefined,
    orderBy?: string[] | null | undefined,
    advancedSearch_Fields?: string[] | null | undefined,
    advancedSearch_Keyword?: string | null | undefined,
    keyword?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfChatUserDto> {
    let url_ = this.baseUrl + '/api/v1/messenger/users/search?';
    if (activeOnly === null)
      throw new Error("The parameter 'activeOnly' cannot be null.");
    else if (activeOnly !== undefined)
      url_ += 'ActiveOnly=' + encodeURIComponent('' + activeOnly) + '&';
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy !== undefined && orderBy !== null)
      orderBy &&
        orderBy.forEach((item) => {
          url_ += 'OrderBy=' + encodeURIComponent('' + item) + '&';
        });
    if (advancedSearch_Fields !== undefined && advancedSearch_Fields !== null)
      advancedSearch_Fields &&
        advancedSearch_Fields.forEach((item) => {
          url_ +=
            'AdvancedSearch.Fields=' + encodeURIComponent('' + item) + '&';
        });
    if (advancedSearch_Keyword !== undefined && advancedSearch_Keyword !== null)
      url_ +=
        'AdvancedSearch.Keyword=' +
        encodeURIComponent('' + advancedSearch_Keyword) +
        '&';
    if (keyword !== undefined && keyword !== null)
      url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearchUsers(_response);
      });
  }

  protected processSearchUsers(
    response: AxiosResponse
  ): Promise<PaginationResponseOfChatUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfChatUserDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfChatUserDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Search current user's chat conversations.
   */
  searchConversations(
    request: SearchChatConversationsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfChatConversationDto> {
    let url_ = this.baseUrl + '/api/v1/messenger/conversations/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearchConversations(_response);
      });
  }

  protected processSearchConversations(
    response: AxiosResponse
  ): Promise<PaginationResponseOfChatConversationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfChatConversationDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfChatConversationDto>(
        result200
      );
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a chat conversation.
   */
  createConversation(
    request: CreateChatConversationRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<ChatConversationDto> {
    let url_ = this.baseUrl + '/api/v1/messenger/conversations';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateConversation(_response);
      });
  }

  protected processCreateConversation(
    response: AxiosResponse
  ): Promise<ChatConversationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChatConversationDto.fromJS(resultData200);
      return Promise.resolve<ChatConversationDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get chat conversation.
   */
  getConversation(
    conversationId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<ChatConversationDto> {
    let url_ =
      this.baseUrl + '/api/v1/messenger/conversations/{conversationId}';
    if (conversationId === undefined || conversationId === null)
      throw new Error("The parameter 'conversationId' must be defined.");
    url_ = url_.replace(
      '{conversationId}',
      encodeURIComponent('' + conversationId)
    );
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetConversation(_response);
      });
  }

  protected processGetConversation(
    response: AxiosResponse
  ): Promise<ChatConversationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChatConversationDto.fromJS(resultData200);
      return Promise.resolve<ChatConversationDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Remove current user from a chat conversation.
   */
  deleteConversation(
    conversationId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ =
      this.baseUrl + '/api/v1/messenger/conversations/{conversationId}';
    if (conversationId === undefined || conversationId === null)
      throw new Error("The parameter 'conversationId' must be defined.");
    url_ = url_.replace(
      '{conversationId}',
      encodeURIComponent('' + conversationId)
    );
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteConversation(_response);
      });
  }

  protected processDeleteConversation(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get chat messages.
   * @param before (optional)
   * @param after (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @param keyword (optional)
   */
  getMessages(
    conversationId: string,
    before?: string | null | undefined,
    after?: string | null | undefined,
    pageNumber?: number | undefined,
    pageSize?: number | undefined,
    keyword?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfChatMessageDto> {
    let url_ =
      this.baseUrl +
      '/api/v1/messenger/conversations/{conversationId}/messages?';
    if (conversationId === undefined || conversationId === null)
      throw new Error("The parameter 'conversationId' must be defined.");
    url_ = url_.replace(
      '{conversationId}',
      encodeURIComponent('' + conversationId)
    );
    if (before !== undefined && before !== null)
      url_ += 'before=' + encodeURIComponent('' + before) + '&';
    if (after !== undefined && after !== null)
      url_ += 'after=' + encodeURIComponent('' + after) + '&';
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'pageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (keyword !== undefined && keyword !== null)
      url_ += 'keyword=' + encodeURIComponent('' + keyword) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetMessages(_response);
      });
  }

  protected processGetMessages(
    response: AxiosResponse
  ): Promise<PaginationResponseOfChatMessageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfChatMessageDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfChatMessageDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<PaginationResponseOfChatMessageDto>(null as any);
  }

  /**
   * Send chat message.
   */
  sendMessage(
    conversationId: string,
    request: SendChatMessageRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<ChatMessageDto> {
    let url_ =
      this.baseUrl +
      '/api/v1/messenger/conversations/{conversationId}/messages';
    if (conversationId === undefined || conversationId === null)
      throw new Error("The parameter 'conversationId' must be defined.");
    url_ = url_.replace(
      '{conversationId}',
      encodeURIComponent('' + conversationId)
    );
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSendMessage(_response);
      });
  }

  protected processSendMessage(
    response: AxiosResponse
  ): Promise<ChatMessageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChatMessageDto.fromJS(resultData200);
      return Promise.resolve<ChatMessageDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ChatMessageDto>(null as any);
  }

  /**
   * Mark chat conversation as read.
   */
  markRead(
    conversationId: string,
    request: MarkChatConversationReadRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<ChatConversationReadDto> {
    let url_ =
      this.baseUrl + '/api/v1/messenger/conversations/{conversationId}/read';
    if (conversationId === undefined || conversationId === null)
      throw new Error("The parameter 'conversationId' must be defined.");
    url_ = url_.replace(
      '{conversationId}',
      encodeURIComponent('' + conversationId)
    );
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMarkRead(_response);
      });
  }

  protected processMarkRead(
    response: AxiosResponse
  ): Promise<ChatConversationReadDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChatConversationReadDto.fromJS(resultData200);
      return Promise.resolve<ChatConversationReadDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ChatConversationReadDto>(null as any);
  }
}

export class OrderActivityClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get service order activity.
   */
  get(
    orderId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<OrderActivityDto[]> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{orderId}/activity';
    if (orderId === undefined || orderId === null)
      throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<OrderActivityDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(OrderActivityDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<OrderActivityDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Add service order comment.
   */
  addComment(
    request: AddOrderCommentRequest,
    orderId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{orderId}/comments';
    if (orderId === undefined || orderId === null)
      throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAddComment(_response);
      });
  }

  protected processAddComment(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Add service order attachment.
   */
  addAttachment(
    request: AddOrderAttachmentRequest,
    orderId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{orderId}/attachments';
    if (orderId === undefined || orderId === null)
      throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAddAttachment(_response);
      });
  }

  protected processAddAttachment(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Add service order photo.
   */
  addPhoto(
    request: AddOrderPhotoRequest,
    orderId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{orderId}/photos';
    if (orderId === undefined || orderId === null)
      throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAddPhoto(_response);
      });
  }

  protected processAddPhoto(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Add service order time entry.
   */
  addTimeEntry(
    request: AddOrderTimeEntryRequest,
    orderId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{orderId}/time-entries';
    if (orderId === undefined || orderId === null)
      throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAddTimeEntry(_response);
      });
  }

  protected processAddTimeEntry(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }
}

export class ServiceOrdersClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Search service orders.
   */
  search(
    request: SearchServiceOrdersRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfServiceOrderDto> {
    let url_ = this.baseUrl + '/api/v1/service-orders/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(
    response: AxiosResponse
  ): Promise<PaginationResponseOfServiceOrderDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfServiceOrderDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfServiceOrderDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get service order details.
   */
  get(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<ServiceOrderDto> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<ServiceOrderDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ServiceOrderDto.fromJS(resultData200);
      return Promise.resolve<ServiceOrderDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a service order.
   */
  update(
    request: UpdateServiceOrderRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete a service order.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a service order.
   * @param tenant Input your tenant Id to access this API
   */
  create(
    tenant: string,
    request: CreateServiceOrderRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<ServiceOrderDto> {
    let url_ = this.baseUrl + '/api/v1/service-orders';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<ServiceOrderDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ServiceOrderDto.fromJS(resultData200);
      return Promise.resolve<ServiceOrderDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Change service order status.
   * @param tenant Input your tenant Id to access this API
   */
  changeStatus(
    tenant: string,
    request: ChangeServiceOrderStatusRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{id}/status';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PATCH',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangeStatus(_response);
      });
  }

  protected processChangeStatus(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Schedule a service order.
   */
  schedule(
    request: ScheduleServiceOrderRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{id}/schedule';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PATCH',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSchedule(_response);
      });
  }

  protected processSchedule(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Assign a worker to service order.
   */
  assign(
    request: AssignServiceOrderRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{id}/assignee';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PATCH',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAssign(_response);
      });
  }

  protected processAssign(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Assign employees to service order.
   */
  assignEmployees(
    request: UpdateServiceOrderEmployeesRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{id}/employees';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAssignEmployees(_response);
      });
  }

  protected processAssignEmployees(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }
}

export class OrderStatusesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get order statuses.
   */
  get(cancelToken?: CancelToken | undefined): Promise<OrderStatusDto[]> {
    let url_ = this.baseUrl + '/api/v1/order-statuses';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<OrderStatusDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(OrderStatusDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<OrderStatusDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create an order status.
   */
  create(
    request: CreateOrderStatusRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/order-statuses';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update an order status.
   */
  update(
    request: UpdateOrderStatusRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/order-statuses/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete an order status.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/order-statuses/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class PositionsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get positions.
   */
  get(cancelToken?: CancelToken | undefined): Promise<PositionDto[]> {
    let url_ = this.baseUrl + '/api/v1/positions';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<PositionDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(PositionDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<PositionDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a position.
   */
  create(
    request: CreatePositionRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/positions';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a position.
   */
  update(
    request: UpdatePositionRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/positions/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete a position.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/positions/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class PublicCompaniesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Search public companies directory.
   * @param keyword (optional)
   * @param industry (optional)
   * @param location (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   */
  search(
    keyword?: string | null | undefined,
    industry?: string | null | undefined,
    location?: string | null | undefined,
    pageNumber?: number | undefined,
    pageSize?: number | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PublicCompanySearchResponse> {
    let url_ = this.baseUrl + '/api/v1/public-companies/search?';
    if (keyword !== undefined && keyword !== null)
      url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
    if (industry !== undefined && industry !== null)
      url_ += 'Industry=' + encodeURIComponent('' + industry) + '&';
    if (location !== undefined && location !== null)
      url_ += 'Location=' + encodeURIComponent('' + location) + '&';
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(
    response: AxiosResponse
  ): Promise<PublicCompanySearchResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PublicCompanySearchResponse.fromJS(resultData200);
      return Promise.resolve<PublicCompanySearchResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<PublicCompanySearchResponse>(null as any);
  }
}

export class PublicProfileClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get public profile settings.
   */
  getSettings(
    cancelToken?: CancelToken | undefined
  ): Promise<PublicProfileDto> {
    let url_ = this.baseUrl + '/api/v1/public-profile/settings';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSettings(_response);
      });
  }

  protected processGetSettings(
    response: AxiosResponse
  ): Promise<PublicProfileDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PublicProfileDto.fromJS(resultData200);
      return Promise.resolve<PublicProfileDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update public profile settings.
   */
  upsertSettingsPUT(
    request: UpsertPublicProfileSettingsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/public-profile/settings';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertSettingsPUT(_response);
      });
  }

  protected processUpsertSettingsPUT(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Update public profile settings.
   */
  upsertSettingsPOST(
    request: UpsertPublicProfileSettingsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/public-profile/settings';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertSettingsPOST(_response);
      });
  }

  protected processUpsertSettingsPOST(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Get archived public profile layout versions.
   */
  getLayoutVersions(
    cancelToken?: CancelToken | undefined
  ): Promise<PublicProfileLayoutVersionDto[]> {
    let url_ = this.baseUrl + '/api/v1/public-profile/layout-versions';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLayoutVersions(_response);
      });
  }

  protected processGetLayoutVersions(
    response: AxiosResponse
  ): Promise<PublicProfileLayoutVersionDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(PublicProfileLayoutVersionDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<PublicProfileLayoutVersionDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get archived public profile layout version.
   */
  getLayoutVersion(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<PublicProfileLayoutVersionDto> {
    let url_ = this.baseUrl + '/api/v1/public-profile/layout-versions/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLayoutVersion(_response);
      });
  }

  protected processGetLayoutVersion(
    response: AxiosResponse
  ): Promise<PublicProfileLayoutVersionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PublicProfileLayoutVersionDto.fromJS(resultData200);
      return Promise.resolve<PublicProfileLayoutVersionDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Restore archived public profile layout version.
   */
  restoreLayoutVersion(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<PublicProfileDto> {
    let url_ =
      this.baseUrl + '/api/v1/public-profile/layout-versions/{id}/restore';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRestoreLayoutVersion(_response);
      });
  }

  protected processRestoreLayoutVersion(
    response: AxiosResponse
  ): Promise<PublicProfileDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PublicProfileDto.fromJS(resultData200);
      return Promise.resolve<PublicProfileDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<PublicProfileDto>(null as any);
  }

  /**
   * Create public profile draft preview token.
   */
  createPreview(
    request: CreatePublicProfilePreviewRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<CreatePublicProfilePreviewResponse> {
    let url_ = this.baseUrl + '/api/v1/public-profile/previews';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreatePreview(_response);
      });
  }

  protected processCreatePreview(
    response: AxiosResponse
  ): Promise<CreatePublicProfilePreviewResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreatePublicProfilePreviewResponse.fromJS(resultData200);
      return Promise.resolve<CreatePublicProfilePreviewResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreatePublicProfilePreviewResponse>(null as any);
  }

  /**
   * Get public profile draft preview by token.
   */
  getPreview(
    token: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<PublicProfilePreviewDto> {
    let url_ = this.baseUrl + '/api/v1/public-profile/previews/{token}';
    if (token === undefined || token === null)
      throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace('{token}', encodeURIComponent('' + token));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPreview(_response);
      });
  }

  protected processGetPreview(
    response: AxiosResponse
  ): Promise<PublicProfilePreviewDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PublicProfilePreviewDto.fromJS(resultData200);
      return Promise.resolve<PublicProfilePreviewDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get public profile templates.
   */
  getTemplates(
    cancelToken?: CancelToken | undefined
  ): Promise<PublicProfileTemplatesResponse> {
    let url_ = this.baseUrl + '/api/v1/public-profile/templates';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTemplates(_response);
      });
  }

  protected processGetTemplates(
    response: AxiosResponse
  ): Promise<PublicProfileTemplatesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PublicProfileTemplatesResponse.fromJS(resultData200);
      return Promise.resolve<PublicProfileTemplatesResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get managed public profile sections.
   */
  getSections(
    cancelToken?: CancelToken | undefined
  ): Promise<PublicProfileSectionDto[]> {
    let url_ = this.baseUrl + '/api/v1/public-profile/sections';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSections(_response);
      });
  }

  protected processGetSections(
    response: AxiosResponse
  ): Promise<PublicProfileSectionDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(PublicProfileSectionDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<PublicProfileSectionDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create public profile section.
   */
  createSection(
    request: CreatePublicProfileSectionRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PublicProfileSectionDto> {
    let url_ = this.baseUrl + '/api/v1/public-profile/sections';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateSection(_response);
      });
  }

  protected processCreateSection(
    response: AxiosResponse
  ): Promise<PublicProfileSectionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PublicProfileSectionDto.fromJS(resultData200);
      return Promise.resolve<PublicProfileSectionDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update public profile section.
   */
  updateSection(
    request: UpdatePublicProfileSectionRequest,
    key: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<PublicProfileSectionDto> {
    let url_ = this.baseUrl + '/api/v1/public-profile/sections/{key}';
    if (key === undefined || key === null)
      throw new Error("The parameter 'key' must be defined.");
    url_ = url_.replace('{key}', encodeURIComponent('' + key));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateSection(_response);
      });
  }

  protected processUpdateSection(
    response: AxiosResponse
  ): Promise<PublicProfileSectionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PublicProfileSectionDto.fromJS(resultData200);
      return Promise.resolve<PublicProfileSectionDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete public profile section.
   */
  deleteSection(
    key: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/public-profile/sections/{key}';
    if (key === undefined || key === null)
      throw new Error("The parameter 'key' must be defined.");
    url_ = url_.replace('{key}', encodeURIComponent('' + key));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteSection(_response);
      });
  }

  protected processDeleteSection(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get website pages.
   */
  getPages(cancelToken?: CancelToken | undefined): Promise<WebsitePageDto[]> {
    let url_ = this.baseUrl + '/api/v1/public-profile/pages';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPages(_response);
      });
  }

  protected processGetPages(
    response: AxiosResponse
  ): Promise<WebsitePageDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(WebsitePageDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<WebsitePageDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create website page.
   */
  createPage(
    request: CreateWebsitePageRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/public-profile/pages';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreatePage(_response);
      });
  }

  protected processCreatePage(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update website page.
   */
  updatePage(
    request: UpdateWebsitePageRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/public-profile/pages/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdatePage(_response);
      });
  }

  protected processUpdatePage(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete website page.
   */
  deletePage(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/public-profile/pages/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeletePage(_response);
      });
  }

  protected processDeletePage(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get blog posts.
   */
  getBlogPosts(cancelToken?: CancelToken | undefined): Promise<BlogPostDto[]> {
    let url_ = this.baseUrl + '/api/v1/public-profile/blog-posts';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBlogPosts(_response);
      });
  }

  protected processGetBlogPosts(
    response: AxiosResponse
  ): Promise<BlogPostDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(BlogPostDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<BlogPostDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create blog post.
   */
  createBlogPost(
    request: CreateBlogPostRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/public-profile/blog-posts';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateBlogPost(_response);
      });
  }

  protected processCreateBlogPost(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update blog post.
   */
  updateBlogPost(
    request: UpdateBlogPostRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/public-profile/blog-posts/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateBlogPost(_response);
      });
  }

  protected processUpdateBlogPost(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete blog post.
   */
  deleteBlogPost(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/public-profile/blog-posts/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteBlogPost(_response);
      });
  }

  protected processDeleteBlogPost(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class PublicProfilesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get public profile.
   */
  get(
    friendlyUrl: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<PublicProfileDto> {
    let url_ = this.baseUrl + '/api/v1/public-profiles/{friendlyUrl}';
    if (friendlyUrl === undefined || friendlyUrl === null)
      throw new Error("The parameter 'friendlyUrl' must be defined.");
    url_ = url_.replace('{friendlyUrl}', encodeURIComponent('' + friendlyUrl));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<PublicProfileDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PublicProfileDto.fromJS(resultData200);
      return Promise.resolve<PublicProfileDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get public profile pages visible in menu.
   */
  getPages(
    friendlyUrl: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsitePageDto[]> {
    let url_ = this.baseUrl + '/api/v1/public-profiles/{friendlyUrl}/pages';
    if (friendlyUrl === undefined || friendlyUrl === null)
      throw new Error("The parameter 'friendlyUrl' must be defined.");
    url_ = url_.replace('{friendlyUrl}', encodeURIComponent('' + friendlyUrl));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPages(_response);
      });
  }

  protected processGetPages(
    response: AxiosResponse
  ): Promise<WebsitePageDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(WebsitePageDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<WebsitePageDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get public profile page.
   */
  getPage(
    friendlyUrl: string | null,
    slug: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsitePageDto> {
    let url_ =
      this.baseUrl + '/api/v1/public-profiles/{friendlyUrl}/pages/{slug}';
    if (friendlyUrl === undefined || friendlyUrl === null)
      throw new Error("The parameter 'friendlyUrl' must be defined.");
    url_ = url_.replace('{friendlyUrl}', encodeURIComponent('' + friendlyUrl));
    if (slug === undefined || slug === null)
      throw new Error("The parameter 'slug' must be defined.");
    url_ = url_.replace('{slug}', encodeURIComponent('' + slug));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPage(_response);
      });
  }

  protected processGetPage(response: AxiosResponse): Promise<WebsitePageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsitePageDto.fromJS(resultData200);
      return Promise.resolve<WebsitePageDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get public profile services.
   */
  getServices(
    friendlyUrl: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<PublicServiceDto[]> {
    let url_ = this.baseUrl + '/api/v1/public-profiles/{friendlyUrl}/services';
    if (friendlyUrl === undefined || friendlyUrl === null)
      throw new Error("The parameter 'friendlyUrl' must be defined.");
    url_ = url_.replace('{friendlyUrl}', encodeURIComponent('' + friendlyUrl));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServices(_response);
      });
  }

  protected processGetServices(
    response: AxiosResponse
  ): Promise<PublicServiceDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(PublicServiceDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<PublicServiceDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get public profile sections.
   */
  getSections(
    friendlyUrl: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<PublicProfileSectionDto[]> {
    let url_ = this.baseUrl + '/api/v1/public-profiles/{friendlyUrl}/sections';
    if (friendlyUrl === undefined || friendlyUrl === null)
      throw new Error("The parameter 'friendlyUrl' must be defined.");
    url_ = url_.replace('{friendlyUrl}', encodeURIComponent('' + friendlyUrl));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSections(_response);
      });
  }

  protected processGetSections(
    response: AxiosResponse
  ): Promise<PublicProfileSectionDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(PublicProfileSectionDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<PublicProfileSectionDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get public profile blog posts.
   */
  getBlog(
    friendlyUrl: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<BlogPostDto[]> {
    let url_ = this.baseUrl + '/api/v1/public-profiles/{friendlyUrl}/blog';
    if (friendlyUrl === undefined || friendlyUrl === null)
      throw new Error("The parameter 'friendlyUrl' must be defined.");
    url_ = url_.replace('{friendlyUrl}', encodeURIComponent('' + friendlyUrl));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBlog(_response);
      });
  }

  protected processGetBlog(response: AxiosResponse): Promise<BlogPostDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(BlogPostDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<BlogPostDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get public profile blog post.
   */
  getBlogPost(
    friendlyUrl: string | null,
    slug: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<BlogPostDto> {
    let url_ =
      this.baseUrl + '/api/v1/public-profiles/{friendlyUrl}/blog/{slug}';
    if (friendlyUrl === undefined || friendlyUrl === null)
      throw new Error("The parameter 'friendlyUrl' must be defined.");
    url_ = url_.replace('{friendlyUrl}', encodeURIComponent('' + friendlyUrl));
    if (slug === undefined || slug === null)
      throw new Error("The parameter 'slug' must be defined.");
    url_ = url_.replace('{slug}', encodeURIComponent('' + slug));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBlogPost(_response);
      });
  }

  protected processGetBlogPost(response: AxiosResponse): Promise<BlogPostDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BlogPostDto.fromJS(resultData200);
      return Promise.resolve<BlogPostDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a lead from public profile.
   */
  createLead(
    request: CreatePublicLeadRequest,
    friendlyUrl: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<CreatePublicLeadResponse> {
    let url_ = this.baseUrl + '/api/v1/public-profiles/{friendlyUrl}/leads';
    if (friendlyUrl === undefined || friendlyUrl === null)
      throw new Error("The parameter 'friendlyUrl' must be defined.");
    url_ = url_.replace('{friendlyUrl}', encodeURIComponent('' + friendlyUrl));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateLead(_response);
      });
  }

  protected processCreateLead(
    response: AxiosResponse
  ): Promise<CreatePublicLeadResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreatePublicLeadResponse.fromJS(resultData200);
      return Promise.resolve<CreatePublicLeadResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<CreatePublicLeadResponse>(null as any);
  }
}

export class RemindersClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Search reminders.
   */
  search(
    request: SearchRemindersRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfReminderDto> {
    let url_ = this.baseUrl + '/api/v1/reminders/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(
    response: AxiosResponse
  ): Promise<PaginationResponseOfReminderDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfReminderDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfReminderDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get service order reminders.
   */
  getOrderReminders(
    orderId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<ReminderDto[]> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{orderId}/reminders';
    if (orderId === undefined || orderId === null)
      throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetOrderReminders(_response);
      });
  }

  protected processGetOrderReminders(
    response: AxiosResponse
  ): Promise<ReminderDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ReminderDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<ReminderDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a service order reminder.
   */
  createOrderReminder(
    request: CreateOrderReminderRequest,
    orderId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/service-orders/{orderId}/reminders';
    if (orderId === undefined || orderId === null)
      throw new Error("The parameter 'orderId' must be defined.");
    url_ = url_.replace('{orderId}', encodeURIComponent('' + orderId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateOrderReminder(_response);
      });
  }

  protected processCreateOrderReminder(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Create a reminder.
   */
  create(
    request: CreateOrderReminderRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/reminders';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Cancel a reminder.
   */
  cancel(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/reminders/{id}/cancel';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'PATCH',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCancel(_response);
      });
  }

  protected processCancel(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Delete a reminder.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/reminders/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class ServicesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get services.
   */
  get(cancelToken?: CancelToken | undefined): Promise<ServiceDto[]> {
    let url_ = this.baseUrl + '/api/v1/services';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<ServiceDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ServiceDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<ServiceDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a service.
   */
  create(
    request: CreateServiceRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/services';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a service.
   */
  update(
    request: UpdateServiceRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/services/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete a service.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/services/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class SettingsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get automation settings.
   */
  getAutomation(
    cancelToken?: CancelToken | undefined
  ): Promise<AutomationSettingsDto> {
    let url_ = this.baseUrl + '/api/v1/settings/automation';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAutomation(_response);
      });
  }

  protected processGetAutomation(
    response: AxiosResponse
  ): Promise<AutomationSettingsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AutomationSettingsDto.fromJS(resultData200);
      return Promise.resolve<AutomationSettingsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update automation settings.
   */
  updateAutomation(
    request: UpdateAutomationSettingsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<AutomationSettingsDto> {
    let url_ = this.baseUrl + '/api/v1/settings/automation';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateAutomation(_response);
      });
  }

  protected processUpdateAutomation(
    response: AxiosResponse
  ): Promise<AutomationSettingsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = AutomationSettingsDto.fromJS(resultData200);
      return Promise.resolve<AutomationSettingsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get SMS template settings.
   */
  getSmsTemplates(
    cancelToken?: CancelToken | undefined
  ): Promise<SmsTemplatesSettingsDto> {
    let url_ = this.baseUrl + '/api/v1/settings/sms-templates';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSmsTemplates(_response);
      });
  }

  protected processGetSmsTemplates(
    response: AxiosResponse
  ): Promise<SmsTemplatesSettingsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SmsTemplatesSettingsDto.fromJS(resultData200);
      return Promise.resolve<SmsTemplatesSettingsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update SMS template settings.
   */
  updateSmsTemplates(
    request: UpdateSmsTemplatesSettingsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<SmsTemplatesSettingsDto> {
    let url_ = this.baseUrl + '/api/v1/settings/sms-templates';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateSmsTemplates(_response);
      });
  }

  protected processUpdateSmsTemplates(
    response: AxiosResponse
  ): Promise<SmsTemplatesSettingsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SmsTemplatesSettingsDto.fromJS(resultData200);
      return Promise.resolve<SmsTemplatesSettingsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get panel preference settings.
   */
  getPanelPreferences(
    cancelToken?: CancelToken | undefined
  ): Promise<PanelPreferencesSettingsDto> {
    let url_ = this.baseUrl + '/api/v1/settings/panel-preferences';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPanelPreferences(_response);
      });
  }

  protected processGetPanelPreferences(
    response: AxiosResponse
  ): Promise<PanelPreferencesSettingsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PanelPreferencesSettingsDto.fromJS(resultData200);
      return Promise.resolve<PanelPreferencesSettingsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update panel preference settings.
   */
  updatePanelPreferences(
    request: UpdatePanelPreferencesSettingsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PanelPreferencesSettingsDto> {
    let url_ = this.baseUrl + '/api/v1/settings/panel-preferences';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdatePanelPreferences(_response);
      });
  }

  protected processUpdatePanelPreferences(
    response: AxiosResponse
  ): Promise<PanelPreferencesSettingsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PanelPreferencesSettingsDto.fromJS(resultData200);
      return Promise.resolve<PanelPreferencesSettingsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class TeamsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Update a team.
   */
  update(
    request: UpdateDepartmentTeamRequest,
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/teams/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete a team.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/teams/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class WebsitesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get the current tenant website.
   */
  getCurrent(cancelToken?: CancelToken | undefined): Promise<WebsiteDto> {
    let url_ = this.baseUrl + '/api/v1/websites/current';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCurrent(_response);
      });
  }

  protected processGetCurrent(response: AxiosResponse): Promise<WebsiteDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsiteDto.fromJS(resultData200);
      return Promise.resolve<WebsiteDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Ensure the current tenant website exists.
   */
  ensureCurrent(cancelToken?: CancelToken | undefined): Promise<WebsiteDto> {
    let url_ = this.baseUrl + '/api/v1/websites/current/ensure';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processEnsureCurrent(_response);
      });
  }

  protected processEnsureCurrent(response: AxiosResponse): Promise<WebsiteDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsiteDto.fromJS(resultData200);
      return Promise.resolve<WebsiteDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<WebsiteDto>(null as any);
  }

  /**
   * Create tenant website.
   */
  create(
    request: CreateWebsiteRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsiteDto> {
    let url_ = this.baseUrl + '/api/v1/websites';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<WebsiteDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsiteDto.fromJS(resultData200);
      return Promise.resolve<WebsiteDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update tenant website settings.
   */
  update(
    websiteId: string,
    request: UpdateWebsiteRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsiteDto> {
    let url_ = this.baseUrl + '/api/v1/websites/{websiteId}';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<WebsiteDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsiteDto.fromJS(resultData200);
      return Promise.resolve<WebsiteDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get website pages.
   */
  getPages(
    websiteId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsitePageSummaryDto[]> {
    let url_ = this.baseUrl + '/api/v1/websites/{websiteId}/pages';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPages(_response);
      });
  }

  protected processGetPages(
    response: AxiosResponse
  ): Promise<WebsitePageSummaryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(WebsitePageSummaryDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<WebsitePageSummaryDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create website page.
   */
  createPage(
    websiteId: string,
    request: CreateWebsitePageRequest2,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsitePageSummaryDto> {
    let url_ = this.baseUrl + '/api/v1/websites/{websiteId}/pages';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreatePage(_response);
      });
  }

  protected processCreatePage(
    response: AxiosResponse
  ): Promise<WebsitePageSummaryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsitePageSummaryDto.fromJS(resultData200);
      return Promise.resolve<WebsitePageSummaryDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<WebsitePageSummaryDto>(null as any);
  }

  /**
   * Get website routing diagnostics.
   */
  getRoutingStatus(
    websiteId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsiteRoutingStatusDto> {
    let url_ = this.baseUrl + '/api/v1/websites/{websiteId}/routing-status';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRoutingStatus(_response);
      });
  }

  protected processGetRoutingStatus(
    response: AxiosResponse
  ): Promise<WebsiteRoutingStatusDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsiteRoutingStatusDto.fromJS(resultData200);
      return Promise.resolve<WebsiteRoutingStatusDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get website custom domains.
   */
  getDomains(
    websiteId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsiteDomainDto[]> {
    let url_ = this.baseUrl + '/api/v1/websites/{websiteId}/domains';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDomains(_response);
      });
  }

  protected processGetDomains(
    response: AxiosResponse
  ): Promise<WebsiteDomainDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(WebsiteDomainDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<WebsiteDomainDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Add website custom domain.
   */
  createDomain(
    websiteId: string,
    request: CreateWebsiteDomainRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsiteDomainDto> {
    let url_ = this.baseUrl + '/api/v1/websites/{websiteId}/domains';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateDomain(_response);
      });
  }

  protected processCreateDomain(
    response: AxiosResponse
  ): Promise<WebsiteDomainDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsiteDomainDto.fromJS(resultData200);
      return Promise.resolve<WebsiteDomainDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<WebsiteDomainDto>(null as any);
  }

  /**
   * Delete website custom domain.
   * @param rowVersion (optional)
   */
  deleteDomain(
    websiteId: string,
    domainId: string,
    rowVersion?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ =
      this.baseUrl + '/api/v1/websites/{websiteId}/domains/{domainId}?';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    if (domainId === undefined || domainId === null)
      throw new Error("The parameter 'domainId' must be defined.");
    url_ = url_.replace('{domainId}', encodeURIComponent('' + domainId));
    if (rowVersion !== undefined && rowVersion !== null)
      url_ += 'rowVersion=' + encodeURIComponent('' + rowVersion) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteDomain(_response);
      });
  }

  protected processDeleteDomain(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Verify website custom domain.
   * @param rowVersion (optional)
   */
  verifyDomain(
    websiteId: string,
    domainId: string,
    rowVersion?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsiteDomainDto> {
    let url_ =
      this.baseUrl + '/api/v1/websites/{websiteId}/domains/{domainId}/verify?';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    if (domainId === undefined || domainId === null)
      throw new Error("The parameter 'domainId' must be defined.");
    url_ = url_.replace('{domainId}', encodeURIComponent('' + domainId));
    if (rowVersion !== undefined && rowVersion !== null)
      url_ += 'rowVersion=' + encodeURIComponent('' + rowVersion) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processVerifyDomain(_response);
      });
  }

  protected processVerifyDomain(
    response: AxiosResponse
  ): Promise<WebsiteDomainDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsiteDomainDto.fromJS(resultData200);
      return Promise.resolve<WebsiteDomainDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<WebsiteDomainDto>(null as any);
  }

  /**
   * Mark website custom domain as primary.
   * @param rowVersion (optional)
   */
  makePrimaryDomain(
    websiteId: string,
    domainId: string,
    rowVersion?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsiteDomainDto> {
    let url_ =
      this.baseUrl +
      '/api/v1/websites/{websiteId}/domains/{domainId}/make-primary?';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    if (domainId === undefined || domainId === null)
      throw new Error("The parameter 'domainId' must be defined.");
    url_ = url_.replace('{domainId}', encodeURIComponent('' + domainId));
    if (rowVersion !== undefined && rowVersion !== null)
      url_ += 'rowVersion=' + encodeURIComponent('' + rowVersion) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMakePrimaryDomain(_response);
      });
  }

  protected processMakePrimaryDomain(
    response: AxiosResponse
  ): Promise<WebsiteDomainDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsiteDomainDto.fromJS(resultData200);
      return Promise.resolve<WebsiteDomainDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<WebsiteDomainDto>(null as any);
  }

  /**
   * Get website page metadata.
   */
  getPage(
    websiteId: string,
    pageId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsitePageSummaryDto> {
    let url_ = this.baseUrl + '/api/v1/websites/{websiteId}/pages/{pageId}';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    if (pageId === undefined || pageId === null)
      throw new Error("The parameter 'pageId' must be defined.");
    url_ = url_.replace('{pageId}', encodeURIComponent('' + pageId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPage(_response);
      });
  }

  protected processGetPage(
    response: AxiosResponse
  ): Promise<WebsitePageSummaryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsitePageSummaryDto.fromJS(resultData200);
      return Promise.resolve<WebsitePageSummaryDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update website page metadata.
   */
  updatePage(
    websiteId: string,
    pageId: string,
    request: UpdateWebsitePageRequest2,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsitePageSummaryDto> {
    let url_ = this.baseUrl + '/api/v1/websites/{websiteId}/pages/{pageId}';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    if (pageId === undefined || pageId === null)
      throw new Error("The parameter 'pageId' must be defined.");
    url_ = url_.replace('{pageId}', encodeURIComponent('' + pageId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdatePage(_response);
      });
  }

  protected processUpdatePage(
    response: AxiosResponse
  ): Promise<WebsitePageSummaryDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsitePageSummaryDto.fromJS(resultData200);
      return Promise.resolve<WebsitePageSummaryDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete website page.
   * @param rowVersion (optional)
   */
  deletePage(
    websiteId: string,
    pageId: string,
    rowVersion?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/websites/{websiteId}/pages/{pageId}?';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    if (pageId === undefined || pageId === null)
      throw new Error("The parameter 'pageId' must be defined.");
    url_ = url_.replace('{pageId}', encodeURIComponent('' + pageId));
    if (rowVersion !== undefined && rowVersion !== null)
      url_ += 'rowVersion=' + encodeURIComponent('' + rowVersion) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeletePage(_response);
      });
  }

  protected processDeletePage(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * Get website page draft.
   */
  getDraft(
    websiteId: string,
    pageId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsitePageDraftDto> {
    let url_ =
      this.baseUrl + '/api/v1/websites/{websiteId}/pages/{pageId}/draft';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    if (pageId === undefined || pageId === null)
      throw new Error("The parameter 'pageId' must be defined.");
    url_ = url_.replace('{pageId}', encodeURIComponent('' + pageId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDraft(_response);
      });
  }

  protected processGetDraft(
    response: AxiosResponse
  ): Promise<WebsitePageDraftDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsitePageDraftDto.fromJS(resultData200);
      return Promise.resolve<WebsitePageDraftDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Save website page draft.
   */
  saveDraft(
    websiteId: string,
    pageId: string,
    request: SaveWebsitePageDraftRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsitePageDraftDto> {
    let url_ =
      this.baseUrl + '/api/v1/websites/{websiteId}/pages/{pageId}/draft';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    if (pageId === undefined || pageId === null)
      throw new Error("The parameter 'pageId' must be defined.");
    url_ = url_.replace('{pageId}', encodeURIComponent('' + pageId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSaveDraft(_response);
      });
  }

  protected processSaveDraft(
    response: AxiosResponse
  ): Promise<WebsitePageDraftDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsitePageDraftDto.fromJS(resultData200);
      return Promise.resolve<WebsitePageDraftDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<WebsitePageDraftDto>(null as any);
  }

  /**
   * Publish website page draft.
   */
  publishPage(
    websiteId: string,
    pageId: string,
    request: PublishWebsitePageRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PublishWebsitePageResultDto> {
    let url_ =
      this.baseUrl + '/api/v1/websites/{websiteId}/pages/{pageId}/publish';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    if (pageId === undefined || pageId === null)
      throw new Error("The parameter 'pageId' must be defined.");
    url_ = url_.replace('{pageId}', encodeURIComponent('' + pageId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processPublishPage(_response);
      });
  }

  protected processPublishPage(
    response: AxiosResponse
  ): Promise<PublishWebsitePageResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PublishWebsitePageResultDto.fromJS(resultData200);
      return Promise.resolve<PublishWebsitePageResultDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<PublishWebsitePageResultDto>(null as any);
  }

  /**
   * Get website page revisions.
   */
  getRevisions(
    websiteId: string,
    pageId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsitePageRevisionDto[]> {
    let url_ =
      this.baseUrl + '/api/v1/websites/{websiteId}/pages/{pageId}/revisions';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    if (pageId === undefined || pageId === null)
      throw new Error("The parameter 'pageId' must be defined.");
    url_ = url_.replace('{pageId}', encodeURIComponent('' + pageId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRevisions(_response);
      });
  }

  protected processGetRevisions(
    response: AxiosResponse
  ): Promise<WebsitePageRevisionDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(WebsitePageRevisionDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<WebsitePageRevisionDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Restore website page revision to draft.
   */
  restoreRevision(
    websiteId: string,
    pageId: string,
    revisionId: string,
    cancelToken?: CancelToken | undefined
  ): Promise<WebsitePageDraftDto> {
    let url_ =
      this.baseUrl +
      '/api/v1/websites/{websiteId}/pages/{pageId}/revisions/{revisionId}/restore';
    if (websiteId === undefined || websiteId === null)
      throw new Error("The parameter 'websiteId' must be defined.");
    url_ = url_.replace('{websiteId}', encodeURIComponent('' + websiteId));
    if (pageId === undefined || pageId === null)
      throw new Error("The parameter 'pageId' must be defined.");
    url_ = url_.replace('{pageId}', encodeURIComponent('' + pageId));
    if (revisionId === undefined || revisionId === null)
      throw new Error("The parameter 'revisionId' must be defined.");
    url_ = url_.replace('{revisionId}', encodeURIComponent('' + revisionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRestoreRevision(_response);
      });
  }

  protected processRestoreRevision(
    response: AxiosResponse
  ): Promise<WebsitePageDraftDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = WebsitePageDraftDto.fromJS(resultData200);
      return Promise.resolve<WebsitePageDraftDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<WebsitePageDraftDto>(null as any);
  }

  /**
   * Resolve public website page.
   * @param host (optional)
   * @param publicSlug (optional)
   * @param path (optional)
   */
  resolvePublic(
    host?: string | null | undefined,
    publicSlug?: string | null | undefined,
    path?: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<PublicWebsiteResolvedPageDto> {
    let url_ = this.baseUrl + '/api/v1/websites/public/resolve?';
    if (host !== undefined && host !== null)
      url_ += 'Host=' + encodeURIComponent('' + host) + '&';
    if (publicSlug !== undefined && publicSlug !== null)
      url_ += 'PublicSlug=' + encodeURIComponent('' + publicSlug) + '&';
    if (path !== undefined && path !== null)
      url_ += 'Path=' + encodeURIComponent('' + path) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processResolvePublic(_response);
      });
  }

  protected processResolvePublic(
    response: AxiosResponse
  ): Promise<PublicWebsiteResolvedPageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PublicWebsiteResolvedPageDto.fromJS(resultData200);
      return Promise.resolve<PublicWebsiteResolvedPageDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<PublicWebsiteResolvedPageDto>(null as any);
  }

  /**
   * Create website contact submission.
   */
  createContactSubmission(
    request: CreateWebsiteContactSubmissionRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<CreateWebsiteContactSubmissionResponse> {
    let url_ = this.baseUrl + '/api/v1/websites/public/contact-submissions';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateContactSubmission(_response);
      });
  }

  protected processCreateContactSubmission(
    response: AxiosResponse
  ): Promise<CreateWebsiteContactSubmissionResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CreateWebsiteContactSubmissionResponse.fromJS(resultData200);
      return Promise.resolve<CreateWebsiteContactSubmissionResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class PaginationResponseOfAdminAuditLogDto
  implements IPaginationResponseOfAdminAuditLogDto
{
  data?: AdminAuditLogDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfAdminAuditLogDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(AdminAuditLogDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfAdminAuditLogDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfAdminAuditLogDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfAdminAuditLogDto {
  data?: AdminAuditLogDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class AdminAuditLogDto implements IAdminAuditLogDto {
  id?: string;
  tenantId?: string;
  tenantName?: string | undefined;
  sourceDatabase?: string;
  userId?: string | undefined;
  userEmail?: string | undefined;
  userName?: string | undefined;
  type?: string | undefined;
  tableName?: string | undefined;
  dateTime?: string;
  oldValues?: string | undefined;
  newValues?: string | undefined;
  affectedColumns?: string | undefined;
  primaryKey?: string | undefined;

  constructor(data?: IAdminAuditLogDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.tenantId = _data['tenantId'];
      this.tenantName = _data['tenantName'];
      this.sourceDatabase = _data['sourceDatabase'];
      this.userId = _data['userId'];
      this.userEmail = _data['userEmail'];
      this.userName = _data['userName'];
      this.type = _data['type'];
      this.tableName = _data['tableName'];
      this.dateTime = _data['dateTime'];
      this.oldValues = _data['oldValues'];
      this.newValues = _data['newValues'];
      this.affectedColumns = _data['affectedColumns'];
      this.primaryKey = _data['primaryKey'];
    }
  }

  static fromJS(data: any): AdminAuditLogDto {
    data = typeof data === 'object' ? data : {};
    let result = new AdminAuditLogDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['tenantId'] = this.tenantId;
    data['tenantName'] = this.tenantName;
    data['sourceDatabase'] = this.sourceDatabase;
    data['userId'] = this.userId;
    data['userEmail'] = this.userEmail;
    data['userName'] = this.userName;
    data['type'] = this.type;
    data['tableName'] = this.tableName;
    data['dateTime'] = this.dateTime;
    data['oldValues'] = this.oldValues;
    data['newValues'] = this.newValues;
    data['affectedColumns'] = this.affectedColumns;
    data['primaryKey'] = this.primaryKey;
    return data;
  }
}

export interface IAdminAuditLogDto {
  id?: string;
  tenantId?: string;
  tenantName?: string | undefined;
  sourceDatabase?: string;
  userId?: string | undefined;
  userEmail?: string | undefined;
  userName?: string | undefined;
  type?: string | undefined;
  tableName?: string | undefined;
  dateTime?: string;
  oldValues?: string | undefined;
  newValues?: string | undefined;
  affectedColumns?: string | undefined;
  primaryKey?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.detail = _data['detail'];
      this.instance = _data['instance'];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['title'] = this.title;
    data['status'] = this.status;
    data['detail'] = this.detail;
    data['instance'] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
}

export class HttpValidationProblemDetails
  extends ProblemDetails
  implements IHttpValidationProblemDetails
{
  errors?: { [key: string]: string[] };

  constructor(data?: IHttpValidationProblemDetails) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (_data['errors']) {
        this.errors = {} as any;
        for (let key in _data['errors']) {
          if (_data['errors'].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data['errors'][key] !== undefined ? _data['errors'][key] : [];
        }
      }
    }
  }

  static fromJS(data: any): HttpValidationProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new HttpValidationProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.errors) {
      data['errors'] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data['errors'])[key] = (<any>this.errors)[key];
      }
    }
    super.toJSON(data);
    return data;
  }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
  errors?: { [key: string]: string[] };
}

export class ErrorResult implements IErrorResult {
  messages?: string[] | undefined;
  source?: string | undefined;
  exception?: string | undefined;
  errorId?: string | undefined;
  supportMessage?: string | undefined;
  statusCode?: number;

  constructor(data?: IErrorResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['messages'])) {
        this.messages = [] as any;
        for (let item of _data['messages']) this.messages!.push(item);
      }
      this.source = _data['source'];
      this.exception = _data['exception'];
      this.errorId = _data['errorId'];
      this.supportMessage = _data['supportMessage'];
      this.statusCode = _data['statusCode'];
    }
  }

  static fromJS(data: any): ErrorResult {
    data = typeof data === 'object' ? data : {};
    let result = new ErrorResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.messages)) {
      data['messages'] = [];
      for (let item of this.messages) data['messages'].push(item);
    }
    data['source'] = this.source;
    data['exception'] = this.exception;
    data['errorId'] = this.errorId;
    data['supportMessage'] = this.supportMessage;
    data['statusCode'] = this.statusCode;
    return data;
  }
}

export interface IErrorResult {
  messages?: string[] | undefined;
  source?: string | undefined;
  exception?: string | undefined;
  errorId?: string | undefined;
  supportMessage?: string | undefined;
  statusCode?: number;
}

export class PaginationResponseOfAdminContactRequestDto
  implements IPaginationResponseOfAdminContactRequestDto
{
  data?: AdminContactRequestDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfAdminContactRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(AdminContactRequestDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfAdminContactRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfAdminContactRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfAdminContactRequestDto {
  data?: AdminContactRequestDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class AdminContactRequestDto implements IAdminContactRequestDto {
  id?: string;
  fullName?: string;
  email?: string;
  industry?: string | undefined;
  message?: string;
  host?: string | undefined;
  sourcePage?: string | undefined;
  status?: string;
  createdAt?: string;
  updatedAt?: string | undefined;
  updatedBy?: string | undefined;

  constructor(data?: IAdminContactRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.fullName = _data['fullName'];
      this.email = _data['email'];
      this.industry = _data['industry'];
      this.message = _data['message'];
      this.host = _data['host'];
      this.sourcePage = _data['sourcePage'];
      this.status = _data['status'];
      this.createdAt = _data['createdAt'];
      this.updatedAt = _data['updatedAt'];
      this.updatedBy = _data['updatedBy'];
    }
  }

  static fromJS(data: any): AdminContactRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new AdminContactRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['email'] = this.email;
    data['industry'] = this.industry;
    data['message'] = this.message;
    data['host'] = this.host;
    data['sourcePage'] = this.sourcePage;
    data['status'] = this.status;
    data['createdAt'] = this.createdAt;
    data['updatedAt'] = this.updatedAt;
    data['updatedBy'] = this.updatedBy;
    return data;
  }
}

export interface IAdminContactRequestDto {
  id?: string;
  fullName?: string;
  email?: string;
  industry?: string | undefined;
  message?: string;
  host?: string | undefined;
  sourcePage?: string | undefined;
  status?: string;
  createdAt?: string;
  updatedAt?: string | undefined;
  updatedBy?: string | undefined;
}

export class UpdateContactRequestStatusRequest
  implements IUpdateContactRequestStatusRequest
{
  status?: string;

  constructor(data?: IUpdateContactRequestStatusRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.status = _data['status'];
    }
  }

  static fromJS(data: any): UpdateContactRequestStatusRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateContactRequestStatusRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['status'] = this.status;
    return data;
  }
}

export interface IUpdateContactRequestStatusRequest {
  status?: string;
}

export class PaginationResponseOfAdminUserDto
  implements IPaginationResponseOfAdminUserDto
{
  data?: AdminUserDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfAdminUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(AdminUserDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfAdminUserDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfAdminUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfAdminUserDto {
  data?: AdminUserDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class AdminUserDto implements IAdminUserDto {
  id?: string;
  tenantId?: string;
  userName?: string | undefined;
  displayName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  imageUrl?: string | undefined;
  isActive?: boolean;
  emailConfirmed?: boolean;
  roles?: AdminUserRoleDto[];

  constructor(data?: IAdminUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.tenantId = _data['tenantId'];
      this.userName = _data['userName'];
      this.displayName = _data['displayName'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.email = _data['email'];
      this.phoneNumber = _data['phoneNumber'];
      this.imageUrl = _data['imageUrl'];
      this.isActive = _data['isActive'];
      this.emailConfirmed = _data['emailConfirmed'];
      if (Array.isArray(_data['roles'])) {
        this.roles = [] as any;
        for (let item of _data['roles'])
          this.roles!.push(AdminUserRoleDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AdminUserDto {
    data = typeof data === 'object' ? data : {};
    let result = new AdminUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['tenantId'] = this.tenantId;
    data['userName'] = this.userName;
    data['displayName'] = this.displayName;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['email'] = this.email;
    data['phoneNumber'] = this.phoneNumber;
    data['imageUrl'] = this.imageUrl;
    data['isActive'] = this.isActive;
    data['emailConfirmed'] = this.emailConfirmed;
    if (Array.isArray(this.roles)) {
      data['roles'] = [];
      for (let item of this.roles) data['roles'].push(item.toJSON());
    }
    return data;
  }
}

export interface IAdminUserDto {
  id?: string;
  tenantId?: string;
  userName?: string | undefined;
  displayName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  imageUrl?: string | undefined;
  isActive?: boolean;
  emailConfirmed?: boolean;
  roles?: AdminUserRoleDto[];
}

export class AdminUserRoleDto implements IAdminUserRoleDto {
  roleId?: string;
  roleName?: string | undefined;
  description?: string | undefined;
  enabled?: boolean;

  constructor(data?: IAdminUserRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.roleId = _data['roleId'];
      this.roleName = _data['roleName'];
      this.description = _data['description'];
      this.enabled = _data['enabled'];
    }
  }

  static fromJS(data: any): AdminUserRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new AdminUserRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['roleId'] = this.roleId;
    data['roleName'] = this.roleName;
    data['description'] = this.description;
    data['enabled'] = this.enabled;
    return data;
  }
}

export interface IAdminUserRoleDto {
  roleId?: string;
  roleName?: string | undefined;
  description?: string | undefined;
  enabled?: boolean;
}

export class AdminUserLookupDto implements IAdminUserLookupDto {
  id?: string;
  tenantId?: string;
  displayName?: string | undefined;
  userName?: string | undefined;
  email?: string | undefined;
  isActive?: boolean;
  emailConfirmed?: boolean;
  roles?: AdminUserRoleDto[];

  constructor(data?: IAdminUserLookupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.tenantId = _data['tenantId'];
      this.displayName = _data['displayName'];
      this.userName = _data['userName'];
      this.email = _data['email'];
      this.isActive = _data['isActive'];
      this.emailConfirmed = _data['emailConfirmed'];
      if (Array.isArray(_data['roles'])) {
        this.roles = [] as any;
        for (let item of _data['roles'])
          this.roles!.push(AdminUserRoleDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AdminUserLookupDto {
    data = typeof data === 'object' ? data : {};
    let result = new AdminUserLookupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['tenantId'] = this.tenantId;
    data['displayName'] = this.displayName;
    data['userName'] = this.userName;
    data['email'] = this.email;
    data['isActive'] = this.isActive;
    data['emailConfirmed'] = this.emailConfirmed;
    if (Array.isArray(this.roles)) {
      data['roles'] = [];
      for (let item of this.roles) data['roles'].push(item.toJSON());
    }
    return data;
  }
}

export interface IAdminUserLookupDto {
  id?: string;
  tenantId?: string;
  displayName?: string | undefined;
  userName?: string | undefined;
  email?: string | undefined;
  isActive?: boolean;
  emailConfirmed?: boolean;
  roles?: AdminUserRoleDto[];
}

export class AdminCreateUserRequest implements IAdminCreateUserRequest {
  firstName?: string;
  lastName?: string;
  userName?: string;
  email?: string;
  phoneNumber?: string | undefined;
  password?: string;
  confirmPassword?: string;
  isActive?: boolean;
  emailConfirmed?: boolean;
  roleIds?: string[];

  constructor(data?: IAdminCreateUserRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.userName = _data['userName'];
      this.email = _data['email'];
      this.phoneNumber = _data['phoneNumber'];
      this.password = _data['password'];
      this.confirmPassword = _data['confirmPassword'];
      this.isActive = _data['isActive'];
      this.emailConfirmed = _data['emailConfirmed'];
      if (Array.isArray(_data['roleIds'])) {
        this.roleIds = [] as any;
        for (let item of _data['roleIds']) this.roleIds!.push(item);
      }
    }
  }

  static fromJS(data: any): AdminCreateUserRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AdminCreateUserRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['userName'] = this.userName;
    data['email'] = this.email;
    data['phoneNumber'] = this.phoneNumber;
    data['password'] = this.password;
    data['confirmPassword'] = this.confirmPassword;
    data['isActive'] = this.isActive;
    data['emailConfirmed'] = this.emailConfirmed;
    if (Array.isArray(this.roleIds)) {
      data['roleIds'] = [];
      for (let item of this.roleIds) data['roleIds'].push(item);
    }
    return data;
  }
}

export interface IAdminCreateUserRequest {
  firstName?: string;
  lastName?: string;
  userName?: string;
  email?: string;
  phoneNumber?: string | undefined;
  password?: string;
  confirmPassword?: string;
  isActive?: boolean;
  emailConfirmed?: boolean;
  roleIds?: string[];
}

export class AdminUpdateUserRequest implements IAdminUpdateUserRequest {
  firstName?: string;
  lastName?: string;
  userName?: string;
  email?: string;
  phoneNumber?: string | undefined;
  isActive?: boolean;
  emailConfirmed?: boolean;
  roleIds?: string[];

  constructor(data?: IAdminUpdateUserRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.userName = _data['userName'];
      this.email = _data['email'];
      this.phoneNumber = _data['phoneNumber'];
      this.isActive = _data['isActive'];
      this.emailConfirmed = _data['emailConfirmed'];
      if (Array.isArray(_data['roleIds'])) {
        this.roleIds = [] as any;
        for (let item of _data['roleIds']) this.roleIds!.push(item);
      }
    }
  }

  static fromJS(data: any): AdminUpdateUserRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AdminUpdateUserRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['userName'] = this.userName;
    data['email'] = this.email;
    data['phoneNumber'] = this.phoneNumber;
    data['isActive'] = this.isActive;
    data['emailConfirmed'] = this.emailConfirmed;
    if (Array.isArray(this.roleIds)) {
      data['roleIds'] = [];
      for (let item of this.roleIds) data['roleIds'].push(item);
    }
    return data;
  }
}

export interface IAdminUpdateUserRequest {
  firstName?: string;
  lastName?: string;
  userName?: string;
  email?: string;
  phoneNumber?: string | undefined;
  isActive?: boolean;
  emailConfirmed?: boolean;
  roleIds?: string[];
}

export class AdminUpdateUserFlagsRequest
  implements IAdminUpdateUserFlagsRequest
{
  isActive?: boolean | undefined;
  emailConfirmed?: boolean | undefined;

  constructor(data?: IAdminUpdateUserFlagsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isActive = _data['isActive'];
      this.emailConfirmed = _data['emailConfirmed'];
    }
  }

  static fromJS(data: any): AdminUpdateUserFlagsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AdminUpdateUserFlagsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isActive'] = this.isActive;
    data['emailConfirmed'] = this.emailConfirmed;
    return data;
  }
}

export interface IAdminUpdateUserFlagsRequest {
  isActive?: boolean | undefined;
  emailConfirmed?: boolean | undefined;
}

export class AdminUpdateUserRolesRequest
  implements IAdminUpdateUserRolesRequest
{
  roleIds?: string[];
  userRoles?: AdminUserRoleDto[] | undefined;

  constructor(data?: IAdminUpdateUserRolesRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['roleIds'])) {
        this.roleIds = [] as any;
        for (let item of _data['roleIds']) this.roleIds!.push(item);
      }
      if (Array.isArray(_data['userRoles'])) {
        this.userRoles = [] as any;
        for (let item of _data['userRoles'])
          this.userRoles!.push(AdminUserRoleDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AdminUpdateUserRolesRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AdminUpdateUserRolesRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.roleIds)) {
      data['roleIds'] = [];
      for (let item of this.roleIds) data['roleIds'].push(item);
    }
    if (Array.isArray(this.userRoles)) {
      data['userRoles'] = [];
      for (let item of this.userRoles) data['userRoles'].push(item.toJSON());
    }
    return data;
  }
}

export interface IAdminUpdateUserRolesRequest {
  roleIds?: string[];
  userRoles?: AdminUserRoleDto[] | undefined;
}

export class AdminRoleDto implements IAdminRoleDto {
  id?: string;
  tenantId?: string;
  name?: string;
  description?: string | undefined;
  permissions?: string[];

  constructor(data?: IAdminRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.tenantId = _data['tenantId'];
      this.name = _data['name'];
      this.description = _data['description'];
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any;
        for (let item of _data['permissions']) this.permissions!.push(item);
      }
    }
  }

  static fromJS(data: any): AdminRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new AdminRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['tenantId'] = this.tenantId;
    data['name'] = this.name;
    data['description'] = this.description;
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item);
    }
    return data;
  }
}

export interface IAdminRoleDto {
  id?: string;
  tenantId?: string;
  name?: string;
  description?: string | undefined;
  permissions?: string[];
}

export class AdminUpsertRoleRequest implements IAdminUpsertRoleRequest {
  id?: string | undefined;
  name?: string;
  description?: string | undefined;
  permissions?: string[] | undefined;

  constructor(data?: IAdminUpsertRoleRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any;
        for (let item of _data['permissions']) this.permissions!.push(item);
      }
    }
  }

  static fromJS(data: any): AdminUpsertRoleRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AdminUpsertRoleRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item);
    }
    return data;
  }
}

export interface IAdminUpsertRoleRequest {
  id?: string | undefined;
  name?: string;
  description?: string | undefined;
  permissions?: string[] | undefined;
}

export class AdminUpdateRolePermissionsRequest
  implements IAdminUpdateRolePermissionsRequest
{
  permissions?: string[];

  constructor(data?: IAdminUpdateRolePermissionsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any;
        for (let item of _data['permissions']) this.permissions!.push(item);
      }
    }
  }

  static fromJS(data: any): AdminUpdateRolePermissionsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AdminUpdateRolePermissionsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item);
    }
    return data;
  }
}

export interface IAdminUpdateRolePermissionsRequest {
  permissions?: string[];
}

export class CreateContactRequestResponse
  implements ICreateContactRequestResponse
{
  id?: string;
  createdAt?: string;

  constructor(data?: ICreateContactRequestResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.createdAt = _data['createdAt'];
    }
  }

  static fromJS(data: any): CreateContactRequestResponse {
    data = typeof data === 'object' ? data : {};
    let result = new CreateContactRequestResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['createdAt'] = this.createdAt;
    return data;
  }
}

export interface ICreateContactRequestResponse {
  id?: string;
  createdAt?: string;
}

export class CreateContactRequestRequest
  implements ICreateContactRequestRequest
{
  fullName?: string;
  email?: string;
  industry?: string | undefined;
  message?: string;
  host?: string | undefined;
  sourcePage?: string | undefined;

  constructor(data?: ICreateContactRequestRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fullName = _data['fullName'];
      this.email = _data['email'];
      this.industry = _data['industry'];
      this.message = _data['message'];
      this.host = _data['host'];
      this.sourcePage = _data['sourcePage'];
    }
  }

  static fromJS(data: any): CreateContactRequestRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateContactRequestRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['fullName'] = this.fullName;
    data['email'] = this.email;
    data['industry'] = this.industry;
    data['message'] = this.message;
    data['host'] = this.host;
    data['sourcePage'] = this.sourcePage;
    return data;
  }
}

export interface ICreateContactRequestRequest {
  fullName?: string;
  email?: string;
  industry?: string | undefined;
  message?: string;
  host?: string | undefined;
  sourcePage?: string | undefined;
}

export class RealtimeConnectionInfoDto implements IRealtimeConnectionInfoDto {
  hubUrl?: string;
  connectionId?: string | undefined;
  tenantId?: string | undefined;
  userId?: string | undefined;
  serverTime?: string;
  heartbeatIntervalMs?: number;
  serverTimeoutMs?: number;
  qualityThresholds?: RealtimeConnectionQualityThresholdsDto;
  clientEvents?: RealtimeClientEventsDto;

  constructor(data?: IRealtimeConnectionInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hubUrl = _data['hubUrl'];
      this.connectionId = _data['connectionId'];
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
      this.serverTime = _data['serverTime'];
      this.heartbeatIntervalMs = _data['heartbeatIntervalMs'];
      this.serverTimeoutMs = _data['serverTimeoutMs'];
      this.qualityThresholds = _data['qualityThresholds']
        ? RealtimeConnectionQualityThresholdsDto.fromJS(
            _data['qualityThresholds']
          )
        : <any>undefined;
      this.clientEvents = _data['clientEvents']
        ? RealtimeClientEventsDto.fromJS(_data['clientEvents'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): RealtimeConnectionInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new RealtimeConnectionInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['hubUrl'] = this.hubUrl;
    data['connectionId'] = this.connectionId;
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    data['serverTime'] = this.serverTime;
    data['heartbeatIntervalMs'] = this.heartbeatIntervalMs;
    data['serverTimeoutMs'] = this.serverTimeoutMs;
    data['qualityThresholds'] = this.qualityThresholds
      ? this.qualityThresholds.toJSON()
      : <any>undefined;
    data['clientEvents'] = this.clientEvents
      ? this.clientEvents.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IRealtimeConnectionInfoDto {
  hubUrl?: string;
  connectionId?: string | undefined;
  tenantId?: string | undefined;
  userId?: string | undefined;
  serverTime?: string;
  heartbeatIntervalMs?: number;
  serverTimeoutMs?: number;
  qualityThresholds?: RealtimeConnectionQualityThresholdsDto;
  clientEvents?: RealtimeClientEventsDto;
}

export class RealtimeConnectionQualityThresholdsDto
  implements IRealtimeConnectionQualityThresholdsDto
{
  excellentMaxLatencyMs?: number;
  goodMaxLatencyMs?: number;
  poorMaxLatencyMs?: number;

  constructor(data?: IRealtimeConnectionQualityThresholdsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.excellentMaxLatencyMs = _data['excellentMaxLatencyMs'];
      this.goodMaxLatencyMs = _data['goodMaxLatencyMs'];
      this.poorMaxLatencyMs = _data['poorMaxLatencyMs'];
    }
  }

  static fromJS(data: any): RealtimeConnectionQualityThresholdsDto {
    data = typeof data === 'object' ? data : {};
    let result = new RealtimeConnectionQualityThresholdsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['excellentMaxLatencyMs'] = this.excellentMaxLatencyMs;
    data['goodMaxLatencyMs'] = this.goodMaxLatencyMs;
    data['poorMaxLatencyMs'] = this.poorMaxLatencyMs;
    return data;
  }
}

export interface IRealtimeConnectionQualityThresholdsDto {
  excellentMaxLatencyMs?: number;
  goodMaxLatencyMs?: number;
  poorMaxLatencyMs?: number;
}

export class RealtimeClientEventsDto implements IRealtimeClientEventsDto {
  notificationFromServer?: string;
  appNotificationReceived?: string;
  appNotificationRead?: string;
  appNotificationDeleted?: string;
  chatMessageReceived?: string;
  chatConversationUpdated?: string;
  chatConversationRead?: string;
  realtimeConnectionInfo?: string;
  realtimePong?: string;

  constructor(data?: IRealtimeClientEventsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.notificationFromServer = _data['notificationFromServer'];
      this.appNotificationReceived = _data['appNotificationReceived'];
      this.appNotificationRead = _data['appNotificationRead'];
      this.appNotificationDeleted = _data['appNotificationDeleted'];
      this.chatMessageReceived = _data['chatMessageReceived'];
      this.chatConversationUpdated = _data['chatConversationUpdated'];
      this.chatConversationRead = _data['chatConversationRead'];
      this.realtimeConnectionInfo = _data['realtimeConnectionInfo'];
      this.realtimePong = _data['realtimePong'];
    }
  }

  static fromJS(data: any): RealtimeClientEventsDto {
    data = typeof data === 'object' ? data : {};
    let result = new RealtimeClientEventsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['notificationFromServer'] = this.notificationFromServer;
    data['appNotificationReceived'] = this.appNotificationReceived;
    data['appNotificationRead'] = this.appNotificationRead;
    data['appNotificationDeleted'] = this.appNotificationDeleted;
    data['chatMessageReceived'] = this.chatMessageReceived;
    data['chatConversationUpdated'] = this.chatConversationUpdated;
    data['chatConversationRead'] = this.chatConversationRead;
    data['realtimeConnectionInfo'] = this.realtimeConnectionInfo;
    data['realtimePong'] = this.realtimePong;
    return data;
  }
}

export interface IRealtimeClientEventsDto {
  notificationFromServer?: string;
  appNotificationReceived?: string;
  appNotificationRead?: string;
  appNotificationDeleted?: string;
  chatMessageReceived?: string;
  chatConversationUpdated?: string;
  chatConversationRead?: string;
  realtimeConnectionInfo?: string;
  realtimePong?: string;
}

export class GlobalSearchResultDto implements IGlobalSearchResultDto {
  title?: string;
  description?: string | undefined;
  url?: string;
  category?: string;
  keywords?: string[];
  entityType?: string;
  entityId?: string;

  constructor(data?: IGlobalSearchResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data['title'];
      this.description = _data['description'];
      this.url = _data['url'];
      this.category = _data['category'];
      if (Array.isArray(_data['keywords'])) {
        this.keywords = [] as any;
        for (let item of _data['keywords']) this.keywords!.push(item);
      }
      this.entityType = _data['entityType'];
      this.entityId = _data['entityId'];
    }
  }

  static fromJS(data: any): GlobalSearchResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new GlobalSearchResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['title'] = this.title;
    data['description'] = this.description;
    data['url'] = this.url;
    data['category'] = this.category;
    if (Array.isArray(this.keywords)) {
      data['keywords'] = [];
      for (let item of this.keywords) data['keywords'].push(item);
    }
    data['entityType'] = this.entityType;
    data['entityId'] = this.entityId;
    return data;
  }
}

export interface IGlobalSearchResultDto {
  title?: string;
  description?: string | undefined;
  url?: string;
  category?: string;
  keywords?: string[];
  entityType?: string;
  entityId?: string;
}

export class CurrentAppRoutesDto implements ICurrentAppRoutesDto {
  tenantId?: string | undefined;
  publicProfileFriendlyUrl?: string | undefined;
  scope?: string | undefined;
  routes?: AppRouteConfigDto[];

  constructor(data?: ICurrentAppRoutesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data['tenantId'];
      this.publicProfileFriendlyUrl = _data['publicProfileFriendlyUrl'];
      this.scope = _data['scope'];
      if (Array.isArray(_data['routes'])) {
        this.routes = [] as any;
        for (let item of _data['routes'])
          this.routes!.push(AppRouteConfigDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CurrentAppRoutesDto {
    data = typeof data === 'object' ? data : {};
    let result = new CurrentAppRoutesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenantId'] = this.tenantId;
    data['publicProfileFriendlyUrl'] = this.publicProfileFriendlyUrl;
    data['scope'] = this.scope;
    if (Array.isArray(this.routes)) {
      data['routes'] = [];
      for (let item of this.routes) data['routes'].push(item.toJSON());
    }
    return data;
  }
}

export interface ICurrentAppRoutesDto {
  tenantId?: string | undefined;
  publicProfileFriendlyUrl?: string | undefined;
  scope?: string | undefined;
  routes?: AppRouteConfigDto[];
}

export class AppRouteConfigDto implements IAppRouteConfigDto {
  path?: string | undefined;
  layout?: string | undefined;
  element?: string | undefined;
  index?: boolean | undefined;
  requiresAuth?: boolean | undefined;
  requiredPermission?: string | undefined;
  children?: AppRouteConfigDto[] | undefined;

  constructor(data?: IAppRouteConfigDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.path = _data['path'];
      this.layout = _data['layout'];
      this.element = _data['element'];
      this.index = _data['index'];
      this.requiresAuth = _data['requiresAuth'];
      this.requiredPermission = _data['requiredPermission'];
      if (Array.isArray(_data['children'])) {
        this.children = [] as any;
        for (let item of _data['children'])
          this.children!.push(AppRouteConfigDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AppRouteConfigDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppRouteConfigDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['path'] = this.path;
    data['layout'] = this.layout;
    data['element'] = this.element;
    data['index'] = this.index;
    data['requiresAuth'] = this.requiresAuth;
    data['requiredPermission'] = this.requiredPermission;
    if (Array.isArray(this.children)) {
      data['children'] = [];
      for (let item of this.children) data['children'].push(item.toJSON());
    }
    return data;
  }
}

export interface IAppRouteConfigDto {
  path?: string | undefined;
  layout?: string | undefined;
  element?: string | undefined;
  index?: boolean | undefined;
  requiresAuth?: boolean | undefined;
  requiredPermission?: string | undefined;
  children?: AppRouteConfigDto[] | undefined;
}

export class TenantResolveDto implements ITenantResolveDto {
  tenantId?: string;
  id?: string;
  source?: string;
  publicProfileFriendlyUrl?: string | undefined;
  scope?: string | undefined;

  constructor(data?: ITenantResolveDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data['tenantId'];
      this.id = _data['id'];
      this.source = _data['source'];
      this.publicProfileFriendlyUrl = _data['publicProfileFriendlyUrl'];
      this.scope = _data['scope'];
    }
  }

  static fromJS(data: any): TenantResolveDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantResolveDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenantId'] = this.tenantId;
    data['id'] = this.id;
    data['source'] = this.source;
    data['publicProfileFriendlyUrl'] = this.publicProfileFriendlyUrl;
    data['scope'] = this.scope;
    return data;
  }
}

export interface ITenantResolveDto {
  tenantId?: string;
  id?: string;
  source?: string;
  publicProfileFriendlyUrl?: string | undefined;
  scope?: string | undefined;
}

export class TenantDto implements ITenantDto {
  id?: string;
  name?: string;
  connectionString?: string | undefined;
  connectionStringConfigured?: boolean;
  adminEmail?: string;
  databaseType?: string;
  isActive?: boolean;
  validUpto?: string | undefined;
  issuer?: string | undefined;

  constructor(data?: ITenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.connectionString = _data['connectionString'];
      this.connectionStringConfigured = _data['connectionStringConfigured'];
      this.adminEmail = _data['adminEmail'];
      this.databaseType = _data['databaseType'];
      this.isActive = _data['isActive'];
      this.validUpto = _data['validUpto'];
      this.issuer = _data['issuer'];
    }
  }

  static fromJS(data: any): TenantDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['connectionString'] = this.connectionString;
    data['connectionStringConfigured'] = this.connectionStringConfigured;
    data['adminEmail'] = this.adminEmail;
    data['databaseType'] = this.databaseType;
    data['isActive'] = this.isActive;
    data['validUpto'] = this.validUpto;
    data['issuer'] = this.issuer;
    return data;
  }
}

export interface ITenantDto {
  id?: string;
  name?: string;
  connectionString?: string | undefined;
  connectionStringConfigured?: boolean;
  adminEmail?: string;
  databaseType?: string;
  isActive?: boolean;
  validUpto?: string | undefined;
  issuer?: string | undefined;
}

export class CreateTenantRequest implements ICreateTenantRequest {
  id!: string;
  name!: string;
  databaseType!: string;
  connectionString?: string | undefined;
  adminEmail!: string;
  issuer?: string | undefined;
  validUpto?: string | undefined;

  constructor(data?: ICreateTenantRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.databaseType = _data['databaseType'];
      this.connectionString = _data['connectionString'];
      this.adminEmail = _data['adminEmail'];
      this.issuer = _data['issuer'];
      this.validUpto = _data['validUpto'];
    }
  }

  static fromJS(data: any): CreateTenantRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateTenantRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['databaseType'] = this.databaseType;
    data['connectionString'] = this.connectionString;
    data['adminEmail'] = this.adminEmail;
    data['issuer'] = this.issuer;
    data['validUpto'] = this.validUpto;
    return data;
  }
}

export interface ICreateTenantRequest {
  id: string;
  name: string;
  databaseType: string;
  connectionString?: string | undefined;
  adminEmail: string;
  issuer?: string | undefined;
  validUpto?: string | undefined;
}

export class UpdateTenantRequest implements IUpdateTenantRequest {
  id!: string;
  name!: string;
  databaseType!: string;
  connectionString?: string | undefined;
  adminEmail!: string;
  issuer?: string | undefined;
  validUpto?: string | undefined;

  constructor(data?: IUpdateTenantRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.databaseType = _data['databaseType'];
      this.connectionString = _data['connectionString'];
      this.adminEmail = _data['adminEmail'];
      this.issuer = _data['issuer'];
      this.validUpto = _data['validUpto'];
    }
  }

  static fromJS(data: any): UpdateTenantRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateTenantRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['databaseType'] = this.databaseType;
    data['connectionString'] = this.connectionString;
    data['adminEmail'] = this.adminEmail;
    data['issuer'] = this.issuer;
    data['validUpto'] = this.validUpto;
    return data;
  }
}

export interface IUpdateTenantRequest {
  id: string;
  name: string;
  databaseType: string;
  connectionString?: string | undefined;
  adminEmail: string;
  issuer?: string | undefined;
  validUpto?: string | undefined;
}

export class UpgradeSubscriptionRequest implements IUpgradeSubscriptionRequest {
  tenantId!: string;
  extendedExpiryDate?: string;

  constructor(data?: IUpgradeSubscriptionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data['tenantId'];
      this.extendedExpiryDate = _data['extendedExpiryDate'];
    }
  }

  static fromJS(data: any): UpgradeSubscriptionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpgradeSubscriptionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenantId'] = this.tenantId;
    data['extendedExpiryDate'] = this.extendedExpiryDate;
    return data;
  }
}

export interface IUpgradeSubscriptionRequest {
  tenantId: string;
  extendedExpiryDate?: string;
}

export class PermissionCatalogItemDto implements IPermissionCatalogItemDto {
  name?: string;
  resource?: string;
  action?: string;
  description?: string | undefined;
  group?: string | undefined;
  isRoot?: boolean;
  isBasic?: boolean;

  constructor(data?: IPermissionCatalogItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.resource = _data['resource'];
      this.action = _data['action'];
      this.description = _data['description'];
      this.group = _data['group'];
      this.isRoot = _data['isRoot'];
      this.isBasic = _data['isBasic'];
    }
  }

  static fromJS(data: any): PermissionCatalogItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new PermissionCatalogItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['resource'] = this.resource;
    data['action'] = this.action;
    data['description'] = this.description;
    data['group'] = this.group;
    data['isRoot'] = this.isRoot;
    data['isBasic'] = this.isBasic;
    return data;
  }
}

export interface IPermissionCatalogItemDto {
  name?: string;
  resource?: string;
  action?: string;
  description?: string | undefined;
  group?: string | undefined;
  isRoot?: boolean;
  isBasic?: boolean;
}

export class RoleDto implements IRoleDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  permissions?: string[] | undefined;

  constructor(data?: IRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any;
        for (let item of _data['permissions']) this.permissions!.push(item);
      }
    }
  }

  static fromJS(data: any): RoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new RoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item);
    }
    return data;
  }
}

export interface IRoleDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  permissions?: string[] | undefined;
}

export class UpdateRolePermissionsRequest
  implements IUpdateRolePermissionsRequest
{
  roleId!: string;
  permissions!: string[];

  constructor(data?: IUpdateRolePermissionsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.permissions = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.roleId = _data['roleId'];
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any;
        for (let item of _data['permissions']) this.permissions!.push(item);
      }
    }
  }

  static fromJS(data: any): UpdateRolePermissionsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateRolePermissionsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['roleId'] = this.roleId;
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item);
    }
    return data;
  }
}

export interface IUpdateRolePermissionsRequest {
  roleId: string;
  permissions: string[];
}

export class CreateOrUpdateRoleRequest implements ICreateOrUpdateRoleRequest {
  id?: string | undefined;
  name!: string;
  description?: string | undefined;

  constructor(data?: ICreateOrUpdateRoleRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): CreateOrUpdateRoleRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrUpdateRoleRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    return data;
  }
}

export interface ICreateOrUpdateRoleRequest {
  id?: string | undefined;
  name: string;
  description?: string | undefined;
}

export class TokenResponse implements ITokenResponse {
  token?: string;
  refreshToken?: string;
  refreshTokenExpiryTime?: string;

  constructor(data?: ITokenResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data['token'];
      this.refreshToken = _data['refreshToken'];
      this.refreshTokenExpiryTime = _data['refreshTokenExpiryTime'];
    }
  }

  static fromJS(data: any): TokenResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TokenResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['token'] = this.token;
    data['refreshToken'] = this.refreshToken;
    data['refreshTokenExpiryTime'] = this.refreshTokenExpiryTime;
    return data;
  }
}

export interface ITokenResponse {
  token?: string;
  refreshToken?: string;
  refreshTokenExpiryTime?: string;
}

export class TokenRequest implements ITokenRequest {
  email!: string;
  password!: string;
  tenantId?: string | undefined;

  constructor(data?: ITokenRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data['email'];
      this.password = _data['password'];
      this.tenantId = _data['tenantId'];
    }
  }

  static fromJS(data: any): TokenRequest {
    data = typeof data === 'object' ? data : {};
    let result = new TokenRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['email'] = this.email;
    data['password'] = this.password;
    data['tenantId'] = this.tenantId;
    return data;
  }
}

export interface ITokenRequest {
  email: string;
  password: string;
  tenantId?: string | undefined;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
  token?: string;
  refreshToken?: string;
  tenantId?: string | undefined;

  constructor(data?: IRefreshTokenRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data['token'];
      this.refreshToken = _data['refreshToken'];
      this.tenantId = _data['tenantId'];
    }
  }

  static fromJS(data: any): RefreshTokenRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RefreshTokenRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['token'] = this.token;
    data['refreshToken'] = this.refreshToken;
    data['tenantId'] = this.tenantId;
    return data;
  }
}

export interface IRefreshTokenRequest {
  token?: string;
  refreshToken?: string;
  tenantId?: string | undefined;
}

export class UserDetailsDto implements IUserDetailsDto {
  id?: string;
  userName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  displayName?: string | undefined;
  email?: string | undefined;
  isActive?: boolean;
  emailConfirmed?: boolean;
  phoneNumber?: string | undefined;
  imageUrl?: string | undefined;
  departmentId?: string | undefined;
  departmentName?: string | undefined;
  teamId?: string | undefined;
  teamName?: string | undefined;
  defaultPositionId?: string | undefined;
  defaultPositionName?: string | undefined;
  positionIds?: string[];
  positions?: UserPositionDto[];
  signature?: string | undefined;
  settings?: UserProfileSettingsDto;

  constructor(data?: IUserDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userName = _data['userName'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.displayName = _data['displayName'];
      this.email = _data['email'];
      this.isActive = _data['isActive'];
      this.emailConfirmed = _data['emailConfirmed'];
      this.phoneNumber = _data['phoneNumber'];
      this.imageUrl = _data['imageUrl'];
      this.departmentId = _data['departmentId'];
      this.departmentName = _data['departmentName'];
      this.teamId = _data['teamId'];
      this.teamName = _data['teamName'];
      this.defaultPositionId = _data['defaultPositionId'];
      this.defaultPositionName = _data['defaultPositionName'];
      if (Array.isArray(_data['positionIds'])) {
        this.positionIds = [] as any;
        for (let item of _data['positionIds']) this.positionIds!.push(item);
      }
      if (Array.isArray(_data['positions'])) {
        this.positions = [] as any;
        for (let item of _data['positions'])
          this.positions!.push(UserPositionDto.fromJS(item));
      }
      this.signature = _data['signature'];
      this.settings = _data['settings']
        ? UserProfileSettingsDto.fromJS(_data['settings'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): UserDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userName'] = this.userName;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['displayName'] = this.displayName;
    data['email'] = this.email;
    data['isActive'] = this.isActive;
    data['emailConfirmed'] = this.emailConfirmed;
    data['phoneNumber'] = this.phoneNumber;
    data['imageUrl'] = this.imageUrl;
    data['departmentId'] = this.departmentId;
    data['departmentName'] = this.departmentName;
    data['teamId'] = this.teamId;
    data['teamName'] = this.teamName;
    data['defaultPositionId'] = this.defaultPositionId;
    data['defaultPositionName'] = this.defaultPositionName;
    if (Array.isArray(this.positionIds)) {
      data['positionIds'] = [];
      for (let item of this.positionIds) data['positionIds'].push(item);
    }
    if (Array.isArray(this.positions)) {
      data['positions'] = [];
      for (let item of this.positions) data['positions'].push(item.toJSON());
    }
    data['signature'] = this.signature;
    data['settings'] = this.settings ? this.settings.toJSON() : <any>undefined;
    return data;
  }
}

export interface IUserDetailsDto {
  id?: string;
  userName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  displayName?: string | undefined;
  email?: string | undefined;
  isActive?: boolean;
  emailConfirmed?: boolean;
  phoneNumber?: string | undefined;
  imageUrl?: string | undefined;
  departmentId?: string | undefined;
  departmentName?: string | undefined;
  teamId?: string | undefined;
  teamName?: string | undefined;
  defaultPositionId?: string | undefined;
  defaultPositionName?: string | undefined;
  positionIds?: string[];
  positions?: UserPositionDto[];
  signature?: string | undefined;
  settings?: UserProfileSettingsDto;
}

export class UserPositionDto implements IUserPositionDto {
  id?: string;
  key?: string;
  name?: string;

  constructor(data?: IUserPositionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.key = _data['key'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): UserPositionDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserPositionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['key'] = this.key;
    data['name'] = this.name;
    return data;
  }
}

export interface IUserPositionDto {
  id?: string;
  key?: string;
  name?: string;
}

export class UserProfileSettingsDto implements IUserProfileSettingsDto {
  isFullWidth?: boolean;
  defaultView?: string;
  density?: string;
  language?: string;
  timezone?: string;
  dateFormat?: string;
  availability?: string;
  defaultPositionId?: string | undefined;
  defaultPositionName?: string | undefined;
  quickActions?: string[];
  emailNotifications?: boolean;
  smsNotifications?: boolean;
  pushNotifications?: boolean;
  newOrderNotification?: boolean;
  commentNotification?: boolean;
  statusNotification?: boolean;
  reminderNotification?: boolean;
  dailySummary?: boolean;
  showPhoneToTeam?: boolean;
  showAvailability?: boolean;
  requireConfirmForStatusChange?: boolean;
  compactOrderCards?: boolean;
  autoAssignCreatedOrders?: boolean;

  constructor(data?: IUserProfileSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isFullWidth = _data['isFullWidth'];
      this.defaultView = _data['defaultView'];
      this.density = _data['density'];
      this.language = _data['language'];
      this.timezone = _data['timezone'];
      this.dateFormat = _data['dateFormat'];
      this.availability = _data['availability'];
      this.defaultPositionId = _data['defaultPositionId'];
      this.defaultPositionName = _data['defaultPositionName'];
      if (Array.isArray(_data['quickActions'])) {
        this.quickActions = [] as any;
        for (let item of _data['quickActions']) this.quickActions!.push(item);
      }
      this.emailNotifications = _data['emailNotifications'];
      this.smsNotifications = _data['smsNotifications'];
      this.pushNotifications = _data['pushNotifications'];
      this.newOrderNotification = _data['newOrderNotification'];
      this.commentNotification = _data['commentNotification'];
      this.statusNotification = _data['statusNotification'];
      this.reminderNotification = _data['reminderNotification'];
      this.dailySummary = _data['dailySummary'];
      this.showPhoneToTeam = _data['showPhoneToTeam'];
      this.showAvailability = _data['showAvailability'];
      this.requireConfirmForStatusChange =
        _data['requireConfirmForStatusChange'];
      this.compactOrderCards = _data['compactOrderCards'];
      this.autoAssignCreatedOrders = _data['autoAssignCreatedOrders'];
    }
  }

  static fromJS(data: any): UserProfileSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserProfileSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isFullWidth'] = this.isFullWidth;
    data['defaultView'] = this.defaultView;
    data['density'] = this.density;
    data['language'] = this.language;
    data['timezone'] = this.timezone;
    data['dateFormat'] = this.dateFormat;
    data['availability'] = this.availability;
    data['defaultPositionId'] = this.defaultPositionId;
    data['defaultPositionName'] = this.defaultPositionName;
    if (Array.isArray(this.quickActions)) {
      data['quickActions'] = [];
      for (let item of this.quickActions) data['quickActions'].push(item);
    }
    data['emailNotifications'] = this.emailNotifications;
    data['smsNotifications'] = this.smsNotifications;
    data['pushNotifications'] = this.pushNotifications;
    data['newOrderNotification'] = this.newOrderNotification;
    data['commentNotification'] = this.commentNotification;
    data['statusNotification'] = this.statusNotification;
    data['reminderNotification'] = this.reminderNotification;
    data['dailySummary'] = this.dailySummary;
    data['showPhoneToTeam'] = this.showPhoneToTeam;
    data['showAvailability'] = this.showAvailability;
    data['requireConfirmForStatusChange'] = this.requireConfirmForStatusChange;
    data['compactOrderCards'] = this.compactOrderCards;
    data['autoAssignCreatedOrders'] = this.autoAssignCreatedOrders;
    return data;
  }
}

export interface IUserProfileSettingsDto {
  isFullWidth?: boolean;
  defaultView?: string;
  density?: string;
  language?: string;
  timezone?: string;
  dateFormat?: string;
  availability?: string;
  defaultPositionId?: string | undefined;
  defaultPositionName?: string | undefined;
  quickActions?: string[];
  emailNotifications?: boolean;
  smsNotifications?: boolean;
  pushNotifications?: boolean;
  newOrderNotification?: boolean;
  commentNotification?: boolean;
  statusNotification?: boolean;
  reminderNotification?: boolean;
  dailySummary?: boolean;
  showPhoneToTeam?: boolean;
  showAvailability?: boolean;
  requireConfirmForStatusChange?: boolean;
  compactOrderCards?: boolean;
  autoAssignCreatedOrders?: boolean;
}

export class UserRoleDto implements IUserRoleDto {
  roleId?: string | undefined;
  roleName?: string | undefined;
  description?: string | undefined;
  enabled?: boolean;

  constructor(data?: IUserRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.roleId = _data['roleId'];
      this.roleName = _data['roleName'];
      this.description = _data['description'];
      this.enabled = _data['enabled'];
    }
  }

  static fromJS(data: any): UserRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['roleId'] = this.roleId;
    data['roleName'] = this.roleName;
    data['description'] = this.description;
    data['enabled'] = this.enabled;
    return data;
  }
}

export interface IUserRoleDto {
  roleId?: string | undefined;
  roleName?: string | undefined;
  description?: string | undefined;
  enabled?: boolean;
}

export class UserRolesRequest implements IUserRolesRequest {
  userRoles?: UserRoleDto[];

  constructor(data?: IUserRolesRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['userRoles'])) {
        this.userRoles = [] as any;
        for (let item of _data['userRoles'])
          this.userRoles!.push(UserRoleDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UserRolesRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UserRolesRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.userRoles)) {
      data['userRoles'] = [];
      for (let item of this.userRoles) data['userRoles'].push(item.toJSON());
    }
    return data;
  }
}

export interface IUserRolesRequest {
  userRoles?: UserRoleDto[];
}

export class CreateUserRequest implements ICreateUserRequest {
  firstName!: string;
  lastName!: string;
  displayName?: string | undefined;
  email!: string;
  userName!: string;
  password!: string;
  confirmPassword!: string;
  phoneNumber?: string | undefined;
  departmentId?: string | undefined;
  teamId?: string | undefined;
  defaultPositionId?: string | undefined;
  positionIds?: string[];
  signature?: string | undefined;

  constructor(data?: ICreateUserRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.displayName = _data['displayName'];
      this.email = _data['email'];
      this.userName = _data['userName'];
      this.password = _data['password'];
      this.confirmPassword = _data['confirmPassword'];
      this.phoneNumber = _data['phoneNumber'];
      this.departmentId = _data['departmentId'];
      this.teamId = _data['teamId'];
      this.defaultPositionId = _data['defaultPositionId'];
      if (Array.isArray(_data['positionIds'])) {
        this.positionIds = [] as any;
        for (let item of _data['positionIds']) this.positionIds!.push(item);
      }
      this.signature = _data['signature'];
    }
  }

  static fromJS(data: any): CreateUserRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateUserRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['displayName'] = this.displayName;
    data['email'] = this.email;
    data['userName'] = this.userName;
    data['password'] = this.password;
    data['confirmPassword'] = this.confirmPassword;
    data['phoneNumber'] = this.phoneNumber;
    data['departmentId'] = this.departmentId;
    data['teamId'] = this.teamId;
    data['defaultPositionId'] = this.defaultPositionId;
    if (Array.isArray(this.positionIds)) {
      data['positionIds'] = [];
      for (let item of this.positionIds) data['positionIds'].push(item);
    }
    data['signature'] = this.signature;
    return data;
  }
}

export interface ICreateUserRequest {
  firstName: string;
  lastName: string;
  displayName?: string | undefined;
  email: string;
  userName: string;
  password: string;
  confirmPassword: string;
  phoneNumber?: string | undefined;
  departmentId?: string | undefined;
  teamId?: string | undefined;
  defaultPositionId?: string | undefined;
  positionIds?: string[];
  signature?: string | undefined;
}

export class UpdateUserRequest implements IUpdateUserRequest {
  id!: string;
  firstName!: string;
  lastName!: string;
  displayName?: string | undefined;
  phoneNumber?: string | undefined;
  email!: string;
  departmentId?: string | undefined;
  teamId?: string | undefined;
  defaultPositionId?: string | undefined;
  positionIds?: string[];
  signature?: string | undefined;
  image?: FileUploadRequest | undefined;
  deleteCurrentImage?: boolean;

  constructor(data?: IUpdateUserRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.displayName = _data['displayName'];
      this.phoneNumber = _data['phoneNumber'];
      this.email = _data['email'];
      this.departmentId = _data['departmentId'];
      this.teamId = _data['teamId'];
      this.defaultPositionId = _data['defaultPositionId'];
      if (Array.isArray(_data['positionIds'])) {
        this.positionIds = [] as any;
        for (let item of _data['positionIds']) this.positionIds!.push(item);
      }
      this.signature = _data['signature'];
      this.image = _data['image']
        ? FileUploadRequest.fromJS(_data['image'])
        : <any>undefined;
      this.deleteCurrentImage = _data['deleteCurrentImage'];
    }
  }

  static fromJS(data: any): UpdateUserRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateUserRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['displayName'] = this.displayName;
    data['phoneNumber'] = this.phoneNumber;
    data['email'] = this.email;
    data['departmentId'] = this.departmentId;
    data['teamId'] = this.teamId;
    data['defaultPositionId'] = this.defaultPositionId;
    if (Array.isArray(this.positionIds)) {
      data['positionIds'] = [];
      for (let item of this.positionIds) data['positionIds'].push(item);
    }
    data['signature'] = this.signature;
    data['image'] = this.image ? this.image.toJSON() : <any>undefined;
    data['deleteCurrentImage'] = this.deleteCurrentImage;
    return data;
  }
}

export interface IUpdateUserRequest {
  id: string;
  firstName: string;
  lastName: string;
  displayName?: string | undefined;
  phoneNumber?: string | undefined;
  email: string;
  departmentId?: string | undefined;
  teamId?: string | undefined;
  defaultPositionId?: string | undefined;
  positionIds?: string[];
  signature?: string | undefined;
  image?: FileUploadRequest | undefined;
  deleteCurrentImage?: boolean;
}

export class FileUploadRequest implements IFileUploadRequest {
  name!: string;
  extension!: string;
  data!: string;

  constructor(data?: IFileUploadRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.extension = _data['extension'];
      this.data = _data['data'];
    }
  }

  static fromJS(data: any): FileUploadRequest {
    data = typeof data === 'object' ? data : {};
    let result = new FileUploadRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['extension'] = this.extension;
    data['data'] = this.data;
    return data;
  }
}

export interface IFileUploadRequest {
  name: string;
  extension: string;
  data: string;
}

export class PublicUserRegistrationResponse
  implements IPublicUserRegistrationResponse
{
  tenantId?: string;
  userId?: string;

  constructor(data?: IPublicUserRegistrationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): PublicUserRegistrationResponse {
    data = typeof data === 'object' ? data : {};
    let result = new PublicUserRegistrationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IPublicUserRegistrationResponse {
  tenantId?: string;
  userId?: string;
}

export class RegisterCompanyRequest implements IRegisterCompanyRequest {
  companyName?: string;
  tenantId?: string | undefined;
  owner?: RegisterCompanyOwnerRequest;

  constructor(data?: IRegisterCompanyRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyName = _data['companyName'];
      this.tenantId = _data['tenantId'];
      this.owner = _data['owner']
        ? RegisterCompanyOwnerRequest.fromJS(_data['owner'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): RegisterCompanyRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterCompanyRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['companyName'] = this.companyName;
    data['tenantId'] = this.tenantId;
    data['owner'] = this.owner ? this.owner.toJSON() : <any>undefined;
    return data;
  }
}

export interface IRegisterCompanyRequest {
  companyName?: string;
  tenantId?: string | undefined;
  owner?: RegisterCompanyOwnerRequest;
}

export class RegisterCompanyOwnerRequest
  implements IRegisterCompanyOwnerRequest
{
  firstName?: string;
  lastName?: string;
  email?: string;
  userName?: string;
  password?: string;
  confirmPassword?: string;

  constructor(data?: IRegisterCompanyOwnerRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.email = _data['email'];
      this.userName = _data['userName'];
      this.password = _data['password'];
      this.confirmPassword = _data['confirmPassword'];
    }
  }

  static fromJS(data: any): RegisterCompanyOwnerRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterCompanyOwnerRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['email'] = this.email;
    data['userName'] = this.userName;
    data['password'] = this.password;
    data['confirmPassword'] = this.confirmPassword;
    return data;
  }
}

export interface IRegisterCompanyOwnerRequest {
  firstName?: string;
  lastName?: string;
  email?: string;
  userName?: string;
  password?: string;
  confirmPassword?: string;
}

export class AcceptInvitationRequest implements IAcceptInvitationRequest {
  invitationToken?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  userName?: string;
  password?: string;
  confirmPassword?: string;

  constructor(data?: IAcceptInvitationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.invitationToken = _data['invitationToken'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.email = _data['email'];
      this.userName = _data['userName'];
      this.password = _data['password'];
      this.confirmPassword = _data['confirmPassword'];
    }
  }

  static fromJS(data: any): AcceptInvitationRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AcceptInvitationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['invitationToken'] = this.invitationToken;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['email'] = this.email;
    data['userName'] = this.userName;
    data['password'] = this.password;
    data['confirmPassword'] = this.confirmPassword;
    return data;
  }
}

export interface IAcceptInvitationRequest {
  invitationToken?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  userName?: string;
  password?: string;
  confirmPassword?: string;
}

export class ToggleUserStatusRequest implements IToggleUserStatusRequest {
  activateUser?: boolean;
  userId?: string | undefined;

  constructor(data?: IToggleUserStatusRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.activateUser = _data['activateUser'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): ToggleUserStatusRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ToggleUserStatusRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['activateUser'] = this.activateUser;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IToggleUserStatusRequest {
  activateUser?: boolean;
  userId?: string | undefined;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
  email!: string;

  constructor(data?: IForgotPasswordRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data['email'];
    }
  }

  static fromJS(data: any): ForgotPasswordRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ForgotPasswordRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['email'] = this.email;
    return data;
  }
}

export interface IForgotPasswordRequest {
  email: string;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
  email?: string | undefined;
  password?: string | undefined;
  token?: string | undefined;

  constructor(data?: IResetPasswordRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data['email'];
      this.password = _data['password'];
      this.token = _data['token'];
    }
  }

  static fromJS(data: any): ResetPasswordRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ResetPasswordRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['email'] = this.email;
    data['password'] = this.password;
    data['token'] = this.token;
    return data;
  }
}

export interface IResetPasswordRequest {
  email?: string | undefined;
  password?: string | undefined;
  token?: string | undefined;
}

export class UpdatePersonalProfileRequest
  implements IUpdatePersonalProfileRequest
{
  firstName!: string;
  lastName!: string;
  displayName?: string | undefined;
  phoneNumber?: string | undefined;
  email!: string;
  departmentId?: string | undefined;
  teamId?: string | undefined;
  defaultPositionId?: string | undefined;
  positionIds?: string[];
  signature?: string | undefined;
  image?: FileUploadRequest | undefined;
  deleteCurrentImage?: boolean;

  constructor(data?: IUpdatePersonalProfileRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.displayName = _data['displayName'];
      this.phoneNumber = _data['phoneNumber'];
      this.email = _data['email'];
      this.departmentId = _data['departmentId'];
      this.teamId = _data['teamId'];
      this.defaultPositionId = _data['defaultPositionId'];
      if (Array.isArray(_data['positionIds'])) {
        this.positionIds = [] as any;
        for (let item of _data['positionIds']) this.positionIds!.push(item);
      }
      this.signature = _data['signature'];
      this.image = _data['image']
        ? FileUploadRequest.fromJS(_data['image'])
        : <any>undefined;
      this.deleteCurrentImage = _data['deleteCurrentImage'];
    }
  }

  static fromJS(data: any): UpdatePersonalProfileRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdatePersonalProfileRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['displayName'] = this.displayName;
    data['phoneNumber'] = this.phoneNumber;
    data['email'] = this.email;
    data['departmentId'] = this.departmentId;
    data['teamId'] = this.teamId;
    data['defaultPositionId'] = this.defaultPositionId;
    if (Array.isArray(this.positionIds)) {
      data['positionIds'] = [];
      for (let item of this.positionIds) data['positionIds'].push(item);
    }
    data['signature'] = this.signature;
    data['image'] = this.image ? this.image.toJSON() : <any>undefined;
    data['deleteCurrentImage'] = this.deleteCurrentImage;
    return data;
  }
}

export interface IUpdatePersonalProfileRequest {
  firstName: string;
  lastName: string;
  displayName?: string | undefined;
  phoneNumber?: string | undefined;
  email: string;
  departmentId?: string | undefined;
  teamId?: string | undefined;
  defaultPositionId?: string | undefined;
  positionIds?: string[];
  signature?: string | undefined;
  image?: FileUploadRequest | undefined;
  deleteCurrentImage?: boolean;
}

export class UpdateUserProfileSettingsRequest
  extends UserProfileSettingsDto
  implements IUpdateUserProfileSettingsRequest
{
  constructor(data?: IUpdateUserProfileSettingsRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
  }

  static fromJS(data: any): UpdateUserProfileSettingsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateUserProfileSettingsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IUpdateUserProfileSettingsRequest
  extends IUserProfileSettingsDto {}

export class PageLayoutConfigDto implements IPageLayoutConfigDto {
  scope?: string;
  source?: string;
  config?: any;
  configJson?: string;
  updatedAt?: string;

  constructor(data?: IPageLayoutConfigDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.scope = _data['scope'];
      this.source = _data['source'];
      this.config = _data['config'];
      this.configJson = _data['configJson'];
      this.updatedAt = _data['updatedAt'];
    }
  }

  static fromJS(data: any): PageLayoutConfigDto {
    data = typeof data === 'object' ? data : {};
    let result = new PageLayoutConfigDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['scope'] = this.scope;
    data['source'] = this.source;
    data['config'] = this.config;
    data['configJson'] = this.configJson;
    data['updatedAt'] = this.updatedAt;
    return data;
  }
}

export interface IPageLayoutConfigDto {
  scope?: string;
  source?: string;
  config?: any;
  configJson?: string;
  updatedAt?: string;
}

export class UpsertPageLayoutConfigRequest
  implements IUpsertPageLayoutConfigRequest
{
  scope!: string;
  config?: any | undefined;
  configJson?: string | undefined;

  constructor(data?: IUpsertPageLayoutConfigRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.scope = _data['scope'];
      this.config = _data['config'];
      this.configJson = _data['configJson'];
    }
  }

  static fromJS(data: any): UpsertPageLayoutConfigRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpsertPageLayoutConfigRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['scope'] = this.scope;
    data['config'] = this.config;
    data['configJson'] = this.configJson;
    return data;
  }
}

export interface IUpsertPageLayoutConfigRequest {
  scope: string;
  config?: any | undefined;
  configJson?: string | undefined;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
  password!: string;
  newPassword!: string;
  confirmNewPassword?: string;

  constructor(data?: IChangePasswordRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.password = _data['password'];
      this.newPassword = _data['newPassword'];
      this.confirmNewPassword = _data['confirmNewPassword'];
    }
  }

  static fromJS(data: any): ChangePasswordRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ChangePasswordRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['password'] = this.password;
    data['newPassword'] = this.newPassword;
    data['confirmNewPassword'] = this.confirmNewPassword;
    return data;
  }
}

export interface IChangePasswordRequest {
  password: string;
  newPassword: string;
  confirmNewPassword?: string;
}

export class AuditDto implements IAuditDto {
  id?: string;
  userId?: string;
  type?: string | undefined;
  tableName?: string | undefined;
  dateTime?: string;
  oldValues?: string | undefined;
  newValues?: string | undefined;
  affectedColumns?: string | undefined;
  primaryKey?: string | undefined;

  constructor(data?: IAuditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userId = _data['userId'];
      this.type = _data['type'];
      this.tableName = _data['tableName'];
      this.dateTime = _data['dateTime'];
      this.oldValues = _data['oldValues'];
      this.newValues = _data['newValues'];
      this.affectedColumns = _data['affectedColumns'];
      this.primaryKey = _data['primaryKey'];
    }
  }

  static fromJS(data: any): AuditDto {
    data = typeof data === 'object' ? data : {};
    let result = new AuditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userId'] = this.userId;
    data['type'] = this.type;
    data['tableName'] = this.tableName;
    data['dateTime'] = this.dateTime;
    data['oldValues'] = this.oldValues;
    data['newValues'] = this.newValues;
    data['affectedColumns'] = this.affectedColumns;
    data['primaryKey'] = this.primaryKey;
    return data;
  }
}

export interface IAuditDto {
  id?: string;
  userId?: string;
  type?: string | undefined;
  tableName?: string | undefined;
  dateTime?: string;
  oldValues?: string | undefined;
  newValues?: string | undefined;
  affectedColumns?: string | undefined;
  primaryKey?: string | undefined;
}

export class StatsDto implements IStatsDto {
  serviceOrderCount?: number;
  customerCount?: number;
  userCount?: number;
  roleCount?: number;
  dataEnterBarChart?: ChartSeries[];

  constructor(data?: IStatsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceOrderCount = _data['serviceOrderCount'];
      this.customerCount = _data['customerCount'];
      this.userCount = _data['userCount'];
      this.roleCount = _data['roleCount'];
      if (Array.isArray(_data['dataEnterBarChart'])) {
        this.dataEnterBarChart = [] as any;
        for (let item of _data['dataEnterBarChart'])
          this.dataEnterBarChart!.push(ChartSeries.fromJS(item));
      }
    }
  }

  static fromJS(data: any): StatsDto {
    data = typeof data === 'object' ? data : {};
    let result = new StatsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['serviceOrderCount'] = this.serviceOrderCount;
    data['customerCount'] = this.customerCount;
    data['userCount'] = this.userCount;
    data['roleCount'] = this.roleCount;
    if (Array.isArray(this.dataEnterBarChart)) {
      data['dataEnterBarChart'] = [];
      for (let item of this.dataEnterBarChart)
        data['dataEnterBarChart'].push(item.toJSON());
    }
    return data;
  }
}

export interface IStatsDto {
  serviceOrderCount?: number;
  customerCount?: number;
  userCount?: number;
  roleCount?: number;
  dataEnterBarChart?: ChartSeries[];
}

export class ChartSeries implements IChartSeries {
  name?: string | undefined;
  data?: number[] | undefined;

  constructor(data?: IChartSeries) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(item);
      }
    }
  }

  static fromJS(data: any): ChartSeries {
    data = typeof data === 'object' ? data : {};
    let result = new ChartSeries();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item);
    }
    return data;
  }
}

export interface IChartSeries {
  name?: string | undefined;
  data?: number[] | undefined;
}

export class PaginationResponseOfAppNotificationDto
  implements IPaginationResponseOfAppNotificationDto
{
  data?: AppNotificationDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfAppNotificationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(AppNotificationDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfAppNotificationDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfAppNotificationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfAppNotificationDto {
  data?: AppNotificationDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class AppNotificationDto implements IAppNotificationDto {
  id?: string;
  title?: string;
  content?: string;
  message?: string;
  type?: string;
  severity?: string;
  status?: string;
  url?: string | undefined;
  sourceType?: string | undefined;
  sourceId?: string | undefined;
  userId?: string | undefined;
  timestamp?: string;
  createdAt?: string;
  readOn?: string | undefined;
  isRead?: boolean;

  constructor(data?: IAppNotificationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.title = _data['title'];
      this.content = _data['content'];
      this.message = _data['message'];
      this.type = _data['type'];
      this.severity = _data['severity'];
      this.status = _data['status'];
      this.url = _data['url'];
      this.sourceType = _data['sourceType'];
      this.sourceId = _data['sourceId'];
      this.userId = _data['userId'];
      this.timestamp = _data['timestamp'];
      this.createdAt = _data['createdAt'];
      this.readOn = _data['readOn'];
      this.isRead = _data['isRead'];
    }
  }

  static fromJS(data: any): AppNotificationDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppNotificationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['title'] = this.title;
    data['content'] = this.content;
    data['message'] = this.message;
    data['type'] = this.type;
    data['severity'] = this.severity;
    data['status'] = this.status;
    data['url'] = this.url;
    data['sourceType'] = this.sourceType;
    data['sourceId'] = this.sourceId;
    data['userId'] = this.userId;
    data['timestamp'] = this.timestamp;
    data['createdAt'] = this.createdAt;
    data['readOn'] = this.readOn;
    data['isRead'] = this.isRead;
    return data;
  }
}

export interface IAppNotificationDto {
  id?: string;
  title?: string;
  content?: string;
  message?: string;
  type?: string;
  severity?: string;
  status?: string;
  url?: string | undefined;
  sourceType?: string | undefined;
  sourceId?: string | undefined;
  userId?: string | undefined;
  timestamp?: string;
  createdAt?: string;
  readOn?: string | undefined;
  isRead?: boolean;
}

export class BaseFilter implements IBaseFilter {
  /** Column Wise Search is Supported. */
  advancedSearch?: Search | undefined;
  /** Keyword to Search in All the available columns of the Resource. */
  keyword?: string | undefined;

  constructor(data?: IBaseFilter) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.advancedSearch = _data['advancedSearch']
        ? Search.fromJS(_data['advancedSearch'])
        : <any>undefined;
      this.keyword = _data['keyword'];
    }
  }

  static fromJS(data: any): BaseFilter {
    data = typeof data === 'object' ? data : {};
    let result = new BaseFilter();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['advancedSearch'] = this.advancedSearch
      ? this.advancedSearch.toJSON()
      : <any>undefined;
    data['keyword'] = this.keyword;
    return data;
  }
}

export interface IBaseFilter {
  /** Column Wise Search is Supported. */
  advancedSearch?: Search | undefined;
  /** Keyword to Search in All the available columns of the Resource. */
  keyword?: string | undefined;
}

export class PaginationFilter extends BaseFilter implements IPaginationFilter {
  pageNumber?: number;
  pageSize?: number;
  orderBy?: string[] | undefined;

  constructor(data?: IPaginationFilter) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.pageNumber = _data['pageNumber'];
      this.pageSize = _data['pageSize'];
      if (Array.isArray(_data['orderBy'])) {
        this.orderBy = [] as any;
        for (let item of _data['orderBy']) this.orderBy!.push(item);
      }
    }
  }

  static fromJS(data: any): PaginationFilter {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationFilter();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['pageNumber'] = this.pageNumber;
    data['pageSize'] = this.pageSize;
    if (Array.isArray(this.orderBy)) {
      data['orderBy'] = [];
      for (let item of this.orderBy) data['orderBy'].push(item);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginationFilter extends IBaseFilter {
  pageNumber?: number;
  pageSize?: number;
  orderBy?: string[] | undefined;
}

export class SearchAppNotificationsRequest
  extends PaginationFilter
  implements ISearchAppNotificationsRequest
{
  isRead?: boolean | undefined;
  type?: string | undefined;

  constructor(data?: ISearchAppNotificationsRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.isRead = _data['isRead'];
      this.type = _data['type'];
    }
  }

  static fromJS(data: any): SearchAppNotificationsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchAppNotificationsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isRead'] = this.isRead;
    data['type'] = this.type;
    super.toJSON(data);
    return data;
  }
}

export interface ISearchAppNotificationsRequest extends IPaginationFilter {
  isRead?: boolean | undefined;
  type?: string | undefined;
}

export class Search implements ISearch {
  fields?: string[];
  keyword?: string | undefined;

  constructor(data?: ISearch) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['fields'])) {
        this.fields = [] as any;
        for (let item of _data['fields']) this.fields!.push(item);
      }
      this.keyword = _data['keyword'];
    }
  }

  static fromJS(data: any): Search {
    data = typeof data === 'object' ? data : {};
    let result = new Search();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.fields)) {
      data['fields'] = [];
      for (let item of this.fields) data['fields'].push(item);
    }
    data['keyword'] = this.keyword;
    return data;
  }
}

export interface ISearch {
  fields?: string[];
  keyword?: string | undefined;
}

export class CreateAppNotificationRequest
  implements ICreateAppNotificationRequest
{
  title?: string;
  content?: string;
  type?: string;
  url?: string | undefined;
  sourceType?: string | undefined;
  sourceId?: string | undefined;
  userId?: string | undefined;

  constructor(data?: ICreateAppNotificationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data['title'];
      this.content = _data['content'];
      this.type = _data['type'];
      this.url = _data['url'];
      this.sourceType = _data['sourceType'];
      this.sourceId = _data['sourceId'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): CreateAppNotificationRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateAppNotificationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['title'] = this.title;
    data['content'] = this.content;
    data['type'] = this.type;
    data['url'] = this.url;
    data['sourceType'] = this.sourceType;
    data['sourceId'] = this.sourceId;
    data['userId'] = this.userId;
    return data;
  }
}

export interface ICreateAppNotificationRequest {
  title?: string;
  content?: string;
  type?: string;
  url?: string | undefined;
  sourceType?: string | undefined;
  sourceId?: string | undefined;
  userId?: string | undefined;
}

export class BusinessStatisticDto implements IBusinessStatisticDto {
  name?: string;
  value?: number;
  goal?: number;
  prevValue?: number;
  unit?: string;

  constructor(data?: IBusinessStatisticDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.value = _data['value'];
      this.goal = _data['goal'];
      this.prevValue = _data['prevValue'];
      this.unit = _data['unit'];
    }
  }

  static fromJS(data: any): BusinessStatisticDto {
    data = typeof data === 'object' ? data : {};
    let result = new BusinessStatisticDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['value'] = this.value;
    data['goal'] = this.goal;
    data['prevValue'] = this.prevValue;
    data['unit'] = this.unit;
    return data;
  }
}

export interface IBusinessStatisticDto {
  name?: string;
  value?: number;
  goal?: number;
  prevValue?: number;
  unit?: string;
}

export class CalendarEventDto implements ICalendarEventDto {
  id?: string;
  type?: string;
  title?: string;
  description?: string | undefined;
  startAt?: string;
  endAt?: string | undefined;
  status?: string | undefined;
  customerName?: string | undefined;
  customerId?: string | undefined;
  phone?: string | undefined;
  serviceName?: string | undefined;
  serviceOrderId?: string | undefined;
  reminderId?: string | undefined;
  recipientType?: string | undefined;
  recipientId?: string | undefined;
  recipientName?: string | undefined;
  recipientPhone?: string | undefined;
  createdById?: string | undefined;
  createdByName?: string | undefined;
  ownedByCurrentUser?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  smsNotificationEnabled?: boolean;
  smsPhone?: string | undefined;
  smsMessage?: string | undefined;
  smsTemplateId?: string | undefined;

  constructor(data?: ICalendarEventDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.title = _data['title'];
      this.description = _data['description'];
      this.startAt = _data['startAt'];
      this.endAt = _data['endAt'];
      this.status = _data['status'];
      this.customerName = _data['customerName'];
      this.customerId = _data['customerId'];
      this.phone = _data['phone'];
      this.serviceName = _data['serviceName'];
      this.serviceOrderId = _data['serviceOrderId'];
      this.reminderId = _data['reminderId'];
      this.recipientType = _data['recipientType'];
      this.recipientId = _data['recipientId'];
      this.recipientName = _data['recipientName'];
      this.recipientPhone = _data['recipientPhone'];
      this.createdById = _data['createdById'];
      this.createdByName = _data['createdByName'];
      this.ownedByCurrentUser = _data['ownedByCurrentUser'];
      this.canEdit = _data['canEdit'];
      this.canDelete = _data['canDelete'];
      this.smsNotificationEnabled = _data['smsNotificationEnabled'];
      this.smsPhone = _data['smsPhone'];
      this.smsMessage = _data['smsMessage'];
      this.smsTemplateId = _data['smsTemplateId'];
    }
  }

  static fromJS(data: any): CalendarEventDto {
    data = typeof data === 'object' ? data : {};
    let result = new CalendarEventDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['title'] = this.title;
    data['description'] = this.description;
    data['startAt'] = this.startAt;
    data['endAt'] = this.endAt;
    data['status'] = this.status;
    data['customerName'] = this.customerName;
    data['customerId'] = this.customerId;
    data['phone'] = this.phone;
    data['serviceName'] = this.serviceName;
    data['serviceOrderId'] = this.serviceOrderId;
    data['reminderId'] = this.reminderId;
    data['recipientType'] = this.recipientType;
    data['recipientId'] = this.recipientId;
    data['recipientName'] = this.recipientName;
    data['recipientPhone'] = this.recipientPhone;
    data['createdById'] = this.createdById;
    data['createdByName'] = this.createdByName;
    data['ownedByCurrentUser'] = this.ownedByCurrentUser;
    data['canEdit'] = this.canEdit;
    data['canDelete'] = this.canDelete;
    data['smsNotificationEnabled'] = this.smsNotificationEnabled;
    data['smsPhone'] = this.smsPhone;
    data['smsMessage'] = this.smsMessage;
    data['smsTemplateId'] = this.smsTemplateId;
    return data;
  }
}

export interface ICalendarEventDto {
  id?: string;
  type?: string;
  title?: string;
  description?: string | undefined;
  startAt?: string;
  endAt?: string | undefined;
  status?: string | undefined;
  customerName?: string | undefined;
  customerId?: string | undefined;
  phone?: string | undefined;
  serviceName?: string | undefined;
  serviceOrderId?: string | undefined;
  reminderId?: string | undefined;
  recipientType?: string | undefined;
  recipientId?: string | undefined;
  recipientName?: string | undefined;
  recipientPhone?: string | undefined;
  createdById?: string | undefined;
  createdByName?: string | undefined;
  ownedByCurrentUser?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  smsNotificationEnabled?: boolean;
  smsPhone?: string | undefined;
  smsMessage?: string | undefined;
  smsTemplateId?: string | undefined;
}

export class SearchCalendarEventsRequest
  implements ISearchCalendarEventsRequest
{
  from?: string;
  to?: string;
  scope?: string | undefined;
  types?: string[] | undefined;

  constructor(data?: ISearchCalendarEventsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.from = _data['from'];
      this.to = _data['to'];
      this.scope = _data['scope'];
      if (Array.isArray(_data['types'])) {
        this.types = [] as any;
        for (let item of _data['types']) this.types!.push(item);
      }
    }
  }

  static fromJS(data: any): SearchCalendarEventsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchCalendarEventsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['from'] = this.from;
    data['to'] = this.to;
    data['scope'] = this.scope;
    if (Array.isArray(this.types)) {
      data['types'] = [];
      for (let item of this.types) data['types'].push(item);
    }
    return data;
  }
}

export interface ISearchCalendarEventsRequest {
  from?: string;
  to?: string;
  scope?: string | undefined;
  types?: string[] | undefined;
}

export class SaveCalendarEventRequest implements ISaveCalendarEventRequest {
  type?: string;
  title?: string;
  description?: string | undefined;
  startAt?: string;
  endAt?: string | undefined;
  customerId?: string | undefined;
  customerName?: string | undefined;
  phone?: string | undefined;
  serviceName?: string | undefined;
  serviceOrderId?: string | undefined;
  reminderId?: string | undefined;
  recipientType?: string | undefined;
  recipientId?: string | undefined;
  recipientName?: string | undefined;
  recipientPhone?: string | undefined;
  smsTemplateId?: string | undefined;
  sendSmsToCurrentUser?: boolean;
  smsPhone?: string | undefined;
  smsMessage?: string | undefined;

  constructor(data?: ISaveCalendarEventRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.title = _data['title'];
      this.description = _data['description'];
      this.startAt = _data['startAt'];
      this.endAt = _data['endAt'];
      this.customerId = _data['customerId'];
      this.customerName = _data['customerName'];
      this.phone = _data['phone'];
      this.serviceName = _data['serviceName'];
      this.serviceOrderId = _data['serviceOrderId'];
      this.reminderId = _data['reminderId'];
      this.recipientType = _data['recipientType'];
      this.recipientId = _data['recipientId'];
      this.recipientName = _data['recipientName'];
      this.recipientPhone = _data['recipientPhone'];
      this.smsTemplateId = _data['smsTemplateId'];
      this.sendSmsToCurrentUser = _data['sendSmsToCurrentUser'];
      this.smsPhone = _data['smsPhone'];
      this.smsMessage = _data['smsMessage'];
    }
  }

  static fromJS(data: any): SaveCalendarEventRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SaveCalendarEventRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['title'] = this.title;
    data['description'] = this.description;
    data['startAt'] = this.startAt;
    data['endAt'] = this.endAt;
    data['customerId'] = this.customerId;
    data['customerName'] = this.customerName;
    data['phone'] = this.phone;
    data['serviceName'] = this.serviceName;
    data['serviceOrderId'] = this.serviceOrderId;
    data['reminderId'] = this.reminderId;
    data['recipientType'] = this.recipientType;
    data['recipientId'] = this.recipientId;
    data['recipientName'] = this.recipientName;
    data['recipientPhone'] = this.recipientPhone;
    data['smsTemplateId'] = this.smsTemplateId;
    data['sendSmsToCurrentUser'] = this.sendSmsToCurrentUser;
    data['smsPhone'] = this.smsPhone;
    data['smsMessage'] = this.smsMessage;
    return data;
  }
}

export interface ISaveCalendarEventRequest {
  type?: string;
  title?: string;
  description?: string | undefined;
  startAt?: string;
  endAt?: string | undefined;
  customerId?: string | undefined;
  customerName?: string | undefined;
  phone?: string | undefined;
  serviceName?: string | undefined;
  serviceOrderId?: string | undefined;
  reminderId?: string | undefined;
  recipientType?: string | undefined;
  recipientId?: string | undefined;
  recipientName?: string | undefined;
  recipientPhone?: string | undefined;
  smsTemplateId?: string | undefined;
  sendSmsToCurrentUser?: boolean;
  smsPhone?: string | undefined;
  smsMessage?: string | undefined;
}

export class CreateCalendarEventRequest
  extends SaveCalendarEventRequest
  implements ICreateCalendarEventRequest
{
  constructor(data?: ICreateCalendarEventRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
  }

  static fromJS(data: any): CreateCalendarEventRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateCalendarEventRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface ICreateCalendarEventRequest
  extends ISaveCalendarEventRequest {}

export class UpdateCalendarEventRequest
  extends SaveCalendarEventRequest
  implements IUpdateCalendarEventRequest
{
  id?: string;

  constructor(data?: IUpdateCalendarEventRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): UpdateCalendarEventRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateCalendarEventRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    super.toJSON(data);
    return data;
  }
}

export interface IUpdateCalendarEventRequest extends ISaveCalendarEventRequest {
  id?: string;
}

export class CompanyProfileDto implements ICompanyProfileDto {
  id?: string;
  publicSlug?: string;
  companyName?: string;
  companySlogan?: string | undefined;
  websiteUrl?: string | undefined;
  logoPath?: string | undefined;
  address?: CompanyAddressDto;
  contact?: CompanyContactDto;
  openingHours?: OpeningHoursDto;

  constructor(data?: ICompanyProfileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.publicSlug = _data['publicSlug'];
      this.companyName = _data['companyName'];
      this.companySlogan = _data['companySlogan'];
      this.websiteUrl = _data['websiteUrl'];
      this.logoPath = _data['logoPath'];
      this.address = _data['address']
        ? CompanyAddressDto.fromJS(_data['address'])
        : <any>undefined;
      this.contact = _data['contact']
        ? CompanyContactDto.fromJS(_data['contact'])
        : <any>undefined;
      this.openingHours = _data['openingHours']
        ? OpeningHoursDto.fromJS(_data['openingHours'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CompanyProfileDto {
    data = typeof data === 'object' ? data : {};
    let result = new CompanyProfileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['publicSlug'] = this.publicSlug;
    data['companyName'] = this.companyName;
    data['companySlogan'] = this.companySlogan;
    data['websiteUrl'] = this.websiteUrl;
    data['logoPath'] = this.logoPath;
    data['address'] = this.address ? this.address.toJSON() : <any>undefined;
    data['contact'] = this.contact ? this.contact.toJSON() : <any>undefined;
    data['openingHours'] = this.openingHours
      ? this.openingHours.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface ICompanyProfileDto {
  id?: string;
  publicSlug?: string;
  companyName?: string;
  companySlogan?: string | undefined;
  websiteUrl?: string | undefined;
  logoPath?: string | undefined;
  address?: CompanyAddressDto;
  contact?: CompanyContactDto;
  openingHours?: OpeningHoursDto;
}

export class CompanyAddressDto implements ICompanyAddressDto {
  city?: string | undefined;
  street?: string | undefined;
  postalCode?: string | undefined;

  constructor(data?: ICompanyAddressDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.city = _data['city'];
      this.street = _data['street'];
      this.postalCode = _data['postalCode'];
    }
  }

  static fromJS(data: any): CompanyAddressDto {
    data = typeof data === 'object' ? data : {};
    let result = new CompanyAddressDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['city'] = this.city;
    data['street'] = this.street;
    data['postalCode'] = this.postalCode;
    return data;
  }
}

export interface ICompanyAddressDto {
  city?: string | undefined;
  street?: string | undefined;
  postalCode?: string | undefined;
}

export class CompanyContactDto implements ICompanyContactDto {
  email?: string | undefined;
  phoneNo?: string | undefined;

  constructor(data?: ICompanyContactDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data['email'];
      this.phoneNo = _data['phoneNo'];
    }
  }

  static fromJS(data: any): CompanyContactDto {
    data = typeof data === 'object' ? data : {};
    let result = new CompanyContactDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['email'] = this.email;
    data['phoneNo'] = this.phoneNo;
    return data;
  }
}

export interface ICompanyContactDto {
  email?: string | undefined;
  phoneNo?: string | undefined;
}

export class OpeningHoursDto implements IOpeningHoursDto {
  monFri?: OpeningHoursDayDto;
  sat?: OpeningHoursDayDto;
  sun?: OpeningHoursDayDto;

  constructor(data?: IOpeningHoursDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.monFri = _data['monFri']
        ? OpeningHoursDayDto.fromJS(_data['monFri'])
        : <any>undefined;
      this.sat = _data['sat']
        ? OpeningHoursDayDto.fromJS(_data['sat'])
        : <any>undefined;
      this.sun = _data['sun']
        ? OpeningHoursDayDto.fromJS(_data['sun'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): OpeningHoursDto {
    data = typeof data === 'object' ? data : {};
    let result = new OpeningHoursDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['monFri'] = this.monFri ? this.monFri.toJSON() : <any>undefined;
    data['sat'] = this.sat ? this.sat.toJSON() : <any>undefined;
    data['sun'] = this.sun ? this.sun.toJSON() : <any>undefined;
    return data;
  }
}

export interface IOpeningHoursDto {
  monFri?: OpeningHoursDayDto;
  sat?: OpeningHoursDayDto;
  sun?: OpeningHoursDayDto;
}

export class OpeningHoursDayDto implements IOpeningHoursDayDto {
  open?: string | undefined;
  close?: string | undefined;
  isClosed?: boolean;

  constructor(data?: IOpeningHoursDayDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.open = _data['open'];
      this.close = _data['close'];
      this.isClosed = _data['isClosed'];
    }
  }

  static fromJS(data: any): OpeningHoursDayDto {
    data = typeof data === 'object' ? data : {};
    let result = new OpeningHoursDayDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['open'] = this.open;
    data['close'] = this.close;
    data['isClosed'] = this.isClosed;
    return data;
  }
}

export interface IOpeningHoursDayDto {
  open?: string | undefined;
  close?: string | undefined;
  isClosed?: boolean;
}

export class UpsertCompanyProfileRequest
  implements IUpsertCompanyProfileRequest
{
  publicSlug?: string;
  companyName?: string;
  companySlogan?: string | undefined;
  websiteUrl?: string | undefined;
  logoPath?: string | undefined;
  address?: CompanyAddressDto;
  contact?: CompanyContactDto;
  openingHours?: OpeningHoursDto;

  constructor(data?: IUpsertCompanyProfileRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.publicSlug = _data['publicSlug'];
      this.companyName = _data['companyName'];
      this.companySlogan = _data['companySlogan'];
      this.websiteUrl = _data['websiteUrl'];
      this.logoPath = _data['logoPath'];
      this.address = _data['address']
        ? CompanyAddressDto.fromJS(_data['address'])
        : <any>undefined;
      this.contact = _data['contact']
        ? CompanyContactDto.fromJS(_data['contact'])
        : <any>undefined;
      this.openingHours = _data['openingHours']
        ? OpeningHoursDto.fromJS(_data['openingHours'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): UpsertCompanyProfileRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpsertCompanyProfileRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['publicSlug'] = this.publicSlug;
    data['companyName'] = this.companyName;
    data['companySlogan'] = this.companySlogan;
    data['websiteUrl'] = this.websiteUrl;
    data['logoPath'] = this.logoPath;
    data['address'] = this.address ? this.address.toJSON() : <any>undefined;
    data['contact'] = this.contact ? this.contact.toJSON() : <any>undefined;
    data['openingHours'] = this.openingHours
      ? this.openingHours.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IUpsertCompanyProfileRequest {
  publicSlug?: string;
  companyName?: string;
  companySlogan?: string | undefined;
  websiteUrl?: string | undefined;
  logoPath?: string | undefined;
  address?: CompanyAddressDto;
  contact?: CompanyContactDto;
  openingHours?: OpeningHoursDto;
}

export class PaginationResponseOfContactMessageDto
  implements IPaginationResponseOfContactMessageDto
{
  data?: ContactMessageDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfContactMessageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(ContactMessageDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfContactMessageDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfContactMessageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfContactMessageDto {
  data?: ContactMessageDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class ContactMessageDto implements IContactMessageDto {
  id?: string;
  fullName?: string;
  email?: string;
  phoneNo?: string | undefined;
  subject?: string | undefined;
  message?: string;
  createdOn?: string;
  readOn?: string | undefined;
  isRead?: boolean;

  constructor(data?: IContactMessageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.fullName = _data['fullName'];
      this.email = _data['email'];
      this.phoneNo = _data['phoneNo'];
      this.subject = _data['subject'];
      this.message = _data['message'];
      this.createdOn = _data['createdOn'];
      this.readOn = _data['readOn'];
      this.isRead = _data['isRead'];
    }
  }

  static fromJS(data: any): ContactMessageDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContactMessageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['email'] = this.email;
    data['phoneNo'] = this.phoneNo;
    data['subject'] = this.subject;
    data['message'] = this.message;
    data['createdOn'] = this.createdOn;
    data['readOn'] = this.readOn;
    data['isRead'] = this.isRead;
    return data;
  }
}

export interface IContactMessageDto {
  id?: string;
  fullName?: string;
  email?: string;
  phoneNo?: string | undefined;
  subject?: string | undefined;
  message?: string;
  createdOn?: string;
  readOn?: string | undefined;
  isRead?: boolean;
}

export class SearchContactMessagesRequest
  extends PaginationFilter
  implements ISearchContactMessagesRequest
{
  isRead?: boolean | undefined;

  constructor(data?: ISearchContactMessagesRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.isRead = _data['isRead'];
    }
  }

  static fromJS(data: any): SearchContactMessagesRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchContactMessagesRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isRead'] = this.isRead;
    super.toJSON(data);
    return data;
  }
}

export interface ISearchContactMessagesRequest extends IPaginationFilter {
  isRead?: boolean | undefined;
}

export class CreateContactMessageRequest
  implements ICreateContactMessageRequest
{
  fullName?: string;
  email?: string;
  phoneNo?: string | undefined;
  subject?: string | undefined;
  message?: string;

  constructor(data?: ICreateContactMessageRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fullName = _data['fullName'];
      this.email = _data['email'];
      this.phoneNo = _data['phoneNo'];
      this.subject = _data['subject'];
      this.message = _data['message'];
    }
  }

  static fromJS(data: any): CreateContactMessageRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateContactMessageRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['fullName'] = this.fullName;
    data['email'] = this.email;
    data['phoneNo'] = this.phoneNo;
    data['subject'] = this.subject;
    data['message'] = this.message;
    return data;
  }
}

export interface ICreateContactMessageRequest {
  fullName?: string;
  email?: string;
  phoneNo?: string | undefined;
  subject?: string | undefined;
  message?: string;
}

export class PaginationResponseOfCustomerDto
  implements IPaginationResponseOfCustomerDto
{
  data?: CustomerDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfCustomerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(CustomerDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfCustomerDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfCustomerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfCustomerDto {
  data?: CustomerDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class CustomerDto implements ICustomerDto {
  id?: string;
  name?: string;
  phone?: string | undefined;
  fullName?: string;
  email?: string | undefined;
  phoneNo?: string | undefined;
  address?: string | undefined;
  notes?: string | undefined;
  visitsCount?: number;
  totalValue?: number;
  lastService?: string | undefined;
  followersCount?: number;
  isFollowedByCurrentUser?: boolean;

  constructor(data?: ICustomerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.phone = _data['phone'];
      this.fullName = _data['fullName'];
      this.email = _data['email'];
      this.phoneNo = _data['phoneNo'];
      this.address = _data['address'];
      this.notes = _data['notes'];
      this.visitsCount = _data['visitsCount'];
      this.totalValue = _data['totalValue'];
      this.lastService = _data['lastService'];
      this.followersCount = _data['followersCount'];
      this.isFollowedByCurrentUser = _data['isFollowedByCurrentUser'];
    }
  }

  static fromJS(data: any): CustomerDto {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['phone'] = this.phone;
    data['fullName'] = this.fullName;
    data['email'] = this.email;
    data['phoneNo'] = this.phoneNo;
    data['address'] = this.address;
    data['notes'] = this.notes;
    data['visitsCount'] = this.visitsCount;
    data['totalValue'] = this.totalValue;
    data['lastService'] = this.lastService;
    data['followersCount'] = this.followersCount;
    data['isFollowedByCurrentUser'] = this.isFollowedByCurrentUser;
    return data;
  }
}

export interface ICustomerDto {
  id?: string;
  name?: string;
  phone?: string | undefined;
  fullName?: string;
  email?: string | undefined;
  phoneNo?: string | undefined;
  address?: string | undefined;
  notes?: string | undefined;
  visitsCount?: number;
  totalValue?: number;
  lastService?: string | undefined;
  followersCount?: number;
  isFollowedByCurrentUser?: boolean;
}

export class SearchCustomersRequest
  extends PaginationFilter
  implements ISearchCustomersRequest
{
  constructor(data?: ISearchCustomersRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
  }

  static fromJS(data: any): SearchCustomersRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchCustomersRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface ISearchCustomersRequest extends IPaginationFilter {}

export class CreateCustomerRequest implements ICreateCustomerRequest {
  name?: string | undefined;
  fullName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  phoneNo?: string | undefined;
  address?: string | undefined;
  notes?: string | undefined;

  constructor(data?: ICreateCustomerRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.fullName = _data['fullName'];
      this.email = _data['email'];
      this.phone = _data['phone'];
      this.phoneNo = _data['phoneNo'];
      this.address = _data['address'];
      this.notes = _data['notes'];
    }
  }

  static fromJS(data: any): CreateCustomerRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateCustomerRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['fullName'] = this.fullName;
    data['email'] = this.email;
    data['phone'] = this.phone;
    data['phoneNo'] = this.phoneNo;
    data['address'] = this.address;
    data['notes'] = this.notes;
    return data;
  }
}

export interface ICreateCustomerRequest {
  name?: string | undefined;
  fullName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  phoneNo?: string | undefined;
  address?: string | undefined;
  notes?: string | undefined;
}

export class UpdateCustomerRequest implements IUpdateCustomerRequest {
  id?: string;
  name?: string | undefined;
  fullName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  phoneNo?: string | undefined;
  address?: string | undefined;
  notes?: string | undefined;

  constructor(data?: IUpdateCustomerRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.fullName = _data['fullName'];
      this.email = _data['email'];
      this.phone = _data['phone'];
      this.phoneNo = _data['phoneNo'];
      this.address = _data['address'];
      this.notes = _data['notes'];
    }
  }

  static fromJS(data: any): UpdateCustomerRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateCustomerRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['fullName'] = this.fullName;
    data['email'] = this.email;
    data['phone'] = this.phone;
    data['phoneNo'] = this.phoneNo;
    data['address'] = this.address;
    data['notes'] = this.notes;
    return data;
  }
}

export interface IUpdateCustomerRequest {
  id?: string;
  name?: string | undefined;
  fullName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  phoneNo?: string | undefined;
  address?: string | undefined;
  notes?: string | undefined;
}

export class DepartmentDto implements IDepartmentDto {
  id?: string;
  key?: string;
  name?: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;
  teams?: DepartmentTeamDto[];

  constructor(data?: IDepartmentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.key = _data['key'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.sortOrder = _data['sortOrder'];
      this.isActive = _data['isActive'];
      if (Array.isArray(_data['teams'])) {
        this.teams = [] as any;
        for (let item of _data['teams'])
          this.teams!.push(DepartmentTeamDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): DepartmentDto {
    data = typeof data === 'object' ? data : {};
    let result = new DepartmentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['key'] = this.key;
    data['name'] = this.name;
    data['description'] = this.description;
    data['sortOrder'] = this.sortOrder;
    data['isActive'] = this.isActive;
    if (Array.isArray(this.teams)) {
      data['teams'] = [];
      for (let item of this.teams) data['teams'].push(item.toJSON());
    }
    return data;
  }
}

export interface IDepartmentDto {
  id?: string;
  key?: string;
  name?: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;
  teams?: DepartmentTeamDto[];
}

export class DepartmentTeamDto implements IDepartmentTeamDto {
  id?: string;
  departmentId?: string;
  departmentName?: string | undefined;
  key?: string;
  name?: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;

  constructor(data?: IDepartmentTeamDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.departmentId = _data['departmentId'];
      this.departmentName = _data['departmentName'];
      this.key = _data['key'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.sortOrder = _data['sortOrder'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): DepartmentTeamDto {
    data = typeof data === 'object' ? data : {};
    let result = new DepartmentTeamDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['departmentId'] = this.departmentId;
    data['departmentName'] = this.departmentName;
    data['key'] = this.key;
    data['name'] = this.name;
    data['description'] = this.description;
    data['sortOrder'] = this.sortOrder;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IDepartmentTeamDto {
  id?: string;
  departmentId?: string;
  departmentName?: string | undefined;
  key?: string;
  name?: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;
}

export class CreateDepartmentRequest implements ICreateDepartmentRequest {
  key!: string;
  name!: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;

  constructor(data?: ICreateDepartmentRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data['key'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.sortOrder = _data['sortOrder'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): CreateDepartmentRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateDepartmentRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['key'] = this.key;
    data['name'] = this.name;
    data['description'] = this.description;
    data['sortOrder'] = this.sortOrder;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface ICreateDepartmentRequest {
  key: string;
  name: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;
}

export class UpdateDepartmentRequest implements IUpdateDepartmentRequest {
  id!: string;
  key!: string;
  name!: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;

  constructor(data?: IUpdateDepartmentRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.key = _data['key'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.sortOrder = _data['sortOrder'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): UpdateDepartmentRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateDepartmentRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['key'] = this.key;
    data['name'] = this.name;
    data['description'] = this.description;
    data['sortOrder'] = this.sortOrder;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IUpdateDepartmentRequest {
  id: string;
  key: string;
  name: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;
}

export class CreateDepartmentTeamRequest
  implements ICreateDepartmentTeamRequest
{
  departmentId!: string;
  key!: string;
  name!: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;

  constructor(data?: ICreateDepartmentTeamRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.departmentId = _data['departmentId'];
      this.key = _data['key'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.sortOrder = _data['sortOrder'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): CreateDepartmentTeamRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateDepartmentTeamRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['departmentId'] = this.departmentId;
    data['key'] = this.key;
    data['name'] = this.name;
    data['description'] = this.description;
    data['sortOrder'] = this.sortOrder;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface ICreateDepartmentTeamRequest {
  departmentId: string;
  key: string;
  name: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;
}

export class PaginationResponseOfDriveFileDto
  implements IPaginationResponseOfDriveFileDto
{
  data?: DriveFileDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfDriveFileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(DriveFileDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfDriveFileDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfDriveFileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfDriveFileDto {
  data?: DriveFileDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class DriveFileDto implements IDriveFileDto {
  id?: string;
  fileName?: string;
  contentType?: string | undefined;
  size?: number;
  storagePath?: string;
  folder?: string | undefined;
  description?: string | undefined;
  createdOn?: string;

  constructor(data?: IDriveFileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.fileName = _data['fileName'];
      this.contentType = _data['contentType'];
      this.size = _data['size'];
      this.storagePath = _data['storagePath'];
      this.folder = _data['folder'];
      this.description = _data['description'];
      this.createdOn = _data['createdOn'];
    }
  }

  static fromJS(data: any): DriveFileDto {
    data = typeof data === 'object' ? data : {};
    let result = new DriveFileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fileName'] = this.fileName;
    data['contentType'] = this.contentType;
    data['size'] = this.size;
    data['storagePath'] = this.storagePath;
    data['folder'] = this.folder;
    data['description'] = this.description;
    data['createdOn'] = this.createdOn;
    return data;
  }
}

export interface IDriveFileDto {
  id?: string;
  fileName?: string;
  contentType?: string | undefined;
  size?: number;
  storagePath?: string;
  folder?: string | undefined;
  description?: string | undefined;
  createdOn?: string;
}

export class SearchDriveFilesRequest
  extends PaginationFilter
  implements ISearchDriveFilesRequest
{
  folder?: string | undefined;

  constructor(data?: ISearchDriveFilesRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.folder = _data['folder'];
    }
  }

  static fromJS(data: any): SearchDriveFilesRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchDriveFilesRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['folder'] = this.folder;
    super.toJSON(data);
    return data;
  }
}

export interface ISearchDriveFilesRequest extends IPaginationFilter {
  folder?: string | undefined;
}

export class CreateDriveFileRequest implements ICreateDriveFileRequest {
  fileName?: string;
  contentType?: string | undefined;
  size?: number;
  storagePath?: string;
  folder?: string | undefined;
  description?: string | undefined;

  constructor(data?: ICreateDriveFileRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fileName = _data['fileName'];
      this.contentType = _data['contentType'];
      this.size = _data['size'];
      this.storagePath = _data['storagePath'];
      this.folder = _data['folder'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): CreateDriveFileRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateDriveFileRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['fileName'] = this.fileName;
    data['contentType'] = this.contentType;
    data['size'] = this.size;
    data['storagePath'] = this.storagePath;
    data['folder'] = this.folder;
    data['description'] = this.description;
    return data;
  }
}

export interface ICreateDriveFileRequest {
  fileName?: string;
  contentType?: string | undefined;
  size?: number;
  storagePath?: string;
  folder?: string | undefined;
  description?: string | undefined;
}

export class PaginationResponseOfEmployeeDto
  implements IPaginationResponseOfEmployeeDto
{
  data?: EmployeeDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfEmployeeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(EmployeeDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfEmployeeDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfEmployeeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfEmployeeDto {
  data?: EmployeeDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class EmployeeDto implements IEmployeeDto {
  id?: string;
  fullName?: string;
  position?: string | undefined;
  email?: string | undefined;
  phoneNo?: string | undefined;
  isActive?: boolean;
  canLogin?: boolean;
  roleId?: string | undefined;
  roleName?: string | undefined;
  userId?: string | undefined;
  followersCount?: number;
  isFollowedByCurrentUser?: boolean;

  constructor(data?: IEmployeeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.fullName = _data['fullName'];
      this.position = _data['position'];
      this.email = _data['email'];
      this.phoneNo = _data['phoneNo'];
      this.isActive = _data['isActive'];
      this.canLogin = _data['canLogin'];
      this.roleId = _data['roleId'];
      this.roleName = _data['roleName'];
      this.userId = _data['userId'];
      this.followersCount = _data['followersCount'];
      this.isFollowedByCurrentUser = _data['isFollowedByCurrentUser'];
    }
  }

  static fromJS(data: any): EmployeeDto {
    data = typeof data === 'object' ? data : {};
    let result = new EmployeeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['position'] = this.position;
    data['email'] = this.email;
    data['phoneNo'] = this.phoneNo;
    data['isActive'] = this.isActive;
    data['canLogin'] = this.canLogin;
    data['roleId'] = this.roleId;
    data['roleName'] = this.roleName;
    data['userId'] = this.userId;
    data['followersCount'] = this.followersCount;
    data['isFollowedByCurrentUser'] = this.isFollowedByCurrentUser;
    return data;
  }
}

export interface IEmployeeDto {
  id?: string;
  fullName?: string;
  position?: string | undefined;
  email?: string | undefined;
  phoneNo?: string | undefined;
  isActive?: boolean;
  canLogin?: boolean;
  roleId?: string | undefined;
  roleName?: string | undefined;
  userId?: string | undefined;
  followersCount?: number;
  isFollowedByCurrentUser?: boolean;
}

export class SearchEmployeesRequest
  extends PaginationFilter
  implements ISearchEmployeesRequest
{
  isActive?: boolean | undefined;

  constructor(data?: ISearchEmployeesRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): SearchEmployeesRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchEmployeesRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isActive'] = this.isActive;
    super.toJSON(data);
    return data;
  }
}

export interface ISearchEmployeesRequest extends IPaginationFilter {
  isActive?: boolean | undefined;
}

export class CreateEmployeeRequest implements ICreateEmployeeRequest {
  fullName?: string;
  position?: string | undefined;
  email?: string | undefined;
  phoneNo?: string | undefined;
  isActive?: boolean;
  canLogin?: boolean;
  roleId?: string | undefined;
  roleName?: string | undefined;

  constructor(data?: ICreateEmployeeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fullName = _data['fullName'];
      this.position = _data['position'];
      this.email = _data['email'];
      this.phoneNo = _data['phoneNo'];
      this.isActive = _data['isActive'];
      this.canLogin = _data['canLogin'];
      this.roleId = _data['roleId'];
      this.roleName = _data['roleName'];
    }
  }

  static fromJS(data: any): CreateEmployeeRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateEmployeeRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['fullName'] = this.fullName;
    data['position'] = this.position;
    data['email'] = this.email;
    data['phoneNo'] = this.phoneNo;
    data['isActive'] = this.isActive;
    data['canLogin'] = this.canLogin;
    data['roleId'] = this.roleId;
    data['roleName'] = this.roleName;
    return data;
  }
}

export interface ICreateEmployeeRequest {
  fullName?: string;
  position?: string | undefined;
  email?: string | undefined;
  phoneNo?: string | undefined;
  isActive?: boolean;
  canLogin?: boolean;
  roleId?: string | undefined;
  roleName?: string | undefined;
}

export class UpdateEmployeeRequest implements IUpdateEmployeeRequest {
  id?: string;
  fullName?: string;
  position?: string | undefined;
  email?: string | undefined;
  phoneNo?: string | undefined;
  isActive?: boolean;
  canLogin?: boolean;
  roleId?: string | undefined;
  roleName?: string | undefined;
  userId?: string | undefined;

  constructor(data?: IUpdateEmployeeRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.fullName = _data['fullName'];
      this.position = _data['position'];
      this.email = _data['email'];
      this.phoneNo = _data['phoneNo'];
      this.isActive = _data['isActive'];
      this.canLogin = _data['canLogin'];
      this.roleId = _data['roleId'];
      this.roleName = _data['roleName'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): UpdateEmployeeRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateEmployeeRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['position'] = this.position;
    data['email'] = this.email;
    data['phoneNo'] = this.phoneNo;
    data['isActive'] = this.isActive;
    data['canLogin'] = this.canLogin;
    data['roleId'] = this.roleId;
    data['roleName'] = this.roleName;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IUpdateEmployeeRequest {
  id?: string;
  fullName?: string;
  position?: string | undefined;
  email?: string | undefined;
  phoneNo?: string | undefined;
  isActive?: boolean;
  canLogin?: boolean;
  roleId?: string | undefined;
  roleName?: string | undefined;
  userId?: string | undefined;
}

export class EntityFollowerDto implements IEntityFollowerDto {
  userId?: string;
  displayName?: string | undefined;
  email?: string | undefined;
  followedAt?: string;

  constructor(data?: IEntityFollowerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.displayName = _data['displayName'];
      this.email = _data['email'];
      this.followedAt = _data['followedAt'];
    }
  }

  static fromJS(data: any): EntityFollowerDto {
    data = typeof data === 'object' ? data : {};
    let result = new EntityFollowerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['displayName'] = this.displayName;
    data['email'] = this.email;
    data['followedAt'] = this.followedAt;
    return data;
  }
}

export interface IEntityFollowerDto {
  userId?: string;
  displayName?: string | undefined;
  email?: string | undefined;
  followedAt?: string;
}

export class FollowedEntityDto implements IFollowedEntityDto {
  entityType?: string;
  entityId?: string;
  title?: string;
  subtitle?: string | undefined;
  followedAt?: string;

  constructor(data?: IFollowedEntityDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityType = _data['entityType'];
      this.entityId = _data['entityId'];
      this.title = _data['title'];
      this.subtitle = _data['subtitle'];
      this.followedAt = _data['followedAt'];
    }
  }

  static fromJS(data: any): FollowedEntityDto {
    data = typeof data === 'object' ? data : {};
    let result = new FollowedEntityDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['entityType'] = this.entityType;
    data['entityId'] = this.entityId;
    data['title'] = this.title;
    data['subtitle'] = this.subtitle;
    data['followedAt'] = this.followedAt;
    return data;
  }
}

export interface IFollowedEntityDto {
  entityType?: string;
  entityId?: string;
  title?: string;
  subtitle?: string | undefined;
  followedAt?: string;
}

export class PaginationResponseOfChatUserDto
  implements IPaginationResponseOfChatUserDto
{
  data?: ChatUserDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfChatUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(ChatUserDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfChatUserDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfChatUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfChatUserDto {
  data?: ChatUserDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class ChatUserDto implements IChatUserDto {
  id?: string;
  displayName?: string | undefined;
  userName?: string | undefined;
  email?: string | undefined;
  imageUrl?: string | undefined;
  isActive?: boolean;

  constructor(data?: IChatUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.displayName = _data['displayName'];
      this.userName = _data['userName'];
      this.email = _data['email'];
      this.imageUrl = _data['imageUrl'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): ChatUserDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChatUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['displayName'] = this.displayName;
    data['userName'] = this.userName;
    data['email'] = this.email;
    data['imageUrl'] = this.imageUrl;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IChatUserDto {
  id?: string;
  displayName?: string | undefined;
  userName?: string | undefined;
  email?: string | undefined;
  imageUrl?: string | undefined;
  isActive?: boolean;
}

export class PaginationResponseOfChatConversationDto
  implements IPaginationResponseOfChatConversationDto
{
  data?: ChatConversationDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfChatConversationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(ChatConversationDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfChatConversationDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfChatConversationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfChatConversationDto {
  data?: ChatConversationDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class ChatConversationDto implements IChatConversationDto {
  id?: string;
  type?: string;
  title?: string | undefined;
  createdByUserId?: string;
  createdByDisplayName?: string | undefined;
  createdAt?: string;
  updatedAt?: string;
  lastMessage?: ChatMessageDto | undefined;
  unreadCount?: number;
  participants?: ChatParticipantDto[];

  constructor(data?: IChatConversationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.title = _data['title'];
      this.createdByUserId = _data['createdByUserId'];
      this.createdByDisplayName = _data['createdByDisplayName'];
      this.createdAt = _data['createdAt'];
      this.updatedAt = _data['updatedAt'];
      this.lastMessage = _data['lastMessage']
        ? ChatMessageDto.fromJS(_data['lastMessage'])
        : <any>undefined;
      this.unreadCount = _data['unreadCount'];
      if (Array.isArray(_data['participants'])) {
        this.participants = [] as any;
        for (let item of _data['participants'])
          this.participants!.push(ChatParticipantDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ChatConversationDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChatConversationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['title'] = this.title;
    data['createdByUserId'] = this.createdByUserId;
    data['createdByDisplayName'] = this.createdByDisplayName;
    data['createdAt'] = this.createdAt;
    data['updatedAt'] = this.updatedAt;
    data['lastMessage'] = this.lastMessage
      ? this.lastMessage.toJSON()
      : <any>undefined;
    data['unreadCount'] = this.unreadCount;
    if (Array.isArray(this.participants)) {
      data['participants'] = [];
      for (let item of this.participants)
        data['participants'].push(item.toJSON());
    }
    return data;
  }
}

export interface IChatConversationDto {
  id?: string;
  type?: string;
  title?: string | undefined;
  createdByUserId?: string;
  createdByDisplayName?: string | undefined;
  createdAt?: string;
  updatedAt?: string;
  lastMessage?: ChatMessageDto | undefined;
  unreadCount?: number;
  participants?: ChatParticipantDto[];
}

export class ChatMessageDto implements IChatMessageDto {
  id?: string;
  conversationId?: string;
  senderUserId?: string;
  senderDisplayName?: string | undefined;
  senderEmail?: string | undefined;
  body?: string;
  clientMessageId?: string | undefined;
  sentAt?: string;
  editedAt?: string | undefined;

  constructor(data?: IChatMessageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.conversationId = _data['conversationId'];
      this.senderUserId = _data['senderUserId'];
      this.senderDisplayName = _data['senderDisplayName'];
      this.senderEmail = _data['senderEmail'];
      this.body = _data['body'];
      this.clientMessageId = _data['clientMessageId'];
      this.sentAt = _data['sentAt'];
      this.editedAt = _data['editedAt'];
    }
  }

  static fromJS(data: any): ChatMessageDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChatMessageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['conversationId'] = this.conversationId;
    data['senderUserId'] = this.senderUserId;
    data['senderDisplayName'] = this.senderDisplayName;
    data['senderEmail'] = this.senderEmail;
    data['body'] = this.body;
    data['clientMessageId'] = this.clientMessageId;
    data['sentAt'] = this.sentAt;
    data['editedAt'] = this.editedAt;
    return data;
  }
}

export interface IChatMessageDto {
  id?: string;
  conversationId?: string;
  senderUserId?: string;
  senderDisplayName?: string | undefined;
  senderEmail?: string | undefined;
  body?: string;
  clientMessageId?: string | undefined;
  sentAt?: string;
  editedAt?: string | undefined;
}

export class ChatParticipantDto implements IChatParticipantDto {
  userId?: string;
  displayName?: string | undefined;
  email?: string | undefined;
  imageUrl?: string | undefined;
  joinedAt?: string;
  lastReadAt?: string | undefined;
  lastReadMessageId?: string | undefined;
  isMuted?: boolean;
  isCurrentUser?: boolean;

  constructor(data?: IChatParticipantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.displayName = _data['displayName'];
      this.email = _data['email'];
      this.imageUrl = _data['imageUrl'];
      this.joinedAt = _data['joinedAt'];
      this.lastReadAt = _data['lastReadAt'];
      this.lastReadMessageId = _data['lastReadMessageId'];
      this.isMuted = _data['isMuted'];
      this.isCurrentUser = _data['isCurrentUser'];
    }
  }

  static fromJS(data: any): ChatParticipantDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChatParticipantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['displayName'] = this.displayName;
    data['email'] = this.email;
    data['imageUrl'] = this.imageUrl;
    data['joinedAt'] = this.joinedAt;
    data['lastReadAt'] = this.lastReadAt;
    data['lastReadMessageId'] = this.lastReadMessageId;
    data['isMuted'] = this.isMuted;
    data['isCurrentUser'] = this.isCurrentUser;
    return data;
  }
}

export interface IChatParticipantDto {
  userId?: string;
  displayName?: string | undefined;
  email?: string | undefined;
  imageUrl?: string | undefined;
  joinedAt?: string;
  lastReadAt?: string | undefined;
  lastReadMessageId?: string | undefined;
  isMuted?: boolean;
  isCurrentUser?: boolean;
}

export class SearchChatConversationsRequest
  extends PaginationFilter
  implements ISearchChatConversationsRequest
{
  constructor(data?: ISearchChatConversationsRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
  }

  static fromJS(data: any): SearchChatConversationsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchChatConversationsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface ISearchChatConversationsRequest extends IPaginationFilter {}

export class CreateChatConversationRequest
  implements ICreateChatConversationRequest
{
  title?: string | undefined;
  participantUserIds!: string[];
  initialMessage?: string | undefined;
  clientMessageId?: string | undefined;

  constructor(data?: ICreateChatConversationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.participantUserIds = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data['title'];
      if (Array.isArray(_data['participantUserIds'])) {
        this.participantUserIds = [] as any;
        for (let item of _data['participantUserIds'])
          this.participantUserIds!.push(item);
      }
      this.initialMessage = _data['initialMessage'];
      this.clientMessageId = _data['clientMessageId'];
    }
  }

  static fromJS(data: any): CreateChatConversationRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateChatConversationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['title'] = this.title;
    if (Array.isArray(this.participantUserIds)) {
      data['participantUserIds'] = [];
      for (let item of this.participantUserIds)
        data['participantUserIds'].push(item);
    }
    data['initialMessage'] = this.initialMessage;
    data['clientMessageId'] = this.clientMessageId;
    return data;
  }
}

export interface ICreateChatConversationRequest {
  title?: string | undefined;
  participantUserIds: string[];
  initialMessage?: string | undefined;
  clientMessageId?: string | undefined;
}

export class PaginationResponseOfChatMessageDto
  implements IPaginationResponseOfChatMessageDto
{
  data?: ChatMessageDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfChatMessageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(ChatMessageDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfChatMessageDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfChatMessageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfChatMessageDto {
  data?: ChatMessageDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class SendChatMessageRequest implements ISendChatMessageRequest {
  conversationId!: string;
  body!: string;
  clientMessageId?: string | undefined;

  constructor(data?: ISendChatMessageRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.conversationId = _data['conversationId'];
      this.body = _data['body'];
      this.clientMessageId = _data['clientMessageId'];
    }
  }

  static fromJS(data: any): SendChatMessageRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SendChatMessageRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['conversationId'] = this.conversationId;
    data['body'] = this.body;
    data['clientMessageId'] = this.clientMessageId;
    return data;
  }
}

export interface ISendChatMessageRequest {
  conversationId: string;
  body: string;
  clientMessageId?: string | undefined;
}

export class ChatConversationReadDto implements IChatConversationReadDto {
  conversationId?: string;
  userId?: string;
  readAt?: string;
  lastReadMessageId?: string | undefined;

  constructor(data?: IChatConversationReadDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.conversationId = _data['conversationId'];
      this.userId = _data['userId'];
      this.readAt = _data['readAt'];
      this.lastReadMessageId = _data['lastReadMessageId'];
    }
  }

  static fromJS(data: any): ChatConversationReadDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChatConversationReadDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['conversationId'] = this.conversationId;
    data['userId'] = this.userId;
    data['readAt'] = this.readAt;
    data['lastReadMessageId'] = this.lastReadMessageId;
    return data;
  }
}

export interface IChatConversationReadDto {
  conversationId?: string;
  userId?: string;
  readAt?: string;
  lastReadMessageId?: string | undefined;
}

export class MarkChatConversationReadRequest
  implements IMarkChatConversationReadRequest
{
  conversationId?: string;
  lastReadMessageId?: string | undefined;

  constructor(data?: IMarkChatConversationReadRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.conversationId = _data['conversationId'];
      this.lastReadMessageId = _data['lastReadMessageId'];
    }
  }

  static fromJS(data: any): MarkChatConversationReadRequest {
    data = typeof data === 'object' ? data : {};
    let result = new MarkChatConversationReadRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['conversationId'] = this.conversationId;
    data['lastReadMessageId'] = this.lastReadMessageId;
    return data;
  }
}

export interface IMarkChatConversationReadRequest {
  conversationId?: string;
  lastReadMessageId?: string | undefined;
}

export class OrderActivityDto implements IOrderActivityDto {
  id?: string;
  serviceOrderId?: string;
  type?: string;
  message?: string;
  payloadJson?: string | undefined;
  fileName?: string | undefined;
  url?: string | undefined;
  minutes?: number | undefined;
  employeeId?: string | undefined;
  worker?: string | undefined;
  assignedEmployeeId?: string | undefined;
  assignedWorker?: string | undefined;
  createdAt?: string;

  constructor(data?: IOrderActivityDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.serviceOrderId = _data['serviceOrderId'];
      this.type = _data['type'];
      this.message = _data['message'];
      this.payloadJson = _data['payloadJson'];
      this.fileName = _data['fileName'];
      this.url = _data['url'];
      this.minutes = _data['minutes'];
      this.employeeId = _data['employeeId'];
      this.worker = _data['worker'];
      this.assignedEmployeeId = _data['assignedEmployeeId'];
      this.assignedWorker = _data['assignedWorker'];
      this.createdAt = _data['createdAt'];
    }
  }

  static fromJS(data: any): OrderActivityDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderActivityDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['serviceOrderId'] = this.serviceOrderId;
    data['type'] = this.type;
    data['message'] = this.message;
    data['payloadJson'] = this.payloadJson;
    data['fileName'] = this.fileName;
    data['url'] = this.url;
    data['minutes'] = this.minutes;
    data['employeeId'] = this.employeeId;
    data['worker'] = this.worker;
    data['assignedEmployeeId'] = this.assignedEmployeeId;
    data['assignedWorker'] = this.assignedWorker;
    data['createdAt'] = this.createdAt;
    return data;
  }
}

export interface IOrderActivityDto {
  id?: string;
  serviceOrderId?: string;
  type?: string;
  message?: string;
  payloadJson?: string | undefined;
  fileName?: string | undefined;
  url?: string | undefined;
  minutes?: number | undefined;
  employeeId?: string | undefined;
  worker?: string | undefined;
  assignedEmployeeId?: string | undefined;
  assignedWorker?: string | undefined;
  createdAt?: string;
}

export class AddOrderCommentRequest implements IAddOrderCommentRequest {
  serviceOrderId?: string;
  message?: string;

  constructor(data?: IAddOrderCommentRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceOrderId = _data['serviceOrderId'];
      this.message = _data['message'];
    }
  }

  static fromJS(data: any): AddOrderCommentRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AddOrderCommentRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['serviceOrderId'] = this.serviceOrderId;
    data['message'] = this.message;
    return data;
  }
}

export interface IAddOrderCommentRequest {
  serviceOrderId?: string;
  message?: string;
}

export class AddOrderAttachmentRequest implements IAddOrderAttachmentRequest {
  serviceOrderId?: string;
  fileName?: string;
  url?: string | undefined;
  description?: string | undefined;

  constructor(data?: IAddOrderAttachmentRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceOrderId = _data['serviceOrderId'];
      this.fileName = _data['fileName'];
      this.url = _data['url'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): AddOrderAttachmentRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AddOrderAttachmentRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['serviceOrderId'] = this.serviceOrderId;
    data['fileName'] = this.fileName;
    data['url'] = this.url;
    data['description'] = this.description;
    return data;
  }
}

export interface IAddOrderAttachmentRequest {
  serviceOrderId?: string;
  fileName?: string;
  url?: string | undefined;
  description?: string | undefined;
}

export class AddOrderPhotoRequest implements IAddOrderPhotoRequest {
  serviceOrderId?: string;
  fileName?: string;
  url?: string | undefined;
  description?: string | undefined;

  constructor(data?: IAddOrderPhotoRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceOrderId = _data['serviceOrderId'];
      this.fileName = _data['fileName'];
      this.url = _data['url'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): AddOrderPhotoRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AddOrderPhotoRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['serviceOrderId'] = this.serviceOrderId;
    data['fileName'] = this.fileName;
    data['url'] = this.url;
    data['description'] = this.description;
    return data;
  }
}

export interface IAddOrderPhotoRequest {
  serviceOrderId?: string;
  fileName?: string;
  url?: string | undefined;
  description?: string | undefined;
}

export class AddOrderTimeEntryRequest implements IAddOrderTimeEntryRequest {
  serviceOrderId?: string;
  employeeId?: string | undefined;
  worker?: string | undefined;
  minutes?: number;
  description?: string | undefined;

  constructor(data?: IAddOrderTimeEntryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceOrderId = _data['serviceOrderId'];
      this.employeeId = _data['employeeId'];
      this.worker = _data['worker'];
      this.minutes = _data['minutes'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): AddOrderTimeEntryRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AddOrderTimeEntryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['serviceOrderId'] = this.serviceOrderId;
    data['employeeId'] = this.employeeId;
    data['worker'] = this.worker;
    data['minutes'] = this.minutes;
    data['description'] = this.description;
    return data;
  }
}

export interface IAddOrderTimeEntryRequest {
  serviceOrderId?: string;
  employeeId?: string | undefined;
  worker?: string | undefined;
  minutes?: number;
  description?: string | undefined;
}

export class PaginationResponseOfServiceOrderDto
  implements IPaginationResponseOfServiceOrderDto
{
  data?: ServiceOrderDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfServiceOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(ServiceOrderDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfServiceOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfServiceOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfServiceOrderDto {
  data?: ServiceOrderDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class ServiceOrderDto implements IServiceOrderDto {
  id?: string;
  number?: string;
  customerId?: string | undefined;
  customerName?: string;
  phone?: string;
  serviceId?: string | undefined;
  serviceName?: string | undefined;
  assignedEmployeeId?: string | undefined;
  assignedWorker?: string | undefined;
  assignedEmployees?: AssignedEmployeeDto[];
  subject?: string | undefined;
  description?: string | undefined;
  scheduledAt?: string | undefined;
  statusId?: string | undefined;
  statusKey?: string;
  value?: number | undefined;
  source?: string | undefined;
  customFields?: any | undefined;
  updatedAt?: string;
  followersCount?: number;
  isFollowedByCurrentUser?: boolean;

  constructor(data?: IServiceOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.number = _data['number'];
      this.customerId = _data['customerId'];
      this.customerName = _data['customerName'];
      this.phone = _data['phone'];
      this.serviceId = _data['serviceId'];
      this.serviceName = _data['serviceName'];
      this.assignedEmployeeId = _data['assignedEmployeeId'];
      this.assignedWorker = _data['assignedWorker'];
      if (Array.isArray(_data['assignedEmployees'])) {
        this.assignedEmployees = [] as any;
        for (let item of _data['assignedEmployees'])
          this.assignedEmployees!.push(AssignedEmployeeDto.fromJS(item));
      }
      this.subject = _data['subject'];
      this.description = _data['description'];
      this.scheduledAt = _data['scheduledAt'];
      this.statusId = _data['statusId'];
      this.statusKey = _data['statusKey'];
      this.value = _data['value'];
      this.source = _data['source'];
      this.customFields = _data['customFields'];
      this.updatedAt = _data['updatedAt'];
      this.followersCount = _data['followersCount'];
      this.isFollowedByCurrentUser = _data['isFollowedByCurrentUser'];
    }
  }

  static fromJS(data: any): ServiceOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new ServiceOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['number'] = this.number;
    data['customerId'] = this.customerId;
    data['customerName'] = this.customerName;
    data['phone'] = this.phone;
    data['serviceId'] = this.serviceId;
    data['serviceName'] = this.serviceName;
    data['assignedEmployeeId'] = this.assignedEmployeeId;
    data['assignedWorker'] = this.assignedWorker;
    if (Array.isArray(this.assignedEmployees)) {
      data['assignedEmployees'] = [];
      for (let item of this.assignedEmployees)
        data['assignedEmployees'].push(item.toJSON());
    }
    data['subject'] = this.subject;
    data['description'] = this.description;
    data['scheduledAt'] = this.scheduledAt;
    data['statusId'] = this.statusId;
    data['statusKey'] = this.statusKey;
    data['value'] = this.value;
    data['source'] = this.source;
    data['customFields'] = this.customFields;
    data['updatedAt'] = this.updatedAt;
    data['followersCount'] = this.followersCount;
    data['isFollowedByCurrentUser'] = this.isFollowedByCurrentUser;
    return data;
  }
}

export interface IServiceOrderDto {
  id?: string;
  number?: string;
  customerId?: string | undefined;
  customerName?: string;
  phone?: string;
  serviceId?: string | undefined;
  serviceName?: string | undefined;
  assignedEmployeeId?: string | undefined;
  assignedWorker?: string | undefined;
  assignedEmployees?: AssignedEmployeeDto[];
  subject?: string | undefined;
  description?: string | undefined;
  scheduledAt?: string | undefined;
  statusId?: string | undefined;
  statusKey?: string;
  value?: number | undefined;
  source?: string | undefined;
  customFields?: any | undefined;
  updatedAt?: string;
  followersCount?: number;
  isFollowedByCurrentUser?: boolean;
}

export class AssignedEmployeeDto implements IAssignedEmployeeDto {
  id?: string;
  fullName?: string;
  position?: string | undefined;
  email?: string | undefined;

  constructor(data?: IAssignedEmployeeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.fullName = _data['fullName'];
      this.position = _data['position'];
      this.email = _data['email'];
    }
  }

  static fromJS(data: any): AssignedEmployeeDto {
    data = typeof data === 'object' ? data : {};
    let result = new AssignedEmployeeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['position'] = this.position;
    data['email'] = this.email;
    return data;
  }
}

export interface IAssignedEmployeeDto {
  id?: string;
  fullName?: string;
  position?: string | undefined;
  email?: string | undefined;
}

export class SearchServiceOrdersRequest
  extends PaginationFilter
  implements ISearchServiceOrdersRequest
{
  statusKey?: string | undefined;
  statusId?: string | undefined;
  customerId?: string | undefined;

  constructor(data?: ISearchServiceOrdersRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.statusKey = _data['statusKey'];
      this.statusId = _data['statusId'];
      this.customerId = _data['customerId'];
    }
  }

  static fromJS(data: any): SearchServiceOrdersRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchServiceOrdersRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['statusKey'] = this.statusKey;
    data['statusId'] = this.statusId;
    data['customerId'] = this.customerId;
    super.toJSON(data);
    return data;
  }
}

export interface ISearchServiceOrdersRequest extends IPaginationFilter {
  statusKey?: string | undefined;
  statusId?: string | undefined;
  customerId?: string | undefined;
}

export class CreateServiceOrderRequest implements ICreateServiceOrderRequest {
  number?: string | undefined;
  customerId?: string | undefined;
  customerName?: string | undefined;
  phone?: string | undefined;
  serviceId?: string | undefined;
  serviceName?: string | undefined;
  subject!: string;
  description!: string;
  scheduledAt?: string | undefined;
  statusId?: string | undefined;
  statusKey?: string | undefined;
  value?: number | undefined;
  source?: string | undefined;
  customFields?: any | undefined;
  generatePublicStatusAndNotify?: boolean;

  constructor(data?: ICreateServiceOrderRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.number = _data['number'];
      this.customerId = _data['customerId'];
      this.customerName = _data['customerName'];
      this.phone = _data['phone'];
      this.serviceId = _data['serviceId'];
      this.serviceName = _data['serviceName'];
      this.subject = _data['subject'];
      this.description = _data['description'];
      this.scheduledAt = _data['scheduledAt'];
      this.statusId = _data['statusId'];
      this.statusKey = _data['statusKey'];
      this.value = _data['value'];
      this.source = _data['source'];
      this.customFields = _data['customFields'];
      this.generatePublicStatusAndNotify =
        _data['generatePublicStatusAndNotify'];
    }
  }

  static fromJS(data: any): CreateServiceOrderRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateServiceOrderRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['number'] = this.number;
    data['customerId'] = this.customerId;
    data['customerName'] = this.customerName;
    data['phone'] = this.phone;
    data['serviceId'] = this.serviceId;
    data['serviceName'] = this.serviceName;
    data['subject'] = this.subject;
    data['description'] = this.description;
    data['scheduledAt'] = this.scheduledAt;
    data['statusId'] = this.statusId;
    data['statusKey'] = this.statusKey;
    data['value'] = this.value;
    data['source'] = this.source;
    data['customFields'] = this.customFields;
    data['generatePublicStatusAndNotify'] = this.generatePublicStatusAndNotify;
    return data;
  }
}

export interface ICreateServiceOrderRequest {
  number?: string | undefined;
  customerId?: string | undefined;
  customerName?: string | undefined;
  phone?: string | undefined;
  serviceId?: string | undefined;
  serviceName?: string | undefined;
  subject: string;
  description: string;
  scheduledAt?: string | undefined;
  statusId?: string | undefined;
  statusKey?: string | undefined;
  value?: number | undefined;
  source?: string | undefined;
  customFields?: any | undefined;
  generatePublicStatusAndNotify?: boolean;
}

export class UpdateServiceOrderRequest implements IUpdateServiceOrderRequest {
  id?: string;
  customerId?: string | undefined;
  customerName?: string;
  phone?: string;
  serviceId?: string | undefined;
  serviceName?: string | undefined;
  subject?: string | undefined;
  description?: string | undefined;
  scheduledAt?: string | undefined;
  statusId?: string | undefined;
  statusKey?: string | undefined;
  value?: number | undefined;
  source?: string | undefined;
  customFields?: any | undefined;

  constructor(data?: IUpdateServiceOrderRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.customerId = _data['customerId'];
      this.customerName = _data['customerName'];
      this.phone = _data['phone'];
      this.serviceId = _data['serviceId'];
      this.serviceName = _data['serviceName'];
      this.subject = _data['subject'];
      this.description = _data['description'];
      this.scheduledAt = _data['scheduledAt'];
      this.statusId = _data['statusId'];
      this.statusKey = _data['statusKey'];
      this.value = _data['value'];
      this.source = _data['source'];
      this.customFields = _data['customFields'];
    }
  }

  static fromJS(data: any): UpdateServiceOrderRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateServiceOrderRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['customerId'] = this.customerId;
    data['customerName'] = this.customerName;
    data['phone'] = this.phone;
    data['serviceId'] = this.serviceId;
    data['serviceName'] = this.serviceName;
    data['subject'] = this.subject;
    data['description'] = this.description;
    data['scheduledAt'] = this.scheduledAt;
    data['statusId'] = this.statusId;
    data['statusKey'] = this.statusKey;
    data['value'] = this.value;
    data['source'] = this.source;
    data['customFields'] = this.customFields;
    return data;
  }
}

export interface IUpdateServiceOrderRequest {
  id?: string;
  customerId?: string | undefined;
  customerName?: string;
  phone?: string;
  serviceId?: string | undefined;
  serviceName?: string | undefined;
  subject?: string | undefined;
  description?: string | undefined;
  scheduledAt?: string | undefined;
  statusId?: string | undefined;
  statusKey?: string | undefined;
  value?: number | undefined;
  source?: string | undefined;
  customFields?: any | undefined;
}

export class ChangeServiceOrderStatusRequest
  implements IChangeServiceOrderStatusRequest
{
  id?: string;
  statusId?: string | undefined;
  statusKey?: string | undefined;

  constructor(data?: IChangeServiceOrderStatusRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.statusId = _data['statusId'];
      this.statusKey = _data['statusKey'];
    }
  }

  static fromJS(data: any): ChangeServiceOrderStatusRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ChangeServiceOrderStatusRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['statusId'] = this.statusId;
    data['statusKey'] = this.statusKey;
    return data;
  }
}

export interface IChangeServiceOrderStatusRequest {
  id?: string;
  statusId?: string | undefined;
  statusKey?: string | undefined;
}

export class ScheduleServiceOrderRequest
  implements IScheduleServiceOrderRequest
{
  id?: string;
  scheduledAt?: string | undefined;

  constructor(data?: IScheduleServiceOrderRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.scheduledAt = _data['scheduledAt'];
    }
  }

  static fromJS(data: any): ScheduleServiceOrderRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ScheduleServiceOrderRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['scheduledAt'] = this.scheduledAt;
    return data;
  }
}

export interface IScheduleServiceOrderRequest {
  id?: string;
  scheduledAt?: string | undefined;
}

export class AssignServiceOrderRequest implements IAssignServiceOrderRequest {
  id?: string;
  employeeId?: string | undefined;
  employeeName?: string | undefined;

  constructor(data?: IAssignServiceOrderRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.employeeId = _data['employeeId'];
      this.employeeName = _data['employeeName'];
    }
  }

  static fromJS(data: any): AssignServiceOrderRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AssignServiceOrderRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['employeeId'] = this.employeeId;
    data['employeeName'] = this.employeeName;
    return data;
  }
}

export interface IAssignServiceOrderRequest {
  id?: string;
  employeeId?: string | undefined;
  employeeName?: string | undefined;
}

export class UpdateServiceOrderEmployeesRequest
  implements IUpdateServiceOrderEmployeesRequest
{
  id?: string;
  employeeIds?: string[];

  constructor(data?: IUpdateServiceOrderEmployeesRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      if (Array.isArray(_data['employeeIds'])) {
        this.employeeIds = [] as any;
        for (let item of _data['employeeIds']) this.employeeIds!.push(item);
      }
    }
  }

  static fromJS(data: any): UpdateServiceOrderEmployeesRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateServiceOrderEmployeesRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    if (Array.isArray(this.employeeIds)) {
      data['employeeIds'] = [];
      for (let item of this.employeeIds) data['employeeIds'].push(item);
    }
    return data;
  }
}

export interface IUpdateServiceOrderEmployeesRequest {
  id?: string;
  employeeIds?: string[];
}

export class OrderStatusDto implements IOrderStatusDto {
  id?: string;
  key?: string;
  name?: string;
  color?: string | undefined;
  sortOrder?: number;
  isDefault?: boolean;
  isFinal?: boolean;

  constructor(data?: IOrderStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.key = _data['key'];
      this.name = _data['name'];
      this.color = _data['color'];
      this.sortOrder = _data['sortOrder'];
      this.isDefault = _data['isDefault'];
      this.isFinal = _data['isFinal'];
    }
  }

  static fromJS(data: any): OrderStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrderStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['key'] = this.key;
    data['name'] = this.name;
    data['color'] = this.color;
    data['sortOrder'] = this.sortOrder;
    data['isDefault'] = this.isDefault;
    data['isFinal'] = this.isFinal;
    return data;
  }
}

export interface IOrderStatusDto {
  id?: string;
  key?: string;
  name?: string;
  color?: string | undefined;
  sortOrder?: number;
  isDefault?: boolean;
  isFinal?: boolean;
}

export class CreateOrderStatusRequest implements ICreateOrderStatusRequest {
  key?: string;
  name?: string;
  color?: string | undefined;
  sortOrder?: number;
  isDefault?: boolean;
  isFinal?: boolean;

  constructor(data?: ICreateOrderStatusRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data['key'];
      this.name = _data['name'];
      this.color = _data['color'];
      this.sortOrder = _data['sortOrder'];
      this.isDefault = _data['isDefault'];
      this.isFinal = _data['isFinal'];
    }
  }

  static fromJS(data: any): CreateOrderStatusRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrderStatusRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['key'] = this.key;
    data['name'] = this.name;
    data['color'] = this.color;
    data['sortOrder'] = this.sortOrder;
    data['isDefault'] = this.isDefault;
    data['isFinal'] = this.isFinal;
    return data;
  }
}

export interface ICreateOrderStatusRequest {
  key?: string;
  name?: string;
  color?: string | undefined;
  sortOrder?: number;
  isDefault?: boolean;
  isFinal?: boolean;
}

export class UpdateOrderStatusRequest implements IUpdateOrderStatusRequest {
  id?: string;
  key?: string;
  name?: string;
  color?: string | undefined;
  sortOrder?: number;
  isDefault?: boolean;
  isFinal?: boolean;

  constructor(data?: IUpdateOrderStatusRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.key = _data['key'];
      this.name = _data['name'];
      this.color = _data['color'];
      this.sortOrder = _data['sortOrder'];
      this.isDefault = _data['isDefault'];
      this.isFinal = _data['isFinal'];
    }
  }

  static fromJS(data: any): UpdateOrderStatusRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateOrderStatusRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['key'] = this.key;
    data['name'] = this.name;
    data['color'] = this.color;
    data['sortOrder'] = this.sortOrder;
    data['isDefault'] = this.isDefault;
    data['isFinal'] = this.isFinal;
    return data;
  }
}

export interface IUpdateOrderStatusRequest {
  id?: string;
  key?: string;
  name?: string;
  color?: string | undefined;
  sortOrder?: number;
  isDefault?: boolean;
  isFinal?: boolean;
}

export class PositionDto implements IPositionDto {
  id?: string;
  key?: string;
  name?: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;

  constructor(data?: IPositionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.key = _data['key'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.sortOrder = _data['sortOrder'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): PositionDto {
    data = typeof data === 'object' ? data : {};
    let result = new PositionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['key'] = this.key;
    data['name'] = this.name;
    data['description'] = this.description;
    data['sortOrder'] = this.sortOrder;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IPositionDto {
  id?: string;
  key?: string;
  name?: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;
}

export class CreatePositionRequest implements ICreatePositionRequest {
  key!: string;
  name!: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;

  constructor(data?: ICreatePositionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data['key'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.sortOrder = _data['sortOrder'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): CreatePositionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreatePositionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['key'] = this.key;
    data['name'] = this.name;
    data['description'] = this.description;
    data['sortOrder'] = this.sortOrder;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface ICreatePositionRequest {
  key: string;
  name: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;
}

export class UpdatePositionRequest implements IUpdatePositionRequest {
  id!: string;
  key!: string;
  name!: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;

  constructor(data?: IUpdatePositionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.key = _data['key'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.sortOrder = _data['sortOrder'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): UpdatePositionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdatePositionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['key'] = this.key;
    data['name'] = this.name;
    data['description'] = this.description;
    data['sortOrder'] = this.sortOrder;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IUpdatePositionRequest {
  id: string;
  key: string;
  name: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;
}

export class PublicCompanySearchResponse
  implements IPublicCompanySearchResponse
{
  data?: PublicCompanySearchItemDto[];
  totalCount?: number;

  constructor(data?: IPublicCompanySearchResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(PublicCompanySearchItemDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(data: any): PublicCompanySearchResponse {
    data = typeof data === 'object' ? data : {};
    let result = new PublicCompanySearchResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPublicCompanySearchResponse {
  data?: PublicCompanySearchItemDto[];
  totalCount?: number;
}

export class PublicCompanySearchItemDto implements IPublicCompanySearchItemDto {
  tenantId?: string;
  companyName?: string;
  friendlyUrl?: string;
  city?: string | undefined;
  industry?: string | undefined;
  description?: string | undefined;
  logoUrl?: string | undefined;
  showInDirectory?: boolean;

  constructor(data?: IPublicCompanySearchItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data['tenantId'];
      this.companyName = _data['companyName'];
      this.friendlyUrl = _data['friendlyUrl'];
      this.city = _data['city'];
      this.industry = _data['industry'];
      this.description = _data['description'];
      this.logoUrl = _data['logoUrl'];
      this.showInDirectory = _data['showInDirectory'];
    }
  }

  static fromJS(data: any): PublicCompanySearchItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicCompanySearchItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenantId'] = this.tenantId;
    data['companyName'] = this.companyName;
    data['friendlyUrl'] = this.friendlyUrl;
    data['city'] = this.city;
    data['industry'] = this.industry;
    data['description'] = this.description;
    data['logoUrl'] = this.logoUrl;
    data['showInDirectory'] = this.showInDirectory;
    return data;
  }
}

export interface IPublicCompanySearchItemDto {
  tenantId?: string;
  companyName?: string;
  friendlyUrl?: string;
  city?: string | undefined;
  industry?: string | undefined;
  description?: string | undefined;
  logoUrl?: string | undefined;
  showInDirectory?: boolean;
}

export class PublicProfileDto implements IPublicProfileDto {
  id?: string;
  friendlyUrl?: string;
  preset?: string;
  showTopMenu?: boolean;
  templateId?: string | undefined;
  companyName?: string;
  city?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
  address?: string | undefined;
  tagline?: string | undefined;
  description?: string | undefined;
  workingHours?: string | undefined;
  industry?: string | undefined;
  logoUrl?: string | undefined;
  showInDirectory?: boolean;
  isPublished?: boolean;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  settingsJson?: string | undefined;

  constructor(data?: IPublicProfileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.friendlyUrl = _data['friendlyUrl'];
      this.preset = _data['preset'];
      this.showTopMenu = _data['showTopMenu'];
      this.templateId = _data['templateId'];
      this.companyName = _data['companyName'];
      this.city = _data['city'];
      this.phone = _data['phone'];
      this.email = _data['email'];
      this.address = _data['address'];
      this.tagline = _data['tagline'];
      this.description = _data['description'];
      this.workingHours = _data['workingHours'];
      this.industry = _data['industry'];
      this.logoUrl = _data['logoUrl'];
      this.showInDirectory = _data['showInDirectory'];
      this.isPublished = _data['isPublished'];
      this.seoTitle = _data['seoTitle'];
      this.seoDescription = _data['seoDescription'];
      this.settingsJson = _data['settingsJson'];
    }
  }

  static fromJS(data: any): PublicProfileDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicProfileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['friendlyUrl'] = this.friendlyUrl;
    data['preset'] = this.preset;
    data['showTopMenu'] = this.showTopMenu;
    data['templateId'] = this.templateId;
    data['companyName'] = this.companyName;
    data['city'] = this.city;
    data['phone'] = this.phone;
    data['email'] = this.email;
    data['address'] = this.address;
    data['tagline'] = this.tagline;
    data['description'] = this.description;
    data['workingHours'] = this.workingHours;
    data['industry'] = this.industry;
    data['logoUrl'] = this.logoUrl;
    data['showInDirectory'] = this.showInDirectory;
    data['isPublished'] = this.isPublished;
    data['seoTitle'] = this.seoTitle;
    data['seoDescription'] = this.seoDescription;
    data['settingsJson'] = this.settingsJson;
    return data;
  }
}

export interface IPublicProfileDto {
  id?: string;
  friendlyUrl?: string;
  preset?: string;
  showTopMenu?: boolean;
  templateId?: string | undefined;
  companyName?: string;
  city?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
  address?: string | undefined;
  tagline?: string | undefined;
  description?: string | undefined;
  workingHours?: string | undefined;
  industry?: string | undefined;
  logoUrl?: string | undefined;
  showInDirectory?: boolean;
  isPublished?: boolean;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  settingsJson?: string | undefined;
}

export class UpsertPublicProfileSettingsRequest
  implements IUpsertPublicProfileSettingsRequest
{
  friendlyUrl!: string;
  preset?: string;
  showTopMenu?: boolean;
  templateId?: string | undefined;
  companyName!: string;
  city?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
  address?: string | undefined;
  tagline?: string | undefined;
  description?: string | undefined;
  workingHours?: string | undefined;
  industry?: string | undefined;
  logoUrl?: string | undefined;
  showInDirectory?: boolean;
  isPublished?: boolean;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  settingsJson?: string | undefined;

  constructor(data?: IUpsertPublicProfileSettingsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.friendlyUrl = _data['friendlyUrl'];
      this.preset = _data['preset'];
      this.showTopMenu = _data['showTopMenu'];
      this.templateId = _data['templateId'];
      this.companyName = _data['companyName'];
      this.city = _data['city'];
      this.phone = _data['phone'];
      this.email = _data['email'];
      this.address = _data['address'];
      this.tagline = _data['tagline'];
      this.description = _data['description'];
      this.workingHours = _data['workingHours'];
      this.industry = _data['industry'];
      this.logoUrl = _data['logoUrl'];
      this.showInDirectory = _data['showInDirectory'];
      this.isPublished = _data['isPublished'];
      this.seoTitle = _data['seoTitle'];
      this.seoDescription = _data['seoDescription'];
      this.settingsJson = _data['settingsJson'];
    }
  }

  static fromJS(data: any): UpsertPublicProfileSettingsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpsertPublicProfileSettingsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['friendlyUrl'] = this.friendlyUrl;
    data['preset'] = this.preset;
    data['showTopMenu'] = this.showTopMenu;
    data['templateId'] = this.templateId;
    data['companyName'] = this.companyName;
    data['city'] = this.city;
    data['phone'] = this.phone;
    data['email'] = this.email;
    data['address'] = this.address;
    data['tagline'] = this.tagline;
    data['description'] = this.description;
    data['workingHours'] = this.workingHours;
    data['industry'] = this.industry;
    data['logoUrl'] = this.logoUrl;
    data['showInDirectory'] = this.showInDirectory;
    data['isPublished'] = this.isPublished;
    data['seoTitle'] = this.seoTitle;
    data['seoDescription'] = this.seoDescription;
    data['settingsJson'] = this.settingsJson;
    return data;
  }
}

export interface IUpsertPublicProfileSettingsRequest {
  friendlyUrl: string;
  preset?: string;
  showTopMenu?: boolean;
  templateId?: string | undefined;
  companyName: string;
  city?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
  address?: string | undefined;
  tagline?: string | undefined;
  description?: string | undefined;
  workingHours?: string | undefined;
  industry?: string | undefined;
  logoUrl?: string | undefined;
  showInDirectory?: boolean;
  isPublished?: boolean;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  settingsJson?: string | undefined;
}

export class PublicProfileLayoutVersionDto
  implements IPublicProfileLayoutVersionDto
{
  id?: string;
  layoutJson?: string;
  layout?: any;
  createdAt?: string;
  archivedAt?: string;
  createdByUserId?: string | undefined;
  createdByDisplayName?: string | undefined;
  wasPublished?: boolean;
  templateId?: string | undefined;

  constructor(data?: IPublicProfileLayoutVersionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.layoutJson = _data['layoutJson'];
      this.layout = _data['layout'];
      this.createdAt = _data['createdAt'];
      this.archivedAt = _data['archivedAt'];
      this.createdByUserId = _data['createdByUserId'];
      this.createdByDisplayName = _data['createdByDisplayName'];
      this.wasPublished = _data['wasPublished'];
      this.templateId = _data['templateId'];
    }
  }

  static fromJS(data: any): PublicProfileLayoutVersionDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicProfileLayoutVersionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['layoutJson'] = this.layoutJson;
    data['layout'] = this.layout;
    data['createdAt'] = this.createdAt;
    data['archivedAt'] = this.archivedAt;
    data['createdByUserId'] = this.createdByUserId;
    data['createdByDisplayName'] = this.createdByDisplayName;
    data['wasPublished'] = this.wasPublished;
    data['templateId'] = this.templateId;
    return data;
  }
}

export interface IPublicProfileLayoutVersionDto {
  id?: string;
  layoutJson?: string;
  layout?: any;
  createdAt?: string;
  archivedAt?: string;
  createdByUserId?: string | undefined;
  createdByDisplayName?: string | undefined;
  wasPublished?: boolean;
  templateId?: string | undefined;
}

export class CreatePublicProfilePreviewResponse
  implements ICreatePublicProfilePreviewResponse
{
  token?: string;
  expiresAt?: string;
  previewUrl?: string;

  constructor(data?: ICreatePublicProfilePreviewResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data['token'];
      this.expiresAt = _data['expiresAt'];
      this.previewUrl = _data['previewUrl'];
    }
  }

  static fromJS(data: any): CreatePublicProfilePreviewResponse {
    data = typeof data === 'object' ? data : {};
    let result = new CreatePublicProfilePreviewResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['token'] = this.token;
    data['expiresAt'] = this.expiresAt;
    data['previewUrl'] = this.previewUrl;
    return data;
  }
}

export interface ICreatePublicProfilePreviewResponse {
  token?: string;
  expiresAt?: string;
  previewUrl?: string;
}

export class CreatePublicProfilePreviewRequest
  implements ICreatePublicProfilePreviewRequest
{
  settings?: any | undefined;
  settingsJson?: string | undefined;
  layout?: any | undefined;
  layoutJson?: string | undefined;
  ttlMinutes?: number | undefined;

  constructor(data?: ICreatePublicProfilePreviewRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.settings = _data['settings'];
      this.settingsJson = _data['settingsJson'];
      this.layout = _data['layout'];
      this.layoutJson = _data['layoutJson'];
      this.ttlMinutes = _data['ttlMinutes'];
    }
  }

  static fromJS(data: any): CreatePublicProfilePreviewRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreatePublicProfilePreviewRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['settings'] = this.settings;
    data['settingsJson'] = this.settingsJson;
    data['layout'] = this.layout;
    data['layoutJson'] = this.layoutJson;
    data['ttlMinutes'] = this.ttlMinutes;
    return data;
  }
}

export interface ICreatePublicProfilePreviewRequest {
  settings?: any | undefined;
  settingsJson?: string | undefined;
  layout?: any | undefined;
  layoutJson?: string | undefined;
  ttlMinutes?: number | undefined;
}

export class PublicProfilePreviewDto implements IPublicProfilePreviewDto {
  token?: string;
  expiresAt?: string;
  friendlyUrl?: string;
  profile?: PublicProfileDto;
  settings?: any;
  settingsJson?: string;

  constructor(data?: IPublicProfilePreviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data['token'];
      this.expiresAt = _data['expiresAt'];
      this.friendlyUrl = _data['friendlyUrl'];
      this.profile = _data['profile']
        ? PublicProfileDto.fromJS(_data['profile'])
        : <any>undefined;
      this.settings = _data['settings'];
      this.settingsJson = _data['settingsJson'];
    }
  }

  static fromJS(data: any): PublicProfilePreviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicProfilePreviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['token'] = this.token;
    data['expiresAt'] = this.expiresAt;
    data['friendlyUrl'] = this.friendlyUrl;
    data['profile'] = this.profile ? this.profile.toJSON() : <any>undefined;
    data['settings'] = this.settings;
    data['settingsJson'] = this.settingsJson;
    return data;
  }
}

export interface IPublicProfilePreviewDto {
  token?: string;
  expiresAt?: string;
  friendlyUrl?: string;
  profile?: PublicProfileDto;
  settings?: any;
  settingsJson?: string;
}

export class PublicProfileTemplatesResponse
  implements IPublicProfileTemplatesResponse
{
  templates?: PublicProfileTemplateDto[];

  constructor(data?: IPublicProfileTemplatesResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['templates'])) {
        this.templates = [] as any;
        for (let item of _data['templates'])
          this.templates!.push(PublicProfileTemplateDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PublicProfileTemplatesResponse {
    data = typeof data === 'object' ? data : {};
    let result = new PublicProfileTemplatesResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.templates)) {
      data['templates'] = [];
      for (let item of this.templates) data['templates'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPublicProfileTemplatesResponse {
  templates?: PublicProfileTemplateDto[];
}

export class PublicProfileTemplateDto implements IPublicProfileTemplateDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  supportsHomePage?: boolean;
  supportsCustomPage?: boolean;
  supportsBlogList?: boolean;
  supportsBlogPost?: boolean;
  isSystem?: boolean;
  tenantId?: string | undefined;
  customerId?: string | undefined;

  constructor(data?: IPublicProfileTemplateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.supportsHomePage = _data['supportsHomePage'];
      this.supportsCustomPage = _data['supportsCustomPage'];
      this.supportsBlogList = _data['supportsBlogList'];
      this.supportsBlogPost = _data['supportsBlogPost'];
      this.isSystem = _data['isSystem'];
      this.tenantId = _data['tenantId'];
      this.customerId = _data['customerId'];
    }
  }

  static fromJS(data: any): PublicProfileTemplateDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicProfileTemplateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    data['supportsHomePage'] = this.supportsHomePage;
    data['supportsCustomPage'] = this.supportsCustomPage;
    data['supportsBlogList'] = this.supportsBlogList;
    data['supportsBlogPost'] = this.supportsBlogPost;
    data['isSystem'] = this.isSystem;
    data['tenantId'] = this.tenantId;
    data['customerId'] = this.customerId;
    return data;
  }
}

export interface IPublicProfileTemplateDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  supportsHomePage?: boolean;
  supportsCustomPage?: boolean;
  supportsBlogList?: boolean;
  supportsBlogPost?: boolean;
  isSystem?: boolean;
  tenantId?: string | undefined;
  customerId?: string | undefined;
}

export class PublicProfileSectionDto implements IPublicProfileSectionDto {
  key?: string;
  title?: string;
  description?: string | undefined;
  sortOrder?: number;
  isPublished?: boolean;
  items?: PublicProfileSectionItemDto[];

  constructor(data?: IPublicProfileSectionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data['key'];
      this.title = _data['title'];
      this.description = _data['description'];
      this.sortOrder = _data['sortOrder'];
      this.isPublished = _data['isPublished'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items'])
          this.items!.push(PublicProfileSectionItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PublicProfileSectionDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicProfileSectionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['key'] = this.key;
    data['title'] = this.title;
    data['description'] = this.description;
    data['sortOrder'] = this.sortOrder;
    data['isPublished'] = this.isPublished;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPublicProfileSectionDto {
  key?: string;
  title?: string;
  description?: string | undefined;
  sortOrder?: number;
  isPublished?: boolean;
  items?: PublicProfileSectionItemDto[];
}

export class PublicProfileSectionItemDto
  implements IPublicProfileSectionItemDto
{
  key?: string;
  title?: string;
  description?: string | undefined;
  sortOrder?: number;

  constructor(data?: IPublicProfileSectionItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data['key'];
      this.title = _data['title'];
      this.description = _data['description'];
      this.sortOrder = _data['sortOrder'];
    }
  }

  static fromJS(data: any): PublicProfileSectionItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicProfileSectionItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['key'] = this.key;
    data['title'] = this.title;
    data['description'] = this.description;
    data['sortOrder'] = this.sortOrder;
    return data;
  }
}

export interface IPublicProfileSectionItemDto {
  key?: string;
  title?: string;
  description?: string | undefined;
  sortOrder?: number;
}

export class CreatePublicProfileSectionRequest
  implements ICreatePublicProfileSectionRequest
{
  key?: string;
  title?: string;
  description?: string | undefined;
  sortOrder?: number;
  isPublished?: boolean;
  items?: PublicProfileSectionItemDto[];

  constructor(data?: ICreatePublicProfileSectionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data['key'];
      this.title = _data['title'];
      this.description = _data['description'];
      this.sortOrder = _data['sortOrder'];
      this.isPublished = _data['isPublished'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items'])
          this.items!.push(PublicProfileSectionItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CreatePublicProfileSectionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreatePublicProfileSectionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['key'] = this.key;
    data['title'] = this.title;
    data['description'] = this.description;
    data['sortOrder'] = this.sortOrder;
    data['isPublished'] = this.isPublished;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface ICreatePublicProfileSectionRequest {
  key?: string;
  title?: string;
  description?: string | undefined;
  sortOrder?: number;
  isPublished?: boolean;
  items?: PublicProfileSectionItemDto[];
}

export class UpdatePublicProfileSectionRequest
  implements IUpdatePublicProfileSectionRequest
{
  key?: string;
  title?: string;
  description?: string | undefined;
  sortOrder?: number;
  isPublished?: boolean;
  items?: PublicProfileSectionItemDto[];

  constructor(data?: IUpdatePublicProfileSectionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data['key'];
      this.title = _data['title'];
      this.description = _data['description'];
      this.sortOrder = _data['sortOrder'];
      this.isPublished = _data['isPublished'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items'])
          this.items!.push(PublicProfileSectionItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UpdatePublicProfileSectionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdatePublicProfileSectionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['key'] = this.key;
    data['title'] = this.title;
    data['description'] = this.description;
    data['sortOrder'] = this.sortOrder;
    data['isPublished'] = this.isPublished;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IUpdatePublicProfileSectionRequest {
  key?: string;
  title?: string;
  description?: string | undefined;
  sortOrder?: number;
  isPublished?: boolean;
  items?: PublicProfileSectionItemDto[];
}

export class WebsitePageDto implements IWebsitePageDto {
  id?: string;
  slug?: string;
  title?: string;
  contentJson?: string | undefined;
  isPublished?: boolean;
  sortOrder?: number;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  showInMenu?: boolean;

  constructor(data?: IWebsitePageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.slug = _data['slug'];
      this.title = _data['title'];
      this.contentJson = _data['contentJson'];
      this.isPublished = _data['isPublished'];
      this.sortOrder = _data['sortOrder'];
      this.seoTitle = _data['seoTitle'];
      this.seoDescription = _data['seoDescription'];
      this.showInMenu = _data['showInMenu'];
    }
  }

  static fromJS(data: any): WebsitePageDto {
    data = typeof data === 'object' ? data : {};
    let result = new WebsitePageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['slug'] = this.slug;
    data['title'] = this.title;
    data['contentJson'] = this.contentJson;
    data['isPublished'] = this.isPublished;
    data['sortOrder'] = this.sortOrder;
    data['seoTitle'] = this.seoTitle;
    data['seoDescription'] = this.seoDescription;
    data['showInMenu'] = this.showInMenu;
    return data;
  }
}

export interface IWebsitePageDto {
  id?: string;
  slug?: string;
  title?: string;
  contentJson?: string | undefined;
  isPublished?: boolean;
  sortOrder?: number;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  showInMenu?: boolean;
}

export class CreateWebsitePageRequest implements ICreateWebsitePageRequest {
  slug?: string;
  title?: string;
  contentJson?: string | undefined;
  isPublished?: boolean;
  sortOrder?: number;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  showInMenu?: boolean;

  constructor(data?: ICreateWebsitePageRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.slug = _data['slug'];
      this.title = _data['title'];
      this.contentJson = _data['contentJson'];
      this.isPublished = _data['isPublished'];
      this.sortOrder = _data['sortOrder'];
      this.seoTitle = _data['seoTitle'];
      this.seoDescription = _data['seoDescription'];
      this.showInMenu = _data['showInMenu'];
    }
  }

  static fromJS(data: any): CreateWebsitePageRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateWebsitePageRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['slug'] = this.slug;
    data['title'] = this.title;
    data['contentJson'] = this.contentJson;
    data['isPublished'] = this.isPublished;
    data['sortOrder'] = this.sortOrder;
    data['seoTitle'] = this.seoTitle;
    data['seoDescription'] = this.seoDescription;
    data['showInMenu'] = this.showInMenu;
    return data;
  }
}

export interface ICreateWebsitePageRequest {
  slug?: string;
  title?: string;
  contentJson?: string | undefined;
  isPublished?: boolean;
  sortOrder?: number;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  showInMenu?: boolean;
}

export class UpdateWebsitePageRequest implements IUpdateWebsitePageRequest {
  id?: string;
  slug?: string;
  title?: string;
  contentJson?: string | undefined;
  isPublished?: boolean;
  sortOrder?: number;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  showInMenu?: boolean;

  constructor(data?: IUpdateWebsitePageRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.slug = _data['slug'];
      this.title = _data['title'];
      this.contentJson = _data['contentJson'];
      this.isPublished = _data['isPublished'];
      this.sortOrder = _data['sortOrder'];
      this.seoTitle = _data['seoTitle'];
      this.seoDescription = _data['seoDescription'];
      this.showInMenu = _data['showInMenu'];
    }
  }

  static fromJS(data: any): UpdateWebsitePageRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateWebsitePageRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['slug'] = this.slug;
    data['title'] = this.title;
    data['contentJson'] = this.contentJson;
    data['isPublished'] = this.isPublished;
    data['sortOrder'] = this.sortOrder;
    data['seoTitle'] = this.seoTitle;
    data['seoDescription'] = this.seoDescription;
    data['showInMenu'] = this.showInMenu;
    return data;
  }
}

export interface IUpdateWebsitePageRequest {
  id?: string;
  slug?: string;
  title?: string;
  contentJson?: string | undefined;
  isPublished?: boolean;
  sortOrder?: number;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  showInMenu?: boolean;
}

export class BlogPostDto implements IBlogPostDto {
  id?: string;
  slug?: string;
  title?: string;
  excerpt?: string | undefined;
  content?: string | undefined;
  coverImageUrl?: string | undefined;
  category?: string | undefined;
  authorName?: string | undefined;
  createdByName?: string | undefined;
  authorAvatarUrl?: string | undefined;
  isPublished?: boolean;
  publishedAt?: string | undefined;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  createdOn?: string;
  lastModifiedOn?: string | undefined;

  constructor(data?: IBlogPostDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.slug = _data['slug'];
      this.title = _data['title'];
      this.excerpt = _data['excerpt'];
      this.content = _data['content'];
      this.coverImageUrl = _data['coverImageUrl'];
      this.category = _data['category'];
      this.authorName = _data['authorName'];
      this.createdByName = _data['createdByName'];
      this.authorAvatarUrl = _data['authorAvatarUrl'];
      this.isPublished = _data['isPublished'];
      this.publishedAt = _data['publishedAt'];
      this.seoTitle = _data['seoTitle'];
      this.seoDescription = _data['seoDescription'];
      this.createdOn = _data['createdOn'];
      this.lastModifiedOn = _data['lastModifiedOn'];
    }
  }

  static fromJS(data: any): BlogPostDto {
    data = typeof data === 'object' ? data : {};
    let result = new BlogPostDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['slug'] = this.slug;
    data['title'] = this.title;
    data['excerpt'] = this.excerpt;
    data['content'] = this.content;
    data['coverImageUrl'] = this.coverImageUrl;
    data['category'] = this.category;
    data['authorName'] = this.authorName;
    data['createdByName'] = this.createdByName;
    data['authorAvatarUrl'] = this.authorAvatarUrl;
    data['isPublished'] = this.isPublished;
    data['publishedAt'] = this.publishedAt;
    data['seoTitle'] = this.seoTitle;
    data['seoDescription'] = this.seoDescription;
    data['createdOn'] = this.createdOn;
    data['lastModifiedOn'] = this.lastModifiedOn;
    return data;
  }
}

export interface IBlogPostDto {
  id?: string;
  slug?: string;
  title?: string;
  excerpt?: string | undefined;
  content?: string | undefined;
  coverImageUrl?: string | undefined;
  category?: string | undefined;
  authorName?: string | undefined;
  createdByName?: string | undefined;
  authorAvatarUrl?: string | undefined;
  isPublished?: boolean;
  publishedAt?: string | undefined;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  createdOn?: string;
  lastModifiedOn?: string | undefined;
}

export class CreateBlogPostRequest implements ICreateBlogPostRequest {
  slug?: string;
  title?: string;
  excerpt?: string | undefined;
  content?: string | undefined;
  coverImageUrl?: string | undefined;
  isPublished?: boolean;
  publishedAt?: string | undefined;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;

  constructor(data?: ICreateBlogPostRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.slug = _data['slug'];
      this.title = _data['title'];
      this.excerpt = _data['excerpt'];
      this.content = _data['content'];
      this.coverImageUrl = _data['coverImageUrl'];
      this.isPublished = _data['isPublished'];
      this.publishedAt = _data['publishedAt'];
      this.seoTitle = _data['seoTitle'];
      this.seoDescription = _data['seoDescription'];
    }
  }

  static fromJS(data: any): CreateBlogPostRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateBlogPostRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['slug'] = this.slug;
    data['title'] = this.title;
    data['excerpt'] = this.excerpt;
    data['content'] = this.content;
    data['coverImageUrl'] = this.coverImageUrl;
    data['isPublished'] = this.isPublished;
    data['publishedAt'] = this.publishedAt;
    data['seoTitle'] = this.seoTitle;
    data['seoDescription'] = this.seoDescription;
    return data;
  }
}

export interface ICreateBlogPostRequest {
  slug?: string;
  title?: string;
  excerpt?: string | undefined;
  content?: string | undefined;
  coverImageUrl?: string | undefined;
  isPublished?: boolean;
  publishedAt?: string | undefined;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
}

export class UpdateBlogPostRequest implements IUpdateBlogPostRequest {
  id?: string;
  slug?: string;
  title?: string;
  excerpt?: string | undefined;
  content?: string | undefined;
  coverImageUrl?: string | undefined;
  isPublished?: boolean;
  publishedAt?: string | undefined;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;

  constructor(data?: IUpdateBlogPostRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.slug = _data['slug'];
      this.title = _data['title'];
      this.excerpt = _data['excerpt'];
      this.content = _data['content'];
      this.coverImageUrl = _data['coverImageUrl'];
      this.isPublished = _data['isPublished'];
      this.publishedAt = _data['publishedAt'];
      this.seoTitle = _data['seoTitle'];
      this.seoDescription = _data['seoDescription'];
    }
  }

  static fromJS(data: any): UpdateBlogPostRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateBlogPostRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['slug'] = this.slug;
    data['title'] = this.title;
    data['excerpt'] = this.excerpt;
    data['content'] = this.content;
    data['coverImageUrl'] = this.coverImageUrl;
    data['isPublished'] = this.isPublished;
    data['publishedAt'] = this.publishedAt;
    data['seoTitle'] = this.seoTitle;
    data['seoDescription'] = this.seoDescription;
    return data;
  }
}

export interface IUpdateBlogPostRequest {
  id?: string;
  slug?: string;
  title?: string;
  excerpt?: string | undefined;
  content?: string | undefined;
  coverImageUrl?: string | undefined;
  isPublished?: boolean;
  publishedAt?: string | undefined;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
}

export class PublicServiceDto implements IPublicServiceDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  basePrice?: number | undefined;
  durationMinutes?: number | undefined;
  sortOrder?: number;
  isActive?: boolean;
  isPublished?: boolean;

  constructor(data?: IPublicServiceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.basePrice = _data['basePrice'];
      this.durationMinutes = _data['durationMinutes'];
      this.sortOrder = _data['sortOrder'];
      this.isActive = _data['isActive'];
      this.isPublished = _data['isPublished'];
    }
  }

  static fromJS(data: any): PublicServiceDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicServiceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    data['basePrice'] = this.basePrice;
    data['durationMinutes'] = this.durationMinutes;
    data['sortOrder'] = this.sortOrder;
    data['isActive'] = this.isActive;
    data['isPublished'] = this.isPublished;
    return data;
  }
}

export interface IPublicServiceDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  basePrice?: number | undefined;
  durationMinutes?: number | undefined;
  sortOrder?: number;
  isActive?: boolean;
  isPublished?: boolean;
}

export class CreatePublicLeadResponse implements ICreatePublicLeadResponse {
  leadId?: string;
  serviceOrderId?: string;
  number?: string;

  constructor(data?: ICreatePublicLeadResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.leadId = _data['leadId'];
      this.serviceOrderId = _data['serviceOrderId'];
      this.number = _data['number'];
    }
  }

  static fromJS(data: any): CreatePublicLeadResponse {
    data = typeof data === 'object' ? data : {};
    let result = new CreatePublicLeadResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['leadId'] = this.leadId;
    data['serviceOrderId'] = this.serviceOrderId;
    data['number'] = this.number;
    return data;
  }
}

export interface ICreatePublicLeadResponse {
  leadId?: string;
  serviceOrderId?: string;
  number?: string;
}

export class CreatePublicLeadRequest implements ICreatePublicLeadRequest {
  friendlyUrl?: string | undefined;
  customerName?: string;
  phone?: string | undefined;
  email?: string | undefined;
  serviceName?: string | undefined;
  subject?: string | undefined;
  message?: string | undefined;
  customFields?: string | undefined;

  constructor(data?: ICreatePublicLeadRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.friendlyUrl = _data['friendlyUrl'];
      this.customerName = _data['customerName'];
      this.phone = _data['phone'];
      this.email = _data['email'];
      this.serviceName = _data['serviceName'];
      this.subject = _data['subject'];
      this.message = _data['message'];
      this.customFields = _data['customFields'];
    }
  }

  static fromJS(data: any): CreatePublicLeadRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreatePublicLeadRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['friendlyUrl'] = this.friendlyUrl;
    data['customerName'] = this.customerName;
    data['phone'] = this.phone;
    data['email'] = this.email;
    data['serviceName'] = this.serviceName;
    data['subject'] = this.subject;
    data['message'] = this.message;
    data['customFields'] = this.customFields;
    return data;
  }
}

export interface ICreatePublicLeadRequest {
  friendlyUrl?: string | undefined;
  customerName?: string;
  phone?: string | undefined;
  email?: string | undefined;
  serviceName?: string | undefined;
  subject?: string | undefined;
  message?: string | undefined;
  customFields?: string | undefined;
}

export class PaginationResponseOfReminderDto
  implements IPaginationResponseOfReminderDto
{
  data?: ReminderDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfReminderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(ReminderDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfReminderDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfReminderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfReminderDto {
  data?: ReminderDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class ReminderDto implements IReminderDto {
  id?: string;
  serviceOrderId?: string | undefined;
  customerId?: string | undefined;
  customerName?: string;
  phone?: string;
  serviceName?: string | undefined;
  reason?: string | undefined;
  message?: string | undefined;
  remindAt?: string;
  recipientType?: string | undefined;
  recipientId?: string | undefined;
  recipientName?: string | undefined;
  recipientPhone?: string | undefined;
  smsTemplateId?: string | undefined;
  channel?: string;
  status?: string;
  sentOn?: string | undefined;
  cancelledOn?: string | undefined;

  constructor(data?: IReminderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.serviceOrderId = _data['serviceOrderId'];
      this.customerId = _data['customerId'];
      this.customerName = _data['customerName'];
      this.phone = _data['phone'];
      this.serviceName = _data['serviceName'];
      this.reason = _data['reason'];
      this.message = _data['message'];
      this.remindAt = _data['remindAt'];
      this.recipientType = _data['recipientType'];
      this.recipientId = _data['recipientId'];
      this.recipientName = _data['recipientName'];
      this.recipientPhone = _data['recipientPhone'];
      this.smsTemplateId = _data['smsTemplateId'];
      this.channel = _data['channel'];
      this.status = _data['status'];
      this.sentOn = _data['sentOn'];
      this.cancelledOn = _data['cancelledOn'];
    }
  }

  static fromJS(data: any): ReminderDto {
    data = typeof data === 'object' ? data : {};
    let result = new ReminderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['serviceOrderId'] = this.serviceOrderId;
    data['customerId'] = this.customerId;
    data['customerName'] = this.customerName;
    data['phone'] = this.phone;
    data['serviceName'] = this.serviceName;
    data['reason'] = this.reason;
    data['message'] = this.message;
    data['remindAt'] = this.remindAt;
    data['recipientType'] = this.recipientType;
    data['recipientId'] = this.recipientId;
    data['recipientName'] = this.recipientName;
    data['recipientPhone'] = this.recipientPhone;
    data['smsTemplateId'] = this.smsTemplateId;
    data['channel'] = this.channel;
    data['status'] = this.status;
    data['sentOn'] = this.sentOn;
    data['cancelledOn'] = this.cancelledOn;
    return data;
  }
}

export interface IReminderDto {
  id?: string;
  serviceOrderId?: string | undefined;
  customerId?: string | undefined;
  customerName?: string;
  phone?: string;
  serviceName?: string | undefined;
  reason?: string | undefined;
  message?: string | undefined;
  remindAt?: string;
  recipientType?: string | undefined;
  recipientId?: string | undefined;
  recipientName?: string | undefined;
  recipientPhone?: string | undefined;
  smsTemplateId?: string | undefined;
  channel?: string;
  status?: string;
  sentOn?: string | undefined;
  cancelledOn?: string | undefined;
}

export class SearchRemindersRequest
  extends PaginationFilter
  implements ISearchRemindersRequest
{
  serviceOrderId?: string | undefined;
  status?: string | undefined;
  channel?: string | undefined;
  remindTo?: string | undefined;

  constructor(data?: ISearchRemindersRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.serviceOrderId = _data['serviceOrderId'];
      this.status = _data['status'];
      this.channel = _data['channel'];
      this.remindTo = _data['remindTo'];
    }
  }

  static fromJS(data: any): SearchRemindersRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchRemindersRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['serviceOrderId'] = this.serviceOrderId;
    data['status'] = this.status;
    data['channel'] = this.channel;
    data['remindTo'] = this.remindTo;
    super.toJSON(data);
    return data;
  }
}

export interface ISearchRemindersRequest extends IPaginationFilter {
  serviceOrderId?: string | undefined;
  status?: string | undefined;
  channel?: string | undefined;
  remindTo?: string | undefined;
}

export class CreateOrderReminderRequest implements ICreateOrderReminderRequest {
  serviceOrderId?: string;
  customerName?: string;
  phone?: string;
  serviceName?: string | undefined;
  reason?: string | undefined;
  message?: string | undefined;
  remindAt?: string;
  channel?: string;

  constructor(data?: ICreateOrderReminderRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceOrderId = _data['serviceOrderId'];
      this.customerName = _data['customerName'];
      this.phone = _data['phone'];
      this.serviceName = _data['serviceName'];
      this.reason = _data['reason'];
      this.message = _data['message'];
      this.remindAt = _data['remindAt'];
      this.channel = _data['channel'];
    }
  }

  static fromJS(data: any): CreateOrderReminderRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrderReminderRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['serviceOrderId'] = this.serviceOrderId;
    data['customerName'] = this.customerName;
    data['phone'] = this.phone;
    data['serviceName'] = this.serviceName;
    data['reason'] = this.reason;
    data['message'] = this.message;
    data['remindAt'] = this.remindAt;
    data['channel'] = this.channel;
    return data;
  }
}

export interface ICreateOrderReminderRequest {
  serviceOrderId?: string;
  customerName?: string;
  phone?: string;
  serviceName?: string | undefined;
  reason?: string | undefined;
  message?: string | undefined;
  remindAt?: string;
  channel?: string;
}

export class ServiceDto implements IServiceDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  basePrice?: number | undefined;
  durationMinutes?: number | undefined;
  isActive?: boolean;
  sortOrder?: number;

  constructor(data?: IServiceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.basePrice = _data['basePrice'];
      this.durationMinutes = _data['durationMinutes'];
      this.isActive = _data['isActive'];
      this.sortOrder = _data['sortOrder'];
    }
  }

  static fromJS(data: any): ServiceDto {
    data = typeof data === 'object' ? data : {};
    let result = new ServiceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    data['basePrice'] = this.basePrice;
    data['durationMinutes'] = this.durationMinutes;
    data['isActive'] = this.isActive;
    data['sortOrder'] = this.sortOrder;
    return data;
  }
}

export interface IServiceDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  basePrice?: number | undefined;
  durationMinutes?: number | undefined;
  isActive?: boolean;
  sortOrder?: number;
}

export class CreateServiceRequest implements ICreateServiceRequest {
  name?: string;
  description?: string | undefined;
  basePrice?: number | undefined;
  durationMinutes?: number | undefined;
  isActive?: boolean;
  sortOrder?: number;

  constructor(data?: ICreateServiceRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.description = _data['description'];
      this.basePrice = _data['basePrice'];
      this.durationMinutes = _data['durationMinutes'];
      this.isActive = _data['isActive'];
      this.sortOrder = _data['sortOrder'];
    }
  }

  static fromJS(data: any): CreateServiceRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateServiceRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['description'] = this.description;
    data['basePrice'] = this.basePrice;
    data['durationMinutes'] = this.durationMinutes;
    data['isActive'] = this.isActive;
    data['sortOrder'] = this.sortOrder;
    return data;
  }
}

export interface ICreateServiceRequest {
  name?: string;
  description?: string | undefined;
  basePrice?: number | undefined;
  durationMinutes?: number | undefined;
  isActive?: boolean;
  sortOrder?: number;
}

export class UpdateServiceRequest implements IUpdateServiceRequest {
  id?: string;
  name?: string;
  description?: string | undefined;
  basePrice?: number | undefined;
  durationMinutes?: number | undefined;
  isActive?: boolean;
  sortOrder?: number;

  constructor(data?: IUpdateServiceRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.basePrice = _data['basePrice'];
      this.durationMinutes = _data['durationMinutes'];
      this.isActive = _data['isActive'];
      this.sortOrder = _data['sortOrder'];
    }
  }

  static fromJS(data: any): UpdateServiceRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateServiceRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    data['basePrice'] = this.basePrice;
    data['durationMinutes'] = this.durationMinutes;
    data['isActive'] = this.isActive;
    data['sortOrder'] = this.sortOrder;
    return data;
  }
}

export interface IUpdateServiceRequest {
  id?: string;
  name?: string;
  description?: string | undefined;
  basePrice?: number | undefined;
  durationMinutes?: number | undefined;
  isActive?: boolean;
  sortOrder?: number;
}

export class AutomationSettingsDto implements IAutomationSettingsDto {
  isEnabled?: boolean;
  createOrderFromLead?: boolean;
  notifyInAppOnLead?: boolean;
  autoAssignNewOrders?: boolean;
  defaultEmployeeId?: string | undefined;
  defaultWorker?: string | undefined;
  sendSmsReminders?: boolean;
  reminderLeadTimeHours?: number;

  constructor(data?: IAutomationSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isEnabled = _data['isEnabled'];
      this.createOrderFromLead = _data['createOrderFromLead'];
      this.notifyInAppOnLead = _data['notifyInAppOnLead'];
      this.autoAssignNewOrders = _data['autoAssignNewOrders'];
      this.defaultEmployeeId = _data['defaultEmployeeId'];
      this.defaultWorker = _data['defaultWorker'];
      this.sendSmsReminders = _data['sendSmsReminders'];
      this.reminderLeadTimeHours = _data['reminderLeadTimeHours'];
    }
  }

  static fromJS(data: any): AutomationSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new AutomationSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isEnabled'] = this.isEnabled;
    data['createOrderFromLead'] = this.createOrderFromLead;
    data['notifyInAppOnLead'] = this.notifyInAppOnLead;
    data['autoAssignNewOrders'] = this.autoAssignNewOrders;
    data['defaultEmployeeId'] = this.defaultEmployeeId;
    data['defaultWorker'] = this.defaultWorker;
    data['sendSmsReminders'] = this.sendSmsReminders;
    data['reminderLeadTimeHours'] = this.reminderLeadTimeHours;
    return data;
  }
}

export interface IAutomationSettingsDto {
  isEnabled?: boolean;
  createOrderFromLead?: boolean;
  notifyInAppOnLead?: boolean;
  autoAssignNewOrders?: boolean;
  defaultEmployeeId?: string | undefined;
  defaultWorker?: string | undefined;
  sendSmsReminders?: boolean;
  reminderLeadTimeHours?: number;
}

export class UpdateAutomationSettingsRequest
  extends AutomationSettingsDto
  implements IUpdateAutomationSettingsRequest
{
  constructor(data?: IUpdateAutomationSettingsRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
  }

  static fromJS(data: any): UpdateAutomationSettingsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateAutomationSettingsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IUpdateAutomationSettingsRequest
  extends IAutomationSettingsDto {}

export class SmsTemplatesSettingsDto implements ISmsTemplatesSettingsDto {
  isEnabled?: boolean;
  senderName?: string;
  leadCreated?: string;
  orderScheduled?: string;
  reminder?: string;
  orderReady?: string;
  orderCreatedPublicStatus?: string;
  customTemplates?: SmsTemplateDto[] | undefined;

  constructor(data?: ISmsTemplatesSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isEnabled = _data['isEnabled'];
      this.senderName = _data['senderName'];
      this.leadCreated = _data['leadCreated'];
      this.orderScheduled = _data['orderScheduled'];
      this.reminder = _data['reminder'];
      this.orderReady = _data['orderReady'];
      this.orderCreatedPublicStatus = _data['orderCreatedPublicStatus'];
      if (Array.isArray(_data['customTemplates'])) {
        this.customTemplates = [] as any;
        for (let item of _data['customTemplates'])
          this.customTemplates!.push(SmsTemplateDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SmsTemplatesSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new SmsTemplatesSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isEnabled'] = this.isEnabled;
    data['senderName'] = this.senderName;
    data['leadCreated'] = this.leadCreated;
    data['orderScheduled'] = this.orderScheduled;
    data['reminder'] = this.reminder;
    data['orderReady'] = this.orderReady;
    data['orderCreatedPublicStatus'] = this.orderCreatedPublicStatus;
    if (Array.isArray(this.customTemplates)) {
      data['customTemplates'] = [];
      for (let item of this.customTemplates)
        data['customTemplates'].push(item.toJSON());
    }
    return data;
  }
}

export interface ISmsTemplatesSettingsDto {
  isEnabled?: boolean;
  senderName?: string;
  leadCreated?: string;
  orderScheduled?: string;
  reminder?: string;
  orderReady?: string;
  orderCreatedPublicStatus?: string;
  customTemplates?: SmsTemplateDto[] | undefined;
}

export class SmsTemplateDto implements ISmsTemplateDto {
  id?: string;
  name?: string;
  content?: string;

  constructor(data?: ISmsTemplateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.content = _data['content'];
    }
  }

  static fromJS(data: any): SmsTemplateDto {
    data = typeof data === 'object' ? data : {};
    let result = new SmsTemplateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['content'] = this.content;
    return data;
  }
}

export interface ISmsTemplateDto {
  id?: string;
  name?: string;
  content?: string;
}

export class UpdateSmsTemplatesSettingsRequest
  extends SmsTemplatesSettingsDto
  implements IUpdateSmsTemplatesSettingsRequest
{
  constructor(data?: IUpdateSmsTemplatesSettingsRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
  }

  static fromJS(data: any): UpdateSmsTemplatesSettingsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateSmsTemplatesSettingsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IUpdateSmsTemplatesSettingsRequest
  extends ISmsTemplatesSettingsDto {}

export class PanelPreferencesSettingsDto
  implements IPanelPreferencesSettingsDto
{
  defaultDashboardRange?: string;
  ordersDefaultView?: string;
  compactMode?: boolean;
  showStats?: boolean;
  showReminders?: boolean;
  language?: string;
  dateFormat?: string;

  constructor(data?: IPanelPreferencesSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.defaultDashboardRange = _data['defaultDashboardRange'];
      this.ordersDefaultView = _data['ordersDefaultView'];
      this.compactMode = _data['compactMode'];
      this.showStats = _data['showStats'];
      this.showReminders = _data['showReminders'];
      this.language = _data['language'];
      this.dateFormat = _data['dateFormat'];
    }
  }

  static fromJS(data: any): PanelPreferencesSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new PanelPreferencesSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['defaultDashboardRange'] = this.defaultDashboardRange;
    data['ordersDefaultView'] = this.ordersDefaultView;
    data['compactMode'] = this.compactMode;
    data['showStats'] = this.showStats;
    data['showReminders'] = this.showReminders;
    data['language'] = this.language;
    data['dateFormat'] = this.dateFormat;
    return data;
  }
}

export interface IPanelPreferencesSettingsDto {
  defaultDashboardRange?: string;
  ordersDefaultView?: string;
  compactMode?: boolean;
  showStats?: boolean;
  showReminders?: boolean;
  language?: string;
  dateFormat?: string;
}

export class UpdatePanelPreferencesSettingsRequest
  extends PanelPreferencesSettingsDto
  implements IUpdatePanelPreferencesSettingsRequest
{
  constructor(data?: IUpdatePanelPreferencesSettingsRequest) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
  }

  static fromJS(data: any): UpdatePanelPreferencesSettingsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdatePanelPreferencesSettingsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IUpdatePanelPreferencesSettingsRequest
  extends IPanelPreferencesSettingsDto {}

export class UpdateDepartmentTeamRequest
  implements IUpdateDepartmentTeamRequest
{
  id!: string;
  departmentId!: string;
  key!: string;
  name!: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;

  constructor(data?: IUpdateDepartmentTeamRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.departmentId = _data['departmentId'];
      this.key = _data['key'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.sortOrder = _data['sortOrder'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): UpdateDepartmentTeamRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateDepartmentTeamRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['departmentId'] = this.departmentId;
    data['key'] = this.key;
    data['name'] = this.name;
    data['description'] = this.description;
    data['sortOrder'] = this.sortOrder;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IUpdateDepartmentTeamRequest {
  id: string;
  departmentId: string;
  key: string;
  name: string;
  description?: string | undefined;
  sortOrder?: number;
  isActive?: boolean;
}

export class WebsiteDto implements IWebsiteDto {
  id?: string;
  companyProfileId?: string | undefined;
  name?: string;
  publicSlug?: string;
  status?: string;
  themeJson?: string | undefined;
  homePageId?: string | undefined;
  createdAt?: string;
  updatedAt?: string | undefined;
  rowVersion?: string | undefined;

  constructor(data?: IWebsiteDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.companyProfileId = _data['companyProfileId'];
      this.name = _data['name'];
      this.publicSlug = _data['publicSlug'];
      this.status = _data['status'];
      this.themeJson = _data['themeJson'];
      this.homePageId = _data['homePageId'];
      this.createdAt = _data['createdAt'];
      this.updatedAt = _data['updatedAt'];
      this.rowVersion = _data['rowVersion'];
    }
  }

  static fromJS(data: any): WebsiteDto {
    data = typeof data === 'object' ? data : {};
    let result = new WebsiteDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['companyProfileId'] = this.companyProfileId;
    data['name'] = this.name;
    data['publicSlug'] = this.publicSlug;
    data['status'] = this.status;
    data['themeJson'] = this.themeJson;
    data['homePageId'] = this.homePageId;
    data['createdAt'] = this.createdAt;
    data['updatedAt'] = this.updatedAt;
    data['rowVersion'] = this.rowVersion;
    return data;
  }
}

export interface IWebsiteDto {
  id?: string;
  companyProfileId?: string | undefined;
  name?: string;
  publicSlug?: string;
  status?: string;
  themeJson?: string | undefined;
  homePageId?: string | undefined;
  createdAt?: string;
  updatedAt?: string | undefined;
  rowVersion?: string | undefined;
}

export class CreateWebsiteRequest implements ICreateWebsiteRequest {
  name!: string;
  publicSlug!: string;
  themeJson?: string | undefined;
  companyProfileId?: string | undefined;

  constructor(data?: ICreateWebsiteRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.publicSlug = _data['publicSlug'];
      this.themeJson = _data['themeJson'];
      this.companyProfileId = _data['companyProfileId'];
    }
  }

  static fromJS(data: any): CreateWebsiteRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateWebsiteRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['publicSlug'] = this.publicSlug;
    data['themeJson'] = this.themeJson;
    data['companyProfileId'] = this.companyProfileId;
    return data;
  }
}

export interface ICreateWebsiteRequest {
  name: string;
  publicSlug: string;
  themeJson?: string | undefined;
  companyProfileId?: string | undefined;
}

export class UpdateWebsiteRequest implements IUpdateWebsiteRequest {
  websiteId!: string;
  name!: string;
  publicSlug!: string;
  status!: string;
  themeJson?: string | undefined;
  companyProfileId?: string | undefined;
  rowVersion?: string | undefined;

  constructor(data?: IUpdateWebsiteRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.websiteId = _data['websiteId'];
      this.name = _data['name'];
      this.publicSlug = _data['publicSlug'];
      this.status = _data['status'];
      this.themeJson = _data['themeJson'];
      this.companyProfileId = _data['companyProfileId'];
      this.rowVersion = _data['rowVersion'];
    }
  }

  static fromJS(data: any): UpdateWebsiteRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateWebsiteRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['websiteId'] = this.websiteId;
    data['name'] = this.name;
    data['publicSlug'] = this.publicSlug;
    data['status'] = this.status;
    data['themeJson'] = this.themeJson;
    data['companyProfileId'] = this.companyProfileId;
    data['rowVersion'] = this.rowVersion;
    return data;
  }
}

export interface IUpdateWebsiteRequest {
  websiteId: string;
  name: string;
  publicSlug: string;
  status: string;
  themeJson?: string | undefined;
  companyProfileId?: string | undefined;
  rowVersion?: string | undefined;
}

export class WebsitePageSummaryDto implements IWebsitePageSummaryDto {
  id?: string;
  websiteId?: string;
  archetype?: string;
  slug?: string;
  title?: string;
  isHomePage?: boolean;
  showInNavigation?: boolean;
  navigationOrder?: number;
  navigationLabel?: string | undefined;
  navigationParentPageId?: string | undefined;
  navigationOpenMode?: string;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  currentDraftRevisionId?: string | undefined;
  currentPublishedRevisionId?: string | undefined;
  hasDraft?: boolean;
  hasPublished?: boolean;
  status?: string;
  isPublished?: boolean;
  publishedOn?: string | undefined;
  rowVersion?: string | undefined;

  constructor(data?: IWebsitePageSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.websiteId = _data['websiteId'];
      this.archetype = _data['archetype'];
      this.slug = _data['slug'];
      this.title = _data['title'];
      this.isHomePage = _data['isHomePage'];
      this.showInNavigation = _data['showInNavigation'];
      this.navigationOrder = _data['navigationOrder'];
      this.navigationLabel = _data['navigationLabel'];
      this.navigationParentPageId = _data['navigationParentPageId'];
      this.navigationOpenMode = _data['navigationOpenMode'];
      this.seoTitle = _data['seoTitle'];
      this.seoDescription = _data['seoDescription'];
      this.currentDraftRevisionId = _data['currentDraftRevisionId'];
      this.currentPublishedRevisionId = _data['currentPublishedRevisionId'];
      this.hasDraft = _data['hasDraft'];
      this.hasPublished = _data['hasPublished'];
      this.status = _data['status'];
      this.isPublished = _data['isPublished'];
      this.publishedOn = _data['publishedOn'];
      this.rowVersion = _data['rowVersion'];
    }
  }

  static fromJS(data: any): WebsitePageSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new WebsitePageSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['websiteId'] = this.websiteId;
    data['archetype'] = this.archetype;
    data['slug'] = this.slug;
    data['title'] = this.title;
    data['isHomePage'] = this.isHomePage;
    data['showInNavigation'] = this.showInNavigation;
    data['navigationOrder'] = this.navigationOrder;
    data['navigationLabel'] = this.navigationLabel;
    data['navigationParentPageId'] = this.navigationParentPageId;
    data['navigationOpenMode'] = this.navigationOpenMode;
    data['seoTitle'] = this.seoTitle;
    data['seoDescription'] = this.seoDescription;
    data['currentDraftRevisionId'] = this.currentDraftRevisionId;
    data['currentPublishedRevisionId'] = this.currentPublishedRevisionId;
    data['hasDraft'] = this.hasDraft;
    data['hasPublished'] = this.hasPublished;
    data['status'] = this.status;
    data['isPublished'] = this.isPublished;
    data['publishedOn'] = this.publishedOn;
    data['rowVersion'] = this.rowVersion;
    return data;
  }
}

export interface IWebsitePageSummaryDto {
  id?: string;
  websiteId?: string;
  archetype?: string;
  slug?: string;
  title?: string;
  isHomePage?: boolean;
  showInNavigation?: boolean;
  navigationOrder?: number;
  navigationLabel?: string | undefined;
  navigationParentPageId?: string | undefined;
  navigationOpenMode?: string;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  currentDraftRevisionId?: string | undefined;
  currentPublishedRevisionId?: string | undefined;
  hasDraft?: boolean;
  hasPublished?: boolean;
  status?: string;
  isPublished?: boolean;
  publishedOn?: string | undefined;
  rowVersion?: string | undefined;
}

export class WebsiteRoutingStatusDto implements IWebsiteRoutingStatusDto {
  websiteId?: string;
  publicSlug?: string;
  publicSlugRouteActive?: boolean;
  homePageId?: string | undefined;
  homePagePublished?: boolean;
  domains?: WebsiteDomainRoutingStatusDto[];

  constructor(data?: IWebsiteRoutingStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.websiteId = _data['websiteId'];
      this.publicSlug = _data['publicSlug'];
      this.publicSlugRouteActive = _data['publicSlugRouteActive'];
      this.homePageId = _data['homePageId'];
      this.homePagePublished = _data['homePagePublished'];
      if (Array.isArray(_data['domains'])) {
        this.domains = [] as any;
        for (let item of _data['domains'])
          this.domains!.push(WebsiteDomainRoutingStatusDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): WebsiteRoutingStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new WebsiteRoutingStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['websiteId'] = this.websiteId;
    data['publicSlug'] = this.publicSlug;
    data['publicSlugRouteActive'] = this.publicSlugRouteActive;
    data['homePageId'] = this.homePageId;
    data['homePagePublished'] = this.homePagePublished;
    if (Array.isArray(this.domains)) {
      data['domains'] = [];
      for (let item of this.domains) data['domains'].push(item.toJSON());
    }
    return data;
  }
}

export interface IWebsiteRoutingStatusDto {
  websiteId?: string;
  publicSlug?: string;
  publicSlugRouteActive?: boolean;
  homePageId?: string | undefined;
  homePagePublished?: boolean;
  domains?: WebsiteDomainRoutingStatusDto[];
}

export class WebsiteDomainRoutingStatusDto
  implements IWebsiteDomainRoutingStatusDto
{
  hostname?: string;
  status?: string;
  isPrimary?: boolean;
  routeActive?: boolean;

  constructor(data?: IWebsiteDomainRoutingStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hostname = _data['hostname'];
      this.status = _data['status'];
      this.isPrimary = _data['isPrimary'];
      this.routeActive = _data['routeActive'];
    }
  }

  static fromJS(data: any): WebsiteDomainRoutingStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new WebsiteDomainRoutingStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['hostname'] = this.hostname;
    data['status'] = this.status;
    data['isPrimary'] = this.isPrimary;
    data['routeActive'] = this.routeActive;
    return data;
  }
}

export interface IWebsiteDomainRoutingStatusDto {
  hostname?: string;
  status?: string;
  isPrimary?: boolean;
  routeActive?: boolean;
}

export class WebsiteDomainDto implements IWebsiteDomainDto {
  id?: string;
  websiteId?: string;
  hostname?: string;
  status?: string;
  isPrimary?: boolean;
  verifiedAt?: string | undefined;
  dnsRecordName?: string;
  dnsRecordValue?: string;
  rowVersion?: string | undefined;

  constructor(data?: IWebsiteDomainDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.websiteId = _data['websiteId'];
      this.hostname = _data['hostname'];
      this.status = _data['status'];
      this.isPrimary = _data['isPrimary'];
      this.verifiedAt = _data['verifiedAt'];
      this.dnsRecordName = _data['dnsRecordName'];
      this.dnsRecordValue = _data['dnsRecordValue'];
      this.rowVersion = _data['rowVersion'];
    }
  }

  static fromJS(data: any): WebsiteDomainDto {
    data = typeof data === 'object' ? data : {};
    let result = new WebsiteDomainDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['websiteId'] = this.websiteId;
    data['hostname'] = this.hostname;
    data['status'] = this.status;
    data['isPrimary'] = this.isPrimary;
    data['verifiedAt'] = this.verifiedAt;
    data['dnsRecordName'] = this.dnsRecordName;
    data['dnsRecordValue'] = this.dnsRecordValue;
    data['rowVersion'] = this.rowVersion;
    return data;
  }
}

export interface IWebsiteDomainDto {
  id?: string;
  websiteId?: string;
  hostname?: string;
  status?: string;
  isPrimary?: boolean;
  verifiedAt?: string | undefined;
  dnsRecordName?: string;
  dnsRecordValue?: string;
  rowVersion?: string | undefined;
}

export class CreateWebsiteDomainRequest implements ICreateWebsiteDomainRequest {
  websiteId!: string;
  hostname!: string;
  isPrimary?: boolean;

  constructor(data?: ICreateWebsiteDomainRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.websiteId = _data['websiteId'];
      this.hostname = _data['hostname'];
      this.isPrimary = _data['isPrimary'];
    }
  }

  static fromJS(data: any): CreateWebsiteDomainRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateWebsiteDomainRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['websiteId'] = this.websiteId;
    data['hostname'] = this.hostname;
    data['isPrimary'] = this.isPrimary;
    return data;
  }
}

export interface ICreateWebsiteDomainRequest {
  websiteId: string;
  hostname: string;
  isPrimary?: boolean;
}

export class CreateWebsitePageRequest2 implements ICreateWebsitePageRequest2 {
  websiteId!: string;
  title!: string;
  slug!: string;
  isHomePage?: boolean;
  showInNavigation?: boolean;
  navigationOrder?: number;
  navigationLabel?: string | undefined;
  navigationParentPageId?: string | undefined;
  navigationOpenMode?: string | undefined;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;

  constructor(data?: ICreateWebsitePageRequest2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.websiteId = _data['websiteId'];
      this.title = _data['title'];
      this.slug = _data['slug'];
      this.isHomePage = _data['isHomePage'];
      this.showInNavigation = _data['showInNavigation'];
      this.navigationOrder = _data['navigationOrder'];
      this.navigationLabel = _data['navigationLabel'];
      this.navigationParentPageId = _data['navigationParentPageId'];
      this.navigationOpenMode = _data['navigationOpenMode'];
      this.seoTitle = _data['seoTitle'];
      this.seoDescription = _data['seoDescription'];
    }
  }

  static fromJS(data: any): CreateWebsitePageRequest2 {
    data = typeof data === 'object' ? data : {};
    let result = new CreateWebsitePageRequest2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['websiteId'] = this.websiteId;
    data['title'] = this.title;
    data['slug'] = this.slug;
    data['isHomePage'] = this.isHomePage;
    data['showInNavigation'] = this.showInNavigation;
    data['navigationOrder'] = this.navigationOrder;
    data['navigationLabel'] = this.navigationLabel;
    data['navigationParentPageId'] = this.navigationParentPageId;
    data['navigationOpenMode'] = this.navigationOpenMode;
    data['seoTitle'] = this.seoTitle;
    data['seoDescription'] = this.seoDescription;
    return data;
  }
}

export interface ICreateWebsitePageRequest2 {
  websiteId: string;
  title: string;
  slug: string;
  isHomePage?: boolean;
  showInNavigation?: boolean;
  navigationOrder?: number;
  navigationLabel?: string | undefined;
  navigationParentPageId?: string | undefined;
  navigationOpenMode?: string | undefined;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
}

export class UpdateWebsitePageRequest2 implements IUpdateWebsitePageRequest2 {
  websiteId!: string;
  pageId!: string;
  title!: string;
  slug!: string;
  isHomePage?: boolean;
  showInNavigation?: boolean;
  navigationOrder?: number;
  navigationLabel?: string | undefined;
  navigationParentPageId?: string | undefined;
  navigationOpenMode?: string | undefined;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  rowVersion?: string | undefined;

  constructor(data?: IUpdateWebsitePageRequest2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.websiteId = _data['websiteId'];
      this.pageId = _data['pageId'];
      this.title = _data['title'];
      this.slug = _data['slug'];
      this.isHomePage = _data['isHomePage'];
      this.showInNavigation = _data['showInNavigation'];
      this.navigationOrder = _data['navigationOrder'];
      this.navigationLabel = _data['navigationLabel'];
      this.navigationParentPageId = _data['navigationParentPageId'];
      this.navigationOpenMode = _data['navigationOpenMode'];
      this.seoTitle = _data['seoTitle'];
      this.seoDescription = _data['seoDescription'];
      this.rowVersion = _data['rowVersion'];
    }
  }

  static fromJS(data: any): UpdateWebsitePageRequest2 {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateWebsitePageRequest2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['websiteId'] = this.websiteId;
    data['pageId'] = this.pageId;
    data['title'] = this.title;
    data['slug'] = this.slug;
    data['isHomePage'] = this.isHomePage;
    data['showInNavigation'] = this.showInNavigation;
    data['navigationOrder'] = this.navigationOrder;
    data['navigationLabel'] = this.navigationLabel;
    data['navigationParentPageId'] = this.navigationParentPageId;
    data['navigationOpenMode'] = this.navigationOpenMode;
    data['seoTitle'] = this.seoTitle;
    data['seoDescription'] = this.seoDescription;
    data['rowVersion'] = this.rowVersion;
    return data;
  }
}

export interface IUpdateWebsitePageRequest2 {
  websiteId: string;
  pageId: string;
  title: string;
  slug: string;
  isHomePage?: boolean;
  showInNavigation?: boolean;
  navigationOrder?: number;
  navigationLabel?: string | undefined;
  navigationParentPageId?: string | undefined;
  navigationOpenMode?: string | undefined;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  rowVersion?: string | undefined;
}

export class WebsitePageDraftDto implements IWebsitePageDraftDto {
  page?: WebsitePageSummaryDto;
  revision?: WebsitePageRevisionDto | undefined;
  content?: WebsiteContentDocumentDto | undefined;
  contentJson?: string | undefined;
  rowVersion?: string | undefined;

  constructor(data?: IWebsitePageDraftDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page']
        ? WebsitePageSummaryDto.fromJS(_data['page'])
        : <any>undefined;
      this.revision = _data['revision']
        ? WebsitePageRevisionDto.fromJS(_data['revision'])
        : <any>undefined;
      this.content = _data['content']
        ? WebsiteContentDocumentDto.fromJS(_data['content'])
        : <any>undefined;
      this.contentJson = _data['contentJson'];
      this.rowVersion = _data['rowVersion'];
    }
  }

  static fromJS(data: any): WebsitePageDraftDto {
    data = typeof data === 'object' ? data : {};
    let result = new WebsitePageDraftDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['page'] = this.page ? this.page.toJSON() : <any>undefined;
    data['revision'] = this.revision ? this.revision.toJSON() : <any>undefined;
    data['content'] = this.content ? this.content.toJSON() : <any>undefined;
    data['contentJson'] = this.contentJson;
    data['rowVersion'] = this.rowVersion;
    return data;
  }
}

export interface IWebsitePageDraftDto {
  page?: WebsitePageSummaryDto;
  revision?: WebsitePageRevisionDto | undefined;
  content?: WebsiteContentDocumentDto | undefined;
  contentJson?: string | undefined;
  rowVersion?: string | undefined;
}

export class WebsitePageRevisionDto implements IWebsitePageRevisionDto {
  id?: string;
  websitePageId?: string;
  revisionNumber?: number;
  schemaVersion?: number;
  contentJson?: string;
  status?: string;
  createdAt?: string;
  createdBy?: string;
  publishedAt?: string | undefined;
  publishedBy?: string | undefined;

  constructor(data?: IWebsitePageRevisionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.websitePageId = _data['websitePageId'];
      this.revisionNumber = _data['revisionNumber'];
      this.schemaVersion = _data['schemaVersion'];
      this.contentJson = _data['contentJson'];
      this.status = _data['status'];
      this.createdAt = _data['createdAt'];
      this.createdBy = _data['createdBy'];
      this.publishedAt = _data['publishedAt'];
      this.publishedBy = _data['publishedBy'];
    }
  }

  static fromJS(data: any): WebsitePageRevisionDto {
    data = typeof data === 'object' ? data : {};
    let result = new WebsitePageRevisionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['websitePageId'] = this.websitePageId;
    data['revisionNumber'] = this.revisionNumber;
    data['schemaVersion'] = this.schemaVersion;
    data['contentJson'] = this.contentJson;
    data['status'] = this.status;
    data['createdAt'] = this.createdAt;
    data['createdBy'] = this.createdBy;
    data['publishedAt'] = this.publishedAt;
    data['publishedBy'] = this.publishedBy;
    return data;
  }
}

export interface IWebsitePageRevisionDto {
  id?: string;
  websitePageId?: string;
  revisionNumber?: number;
  schemaVersion?: number;
  contentJson?: string;
  status?: string;
  createdAt?: string;
  createdBy?: string;
  publishedAt?: string | undefined;
  publishedBy?: string | undefined;
}

export class WebsiteContentDocumentDto implements IWebsiteContentDocumentDto {
  schemaVersion?: number;
  seo?: any | undefined;
  settings?: any | undefined;
  content?: { [key: string]: any } | undefined;
  root?: WebsiteBlockDto[];

  constructor(data?: IWebsiteContentDocumentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.schemaVersion = _data['schemaVersion'];
      this.seo = _data['seo'];
      this.settings = _data['settings'];
      if (_data['content']) {
        this.content = {};
        for (let key in _data['content']) {
          if (_data['content'].hasOwnProperty(key))
            this.content![key] = _data['content'][key];
        }
      }
      if (Array.isArray(_data['root'])) {
        this.root = [] as any;
        for (let item of _data['root'])
          this.root!.push(WebsiteBlockDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): WebsiteContentDocumentDto {
    data = typeof data === 'object' ? data : {};
    let result = new WebsiteContentDocumentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['schemaVersion'] = this.schemaVersion;
    data['seo'] = this.seo;
    data['settings'] = this.settings;
    if (this.content) {
      data['content'] = {};
      for (let key in this.content) {
        if (this.content.hasOwnProperty(key))
          data['content'][key] = this.content[key];
      }
    }
    if (Array.isArray(this.root)) {
      data['root'] = [];
      for (let item of this.root) data['root'].push(item.toJSON());
    }
    return data;
  }
}

export interface IWebsiteContentDocumentDto {
  schemaVersion?: number;
  seo?: any | undefined;
  settings?: any | undefined;
  content?: { [key: string]: any } | undefined;
  root?: WebsiteBlockDto[];
}

export class WebsiteBlockDto implements IWebsiteBlockDto {
  id?: string;
  contentKey?: string | undefined;
  type?: string;
  version?: number;
  props?: any | undefined;
  visibility?: any | undefined;
  children?: WebsiteBlockDto[];

  constructor(data?: IWebsiteBlockDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.contentKey = _data['contentKey'];
      this.type = _data['type'];
      this.version = _data['version'];
      this.props = _data['props'];
      this.visibility = _data['visibility'];
      if (Array.isArray(_data['children'])) {
        this.children = [] as any;
        for (let item of _data['children'])
          this.children!.push(WebsiteBlockDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): WebsiteBlockDto {
    data = typeof data === 'object' ? data : {};
    let result = new WebsiteBlockDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['contentKey'] = this.contentKey;
    data['type'] = this.type;
    data['version'] = this.version;
    data['props'] = this.props;
    data['visibility'] = this.visibility;
    if (Array.isArray(this.children)) {
      data['children'] = [];
      for (let item of this.children) data['children'].push(item.toJSON());
    }
    return data;
  }
}

export interface IWebsiteBlockDto {
  id?: string;
  contentKey?: string | undefined;
  type?: string;
  version?: number;
  props?: any | undefined;
  visibility?: any | undefined;
  children?: WebsiteBlockDto[];
}

export class SaveWebsitePageDraftRequest
  implements ISaveWebsitePageDraftRequest
{
  websiteId!: string;
  pageId!: string;
  title?: string | undefined;
  slug?: string | undefined;
  isHomePage?: boolean | undefined;
  showInNavigation?: boolean | undefined;
  navigationOrder?: number | undefined;
  navigationLabel?: string | undefined;
  navigationParentPageId?: string | undefined;
  navigationOpenMode?: string | undefined;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  content?: WebsiteContentDocumentDto | undefined;
  contentJson?: string | undefined;
  rowVersion?: string | undefined;

  constructor(data?: ISaveWebsitePageDraftRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.websiteId = _data['websiteId'];
      this.pageId = _data['pageId'];
      this.title = _data['title'];
      this.slug = _data['slug'];
      this.isHomePage = _data['isHomePage'];
      this.showInNavigation = _data['showInNavigation'];
      this.navigationOrder = _data['navigationOrder'];
      this.navigationLabel = _data['navigationLabel'];
      this.navigationParentPageId = _data['navigationParentPageId'];
      this.navigationOpenMode = _data['navigationOpenMode'];
      this.seoTitle = _data['seoTitle'];
      this.seoDescription = _data['seoDescription'];
      this.content = _data['content']
        ? WebsiteContentDocumentDto.fromJS(_data['content'])
        : <any>undefined;
      this.contentJson = _data['contentJson'];
      this.rowVersion = _data['rowVersion'];
    }
  }

  static fromJS(data: any): SaveWebsitePageDraftRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SaveWebsitePageDraftRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['websiteId'] = this.websiteId;
    data['pageId'] = this.pageId;
    data['title'] = this.title;
    data['slug'] = this.slug;
    data['isHomePage'] = this.isHomePage;
    data['showInNavigation'] = this.showInNavigation;
    data['navigationOrder'] = this.navigationOrder;
    data['navigationLabel'] = this.navigationLabel;
    data['navigationParentPageId'] = this.navigationParentPageId;
    data['navigationOpenMode'] = this.navigationOpenMode;
    data['seoTitle'] = this.seoTitle;
    data['seoDescription'] = this.seoDescription;
    data['content'] = this.content ? this.content.toJSON() : <any>undefined;
    data['contentJson'] = this.contentJson;
    data['rowVersion'] = this.rowVersion;
    return data;
  }
}

export interface ISaveWebsitePageDraftRequest {
  websiteId: string;
  pageId: string;
  title?: string | undefined;
  slug?: string | undefined;
  isHomePage?: boolean | undefined;
  showInNavigation?: boolean | undefined;
  navigationOrder?: number | undefined;
  navigationLabel?: string | undefined;
  navigationParentPageId?: string | undefined;
  navigationOpenMode?: string | undefined;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
  content?: WebsiteContentDocumentDto | undefined;
  contentJson?: string | undefined;
  rowVersion?: string | undefined;
}

export class PublishWebsitePageResultDto
  implements IPublishWebsitePageResultDto
{
  page?: WebsitePageSummaryDto;
  revision?: WebsitePageRevisionDto;
  rowVersion?: string | undefined;
  publicSlug?: string;
  canonicalPath?: string;

  constructor(data?: IPublishWebsitePageResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page']
        ? WebsitePageSummaryDto.fromJS(_data['page'])
        : <any>undefined;
      this.revision = _data['revision']
        ? WebsitePageRevisionDto.fromJS(_data['revision'])
        : <any>undefined;
      this.rowVersion = _data['rowVersion'];
      this.publicSlug = _data['publicSlug'];
      this.canonicalPath = _data['canonicalPath'];
    }
  }

  static fromJS(data: any): PublishWebsitePageResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublishWebsitePageResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['page'] = this.page ? this.page.toJSON() : <any>undefined;
    data['revision'] = this.revision ? this.revision.toJSON() : <any>undefined;
    data['rowVersion'] = this.rowVersion;
    data['publicSlug'] = this.publicSlug;
    data['canonicalPath'] = this.canonicalPath;
    return data;
  }
}

export interface IPublishWebsitePageResultDto {
  page?: WebsitePageSummaryDto;
  revision?: WebsitePageRevisionDto;
  rowVersion?: string | undefined;
  publicSlug?: string;
  canonicalPath?: string;
}

export class PublishWebsitePageRequest implements IPublishWebsitePageRequest {
  websiteId?: string;
  pageId?: string;
  rowVersion?: string | undefined;

  constructor(data?: IPublishWebsitePageRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.websiteId = _data['websiteId'];
      this.pageId = _data['pageId'];
      this.rowVersion = _data['rowVersion'];
    }
  }

  static fromJS(data: any): PublishWebsitePageRequest {
    data = typeof data === 'object' ? data : {};
    let result = new PublishWebsitePageRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['websiteId'] = this.websiteId;
    data['pageId'] = this.pageId;
    data['rowVersion'] = this.rowVersion;
    return data;
  }
}

export interface IPublishWebsitePageRequest {
  websiteId?: string;
  pageId?: string;
  rowVersion?: string | undefined;
}

export class PublicWebsiteResolvedPageDto
  implements IPublicWebsiteResolvedPageDto
{
  website?: PublicWebsiteDto;
  company?: PublicWebsiteCompanyDto | undefined;
  themeJson?: string | undefined;
  navigation?: PublicWebsiteNavigationItemDto[];
  publishedPages?: PublicWebsitePageDto[];
  page?: PublicWebsitePageDto;
  document?: WebsiteContentDocumentDto;
  contentJson?: string;
  schemaVersion?: number;
  revisionNumber?: number;

  constructor(data?: IPublicWebsiteResolvedPageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.website = _data['website']
        ? PublicWebsiteDto.fromJS(_data['website'])
        : <any>undefined;
      this.company = _data['company']
        ? PublicWebsiteCompanyDto.fromJS(_data['company'])
        : <any>undefined;
      this.themeJson = _data['themeJson'];
      if (Array.isArray(_data['navigation'])) {
        this.navigation = [] as any;
        for (let item of _data['navigation'])
          this.navigation!.push(PublicWebsiteNavigationItemDto.fromJS(item));
      }
      if (Array.isArray(_data['publishedPages'])) {
        this.publishedPages = [] as any;
        for (let item of _data['publishedPages'])
          this.publishedPages!.push(PublicWebsitePageDto.fromJS(item));
      }
      this.page = _data['page']
        ? PublicWebsitePageDto.fromJS(_data['page'])
        : <any>undefined;
      this.document = _data['document']
        ? WebsiteContentDocumentDto.fromJS(_data['document'])
        : <any>undefined;
      this.contentJson = _data['contentJson'];
      this.schemaVersion = _data['schemaVersion'];
      this.revisionNumber = _data['revisionNumber'];
    }
  }

  static fromJS(data: any): PublicWebsiteResolvedPageDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicWebsiteResolvedPageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['website'] = this.website ? this.website.toJSON() : <any>undefined;
    data['company'] = this.company ? this.company.toJSON() : <any>undefined;
    data['themeJson'] = this.themeJson;
    if (Array.isArray(this.navigation)) {
      data['navigation'] = [];
      for (let item of this.navigation) data['navigation'].push(item.toJSON());
    }
    if (Array.isArray(this.publishedPages)) {
      data['publishedPages'] = [];
      for (let item of this.publishedPages)
        data['publishedPages'].push(item.toJSON());
    }
    data['page'] = this.page ? this.page.toJSON() : <any>undefined;
    data['document'] = this.document ? this.document.toJSON() : <any>undefined;
    data['contentJson'] = this.contentJson;
    data['schemaVersion'] = this.schemaVersion;
    data['revisionNumber'] = this.revisionNumber;
    return data;
  }
}

export interface IPublicWebsiteResolvedPageDto {
  website?: PublicWebsiteDto;
  company?: PublicWebsiteCompanyDto | undefined;
  themeJson?: string | undefined;
  navigation?: PublicWebsiteNavigationItemDto[];
  publishedPages?: PublicWebsitePageDto[];
  page?: PublicWebsitePageDto;
  document?: WebsiteContentDocumentDto;
  contentJson?: string;
  schemaVersion?: number;
  revisionNumber?: number;
}

export class PublicWebsiteDto implements IPublicWebsiteDto {
  id?: string;
  name?: string;
  publicSlug?: string;
  themeJson?: string | undefined;

  constructor(data?: IPublicWebsiteDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.publicSlug = _data['publicSlug'];
      this.themeJson = _data['themeJson'];
    }
  }

  static fromJS(data: any): PublicWebsiteDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicWebsiteDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['publicSlug'] = this.publicSlug;
    data['themeJson'] = this.themeJson;
    return data;
  }
}

export interface IPublicWebsiteDto {
  id?: string;
  name?: string;
  publicSlug?: string;
  themeJson?: string | undefined;
}

export class PublicWebsiteCompanyDto implements IPublicWebsiteCompanyDto {
  companyName?: string | undefined;
  companySlogan?: string | undefined;
  city?: string | undefined;
  street?: string | undefined;
  postalCode?: string | undefined;
  email?: string | undefined;
  phoneNo?: string | undefined;
  websiteUrl?: string | undefined;
  logoPath?: string | undefined;

  constructor(data?: IPublicWebsiteCompanyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyName = _data['companyName'];
      this.companySlogan = _data['companySlogan'];
      this.city = _data['city'];
      this.street = _data['street'];
      this.postalCode = _data['postalCode'];
      this.email = _data['email'];
      this.phoneNo = _data['phoneNo'];
      this.websiteUrl = _data['websiteUrl'];
      this.logoPath = _data['logoPath'];
    }
  }

  static fromJS(data: any): PublicWebsiteCompanyDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicWebsiteCompanyDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['companyName'] = this.companyName;
    data['companySlogan'] = this.companySlogan;
    data['city'] = this.city;
    data['street'] = this.street;
    data['postalCode'] = this.postalCode;
    data['email'] = this.email;
    data['phoneNo'] = this.phoneNo;
    data['websiteUrl'] = this.websiteUrl;
    data['logoPath'] = this.logoPath;
    return data;
  }
}

export interface IPublicWebsiteCompanyDto {
  companyName?: string | undefined;
  companySlogan?: string | undefined;
  city?: string | undefined;
  street?: string | undefined;
  postalCode?: string | undefined;
  email?: string | undefined;
  phoneNo?: string | undefined;
  websiteUrl?: string | undefined;
  logoPath?: string | undefined;
}

export class PublicWebsiteNavigationItemDto
  implements IPublicWebsiteNavigationItemDto
{
  pageId?: string;
  title?: string;
  label?: string;
  slug?: string;
  path?: string;
  order?: number;
  openMode?: string;
  children?: PublicWebsiteNavigationItemDto[];

  constructor(data?: IPublicWebsiteNavigationItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pageId = _data['pageId'];
      this.title = _data['title'];
      this.label = _data['label'];
      this.slug = _data['slug'];
      this.path = _data['path'];
      this.order = _data['order'];
      this.openMode = _data['openMode'];
      if (Array.isArray(_data['children'])) {
        this.children = [] as any;
        for (let item of _data['children'])
          this.children!.push(PublicWebsiteNavigationItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PublicWebsiteNavigationItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicWebsiteNavigationItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['pageId'] = this.pageId;
    data['title'] = this.title;
    data['label'] = this.label;
    data['slug'] = this.slug;
    data['path'] = this.path;
    data['order'] = this.order;
    data['openMode'] = this.openMode;
    if (Array.isArray(this.children)) {
      data['children'] = [];
      for (let item of this.children) data['children'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPublicWebsiteNavigationItemDto {
  pageId?: string;
  title?: string;
  label?: string;
  slug?: string;
  path?: string;
  order?: number;
  openMode?: string;
  children?: PublicWebsiteNavigationItemDto[];
}

export class PublicWebsitePageDto implements IPublicWebsitePageDto {
  id?: string;
  archetype?: string;
  title?: string;
  slug?: string;
  path?: string;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;

  constructor(data?: IPublicWebsitePageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.archetype = _data['archetype'];
      this.title = _data['title'];
      this.slug = _data['slug'];
      this.path = _data['path'];
      this.seoTitle = _data['seoTitle'];
      this.seoDescription = _data['seoDescription'];
    }
  }

  static fromJS(data: any): PublicWebsitePageDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicWebsitePageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['archetype'] = this.archetype;
    data['title'] = this.title;
    data['slug'] = this.slug;
    data['path'] = this.path;
    data['seoTitle'] = this.seoTitle;
    data['seoDescription'] = this.seoDescription;
    return data;
  }
}

export interface IPublicWebsitePageDto {
  id?: string;
  archetype?: string;
  title?: string;
  slug?: string;
  path?: string;
  seoTitle?: string | undefined;
  seoDescription?: string | undefined;
}

export class CreateWebsiteContactSubmissionResponse
  implements ICreateWebsiteContactSubmissionResponse
{
  id?: string;
  createdAt?: string;

  constructor(data?: ICreateWebsiteContactSubmissionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.createdAt = _data['createdAt'];
    }
  }

  static fromJS(data: any): CreateWebsiteContactSubmissionResponse {
    data = typeof data === 'object' ? data : {};
    let result = new CreateWebsiteContactSubmissionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['createdAt'] = this.createdAt;
    return data;
  }
}

export interface ICreateWebsiteContactSubmissionResponse {
  id?: string;
  createdAt?: string;
}

export class CreateWebsiteContactSubmissionRequest
  implements ICreateWebsiteContactSubmissionRequest
{
  host?: string | undefined;
  publicSlug?: string | undefined;
  path?: string | undefined;
  formBlockId?: string | undefined;
  fullName!: string;
  email!: string;
  phone?: string | undefined;
  message!: string;
  honeypot?: string | undefined;

  constructor(data?: ICreateWebsiteContactSubmissionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.host = _data['host'];
      this.publicSlug = _data['publicSlug'];
      this.path = _data['path'];
      this.formBlockId = _data['formBlockId'];
      this.fullName = _data['fullName'];
      this.email = _data['email'];
      this.phone = _data['phone'];
      this.message = _data['message'];
      this.honeypot = _data['honeypot'];
    }
  }

  static fromJS(data: any): CreateWebsiteContactSubmissionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateWebsiteContactSubmissionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['host'] = this.host;
    data['publicSlug'] = this.publicSlug;
    data['path'] = this.path;
    data['formBlockId'] = this.formBlockId;
    data['fullName'] = this.fullName;
    data['email'] = this.email;
    data['phone'] = this.phone;
    data['message'] = this.message;
    data['honeypot'] = this.honeypot;
    return data;
  }
}

export interface ICreateWebsiteContactSubmissionRequest {
  host?: string | undefined;
  publicSlug?: string | undefined;
  path?: string | undefined;
  formBlockId?: string | undefined;
  fullName: string;
  email: string;
  phone?: string | undefined;
  message: string;
  honeypot?: string | undefined;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}
